/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.mu.logistic.api.AddressData', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CalculateData', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CalculationCoordinates', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CalculationDistanceItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CalculationRoutes', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CancelTaskByIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CancelTaskByIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CancellationReason', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CityItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CoordinateExpress', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CoordinatesClientData', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CoordinatesProducts', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CreateDeliveryItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CreateDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CreateDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CreateExpressRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.CreateExpressResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.DataCalculationDistance', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.DataUserPlatform', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.DeliveryCoordinates', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.DeliveryItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.EditDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.EditDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.EnterpriseGroup', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.EvidenceFilter', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.EvidenceItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ExpressService', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.FilterExpressList', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.FiltersToDelivery', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetAddressData', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetAddressGeolocation', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetAddressInGeologicRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetAddressInGeologicResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetAddressResultType', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCalculateRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCalculateResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCalculationDistanceRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCalculationDistanceResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCancellationRateRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCancellationRateResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCancellationTypesRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCancellationTypesResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCitiesRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetCitiesResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetExpressServicesRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetExpressServicesResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetExpressTaskHistoryRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetExpressTaskHistoryResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetOrderTypesRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetOrderTypesResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetPermissionsByUserIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetPermissionsByUserIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetRatebyTaskIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetRatebyTaskIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetResourcesByUserRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.GetResourcesByUserResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.Hits', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ItemHits', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ListCalculationDistanceRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ListCalculationDistanceResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.NearbyCity', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.OauthTokenRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.OauthTokenResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ObservationItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.OrderType', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.OrderTypeEnum', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PaginationDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PaginationDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PaymentInfo', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PaymentType', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PermissionItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.Products', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PropertiesToFilter', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PropertiesToFilterbyUser', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PutCreateServiceRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.PutCreateServiceResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.RateTaskbyIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.RateTaskbyIdResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ResourceItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.Resources', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.Schedule', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.Schedule.DayOfWeek', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ScheduleTime', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SearchItemsRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SearchItemsResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SegmentationType', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ServiceTypeEnum', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.ShardsItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SimplifiedCoordinates', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.SourceDeliveryIn', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.StatusInfoResponse', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.StatusInfoResponse.ErrorCode', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.StatusInfoResponse.StatusType', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.TaskContent', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.TaskHistory', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.TaskItem', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.TaskPlaceDelivery', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.TotalAddress', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.UserTaskByIdRequest', null, global);
goog.exportSymbol('proto.com.mu.logistic.api.UserTaskByIdResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CalculationRoutes = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CalculationRoutes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CalculationRoutes.displayName = 'proto.com.mu.logistic.api.CalculationRoutes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CalculationDistanceItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.CalculationDistanceItem.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.CalculationDistanceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CalculationDistanceItem.displayName = 'proto.com.mu.logistic.api.CalculationDistanceItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.Schedule = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.Schedule.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.Schedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.Schedule.displayName = 'proto.com.mu.logistic.api.Schedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ScheduleTime = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.ScheduleTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ScheduleTime.displayName = 'proto.com.mu.logistic.api.ScheduleTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.ListCalculationDistanceResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.ListCalculationDistanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ListCalculationDistanceResponse.displayName = 'proto.com.mu.logistic.api.ListCalculationDistanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CalculationCoordinates = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CalculationCoordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CalculationCoordinates.displayName = 'proto.com.mu.logistic.api.CalculationCoordinates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.ListCalculationDistanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ListCalculationDistanceRequest.displayName = 'proto.com.mu.logistic.api.ListCalculationDistanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CalculateData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.CalculateData.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.CalculateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CalculateData.displayName = 'proto.com.mu.logistic.api.CalculateData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCalculateResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCalculateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCalculateResponse.displayName = 'proto.com.mu.logistic.api.GetCalculateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.AddressData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.AddressData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.AddressData.displayName = 'proto.com.mu.logistic.api.AddressData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.SimplifiedCoordinates = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.SimplifiedCoordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.SimplifiedCoordinates.displayName = 'proto.com.mu.logistic.api.SimplifiedCoordinates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCalculateRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetCalculateRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCalculateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCalculateRequest.displayName = 'proto.com.mu.logistic.api.GetCalculateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.EditDeliveryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.EditDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.EditDeliveryResponse.displayName = 'proto.com.mu.logistic.api.EditDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.TotalAddress = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.TotalAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.TotalAddress.displayName = 'proto.com.mu.logistic.api.TotalAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.EditDeliveryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.EditDeliveryRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.EditDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.EditDeliveryRequest.displayName = 'proto.com.mu.logistic.api.EditDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PutCreateServiceResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.PutCreateServiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PutCreateServiceResponse.displayName = 'proto.com.mu.logistic.api.PutCreateServiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PutCreateServiceRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.PutCreateServiceRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.PutCreateServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PutCreateServiceRequest.displayName = 'proto.com.mu.logistic.api.PutCreateServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CreateDeliveryItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CreateDeliveryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CreateDeliveryItem.displayName = 'proto.com.mu.logistic.api.CreateDeliveryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CreateDeliveryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CreateDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CreateDeliveryResponse.displayName = 'proto.com.mu.logistic.api.CreateDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CoordinatesProducts = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CoordinatesProducts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CoordinatesProducts.displayName = 'proto.com.mu.logistic.api.CoordinatesProducts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CoordinatesClientData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CoordinatesClientData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CoordinatesClientData.displayName = 'proto.com.mu.logistic.api.CoordinatesClientData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.DeliveryCoordinates = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.DeliveryCoordinates.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.DeliveryCoordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.DeliveryCoordinates.displayName = 'proto.com.mu.logistic.api.DeliveryCoordinates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CreateDeliveryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.CreateDeliveryRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.CreateDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CreateDeliveryRequest.displayName = 'proto.com.mu.logistic.api.CreateDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.DataCalculationDistance = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.DataCalculationDistance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.DataCalculationDistance.displayName = 'proto.com.mu.logistic.api.DataCalculationDistance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCalculationDistanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCalculationDistanceResponse.displayName = 'proto.com.mu.logistic.api.GetCalculationDistanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetCalculationDistanceRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCalculationDistanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCalculationDistanceRequest.displayName = 'proto.com.mu.logistic.api.GetCalculationDistanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetAddressInGeologicRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetAddressInGeologicRequest.displayName = 'proto.com.mu.logistic.api.GetAddressInGeologicRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetAddressGeolocation = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetAddressGeolocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetAddressGeolocation.displayName = 'proto.com.mu.logistic.api.GetAddressGeolocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetAddressData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetAddressData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetAddressData.displayName = 'proto.com.mu.logistic.api.GetAddressData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetAddressInGeologicResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetAddressInGeologicResponse.displayName = 'proto.com.mu.logistic.api.GetAddressInGeologicResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.DeliveryItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.DeliveryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.DeliveryItem.displayName = 'proto.com.mu.logistic.api.DeliveryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.FiltersToDelivery = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.FiltersToDelivery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.FiltersToDelivery.displayName = 'proto.com.mu.logistic.api.FiltersToDelivery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PropertiesToFilter = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.PropertiesToFilter.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.PropertiesToFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PropertiesToFilter.displayName = 'proto.com.mu.logistic.api.PropertiesToFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.UserTaskByIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.UserTaskByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.UserTaskByIdRequest.displayName = 'proto.com.mu.logistic.api.UserTaskByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.UserTaskByIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.UserTaskByIdResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.UserTaskByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.UserTaskByIdResponse.displayName = 'proto.com.mu.logistic.api.UserTaskByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.OauthTokenRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.OauthTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.OauthTokenRequest.displayName = 'proto.com.mu.logistic.api.OauthTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.OauthTokenResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.OauthTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.OauthTokenResponse.displayName = 'proto.com.mu.logistic.api.OauthTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.EvidenceItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.EvidenceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.EvidenceItem.displayName = 'proto.com.mu.logistic.api.EvidenceItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.displayName = 'proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.EvidenceFilter = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.EvidenceFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.EvidenceFilter.displayName = 'proto.com.mu.logistic.api.EvidenceFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.displayName = 'proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.displayName = 'proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetRatebyTaskIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetRatebyTaskIdRequest.displayName = 'proto.com.mu.logistic.api.GetRatebyTaskIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetRatebyTaskIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetRatebyTaskIdResponse.displayName = 'proto.com.mu.logistic.api.GetRatebyTaskIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.RateTaskbyIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.RateTaskbyIdRequest.displayName = 'proto.com.mu.logistic.api.RateTaskbyIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.RateTaskbyIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.RateTaskbyIdResponse.displayName = 'proto.com.mu.logistic.api.RateTaskbyIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CancelTaskByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CancelTaskByIdRequest.displayName = 'proto.com.mu.logistic.api.CancelTaskByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CancelTaskByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CancelTaskByIdResponse.displayName = 'proto.com.mu.logistic.api.CancelTaskByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.SourceDeliveryIn = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.SourceDeliveryIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.SourceDeliveryIn.displayName = 'proto.com.mu.logistic.api.SourceDeliveryIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.Hits = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.Hits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.Hits.displayName = 'proto.com.mu.logistic.api.Hits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ItemHits = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.ItemHits.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.ItemHits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ItemHits.displayName = 'proto.com.mu.logistic.api.ItemHits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ShardsItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.ShardsItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ShardsItem.displayName = 'proto.com.mu.logistic.api.ShardsItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.SearchItemsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.SearchItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.SearchItemsRequest.displayName = 'proto.com.mu.logistic.api.SearchItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.SearchItemsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.SearchItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.SearchItemsResponse.displayName = 'proto.com.mu.logistic.api.SearchItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetResourcesByUserRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetResourcesByUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetResourcesByUserRequest.displayName = 'proto.com.mu.logistic.api.GetResourcesByUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ResourceItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.ResourceItem.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.ResourceItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ResourceItem.displayName = 'proto.com.mu.logistic.api.ResourceItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.EnterpriseGroup = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.EnterpriseGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.EnterpriseGroup.displayName = 'proto.com.mu.logistic.api.EnterpriseGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetResourcesByUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetResourcesByUserResponse.displayName = 'proto.com.mu.logistic.api.GetResourcesByUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.NearbyCity = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.NearbyCity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.NearbyCity.displayName = 'proto.com.mu.logistic.api.NearbyCity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CityItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.CityItem.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.CityItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CityItem.displayName = 'proto.com.mu.logistic.api.CityItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCitiesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCitiesRequest.displayName = 'proto.com.mu.logistic.api.GetCitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCitiesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetCitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCitiesResponse.displayName = 'proto.com.mu.logistic.api.GetCitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PermissionItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.PermissionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PermissionItem.displayName = 'proto.com.mu.logistic.api.PermissionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.PropertiesToFilterbyUser.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.PropertiesToFilterbyUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PropertiesToFilterbyUser.displayName = 'proto.com.mu.logistic.api.PropertiesToFilterbyUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetPermissionsByUserIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.displayName = 'proto.com.mu.logistic.api.GetPermissionsByUserIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetPermissionsByUserIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.displayName = 'proto.com.mu.logistic.api.GetPermissionsByUserIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.Products = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.Products, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.Products.displayName = 'proto.com.mu.logistic.api.Products';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.TaskPlaceDelivery = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.TaskPlaceDelivery.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.TaskPlaceDelivery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.TaskPlaceDelivery.displayName = 'proto.com.mu.logistic.api.TaskPlaceDelivery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.Resources = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.Resources, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.Resources.displayName = 'proto.com.mu.logistic.api.Resources';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.DataUserPlatform = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.DataUserPlatform, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.DataUserPlatform.displayName = 'proto.com.mu.logistic.api.DataUserPlatform';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ObservationItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.ObservationItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ObservationItem.displayName = 'proto.com.mu.logistic.api.ObservationItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.TaskItem = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.TaskItem.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.TaskItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.TaskItem.displayName = 'proto.com.mu.logistic.api.TaskItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.displayName = 'proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.displayName = 'proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CreateExpressRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.CreateExpressRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.CreateExpressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CreateExpressRequest.displayName = 'proto.com.mu.logistic.api.CreateExpressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CreateExpressResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CreateExpressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CreateExpressResponse.displayName = 'proto.com.mu.logistic.api.CreateExpressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CoordinateExpress = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CoordinateExpress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CoordinateExpress.displayName = 'proto.com.mu.logistic.api.CoordinateExpress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PaymentInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.PaymentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PaymentInfo.displayName = 'proto.com.mu.logistic.api.PaymentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetOrderTypesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetOrderTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetOrderTypesRequest.displayName = 'proto.com.mu.logistic.api.GetOrderTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetOrderTypesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetOrderTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetOrderTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetOrderTypesResponse.displayName = 'proto.com.mu.logistic.api.GetOrderTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.OrderType = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.OrderType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.OrderType.displayName = 'proto.com.mu.logistic.api.OrderType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetExpressTaskHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.displayName = 'proto.com.mu.logistic.api.GetExpressTaskHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetExpressTaskHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.displayName = 'proto.com.mu.logistic.api.GetExpressTaskHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.TaskHistory = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.TaskHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.TaskHistory.displayName = 'proto.com.mu.logistic.api.TaskHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.TaskContent = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.TaskContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.TaskContent.displayName = 'proto.com.mu.logistic.api.TaskContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.FilterExpressList = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.FilterExpressList.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.FilterExpressList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.FilterExpressList.displayName = 'proto.com.mu.logistic.api.FilterExpressList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.ExpressService = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.ExpressService, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.ExpressService.displayName = 'proto.com.mu.logistic.api.ExpressService';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.PaginationDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PaginationDeliveryRequest.displayName = 'proto.com.mu.logistic.api.PaginationDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.PaginationDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.PaginationDeliveryResponse.displayName = 'proto.com.mu.logistic.api.PaginationDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetExpressServicesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetExpressServicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetExpressServicesRequest.displayName = 'proto.com.mu.logistic.api.GetExpressServicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetExpressServicesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetExpressServicesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetExpressServicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetExpressServicesResponse.displayName = 'proto.com.mu.logistic.api.GetExpressServicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.displayName = 'proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.displayName = 'proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.StatusInfoResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.StatusInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.StatusInfoResponse.displayName = 'proto.com.mu.logistic.api.StatusInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCancellationTypesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCancellationTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCancellationTypesRequest.displayName = 'proto.com.mu.logistic.api.GetCancellationTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.CancellationReason = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.CancellationReason, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.CancellationReason.displayName = 'proto.com.mu.logistic.api.CancellationReason';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.logistic.api.GetCancellationTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCancellationTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCancellationTypesResponse.displayName = 'proto.com.mu.logistic.api.GetCancellationTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCancellationRateRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCancellationRateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCancellationRateRequest.displayName = 'proto.com.mu.logistic.api.GetCancellationRateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetCancellationRateResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetCancellationRateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetCancellationRateResponse.displayName = 'proto.com.mu.logistic.api.GetCancellationRateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.displayName = 'proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.displayName = 'proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.displayName = 'proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CalculationRoutes.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CalculationRoutes.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CalculationRoutes} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CalculationRoutes.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        duration: jspb.Message.getFieldWithDefault(msg, 1, 0),
        distance: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CalculationRoutes}
 */
proto.com.mu.logistic.api.CalculationRoutes.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CalculationRoutes();
  return proto.com.mu.logistic.api.CalculationRoutes.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CalculationRoutes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CalculationRoutes}
 */
proto.com.mu.logistic.api.CalculationRoutes.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDuration(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDistance(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CalculationRoutes.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CalculationRoutes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CalculationRoutes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CalculationRoutes.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional int32 duration = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationRoutes.prototype.getDuration = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationRoutes.prototype.setDuration = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 distance = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationRoutes.prototype.getDistance = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationRoutes.prototype.setDistance = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.CalculationDistanceItem.repeatedFields_ = [15];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CalculationDistanceItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CalculationDistanceItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CalculationDistanceItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CalculationDistanceItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        address: jspb.Message.getFieldWithDefault(msg, 1, ''),
        assigned: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
        pointsitemid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        cityid: jspb.Message.getFieldWithDefault(msg, 4, ''),
        nearbycityid: jspb.Message.getFieldWithDefault(msg, 5, 0),
        pointclientid: jspb.Message.getFieldWithDefault(msg, 6, ''),
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
        pointsitemname: jspb.Message.getFieldWithDefault(msg, 9, ''),
        namenearbycity: jspb.Message.getFieldWithDefault(msg, 10, ''),
        parking: jspb.Message.getFieldWithDefault(msg, 11, ''),
        phone: jspb.Message.getFieldWithDefault(msg, 12, ''),
        schedule: jspb.Message.getFieldWithDefault(msg, 13, ''),
        schedulejson: jspb.Message.getFieldWithDefault(msg, 14, ''),
        schedulestructuredList: jspb.Message.toObjectList(
          msg.getSchedulestructuredList(),
          proto.com.mu.logistic.api.Schedule.toObject,
          includeInstance
        ),
        pointsitemstatus: jspb.Message.getFieldWithDefault(msg, 16, ''),
        routes: (f = msg.getRoutes()) && proto.com.mu.logistic.api.CalculationRoutes.toObject(includeInstance, f),
        isschedule24x7: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CalculationDistanceItem}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CalculationDistanceItem();
  return proto.com.mu.logistic.api.CalculationDistanceItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CalculationDistanceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CalculationDistanceItem}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 2:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setAssigned(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setPointsitemid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityid(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setNearbycityid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setPointclientid(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setPointsitemname(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setNamenearbycity(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setParking(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setPhone(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setSchedule(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setSchedulejson(value);
        break;
      case 15:
        var value = new proto.com.mu.logistic.api.Schedule();
        reader.readMessage(value, proto.com.mu.logistic.api.Schedule.deserializeBinaryFromReader);
        msg.addSchedulestructured(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setPointsitemstatus(value);
        break;
      case 17:
        var value = new proto.com.mu.logistic.api.CalculationRoutes();
        reader.readMessage(value, proto.com.mu.logistic.api.CalculationRoutes.deserializeBinaryFromReader);
        msg.setRoutes(value);
        break;
      case 18:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsschedule24x7(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CalculationDistanceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CalculationDistanceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CalculationDistanceItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getAssigned();
  if (f) {
    writer.writeBool(2, f);
  }
  f = message.getPointsitemid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getCityid();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getNearbycityid();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getPointclientid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(7, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(8, f);
  }
  f = message.getPointsitemname();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getNamenearbycity();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getParking();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getSchedule();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getSchedulejson();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getSchedulestructuredList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(15, f, proto.com.mu.logistic.api.Schedule.serializeBinaryToWriter);
  }
  f = message.getPointsitemstatus();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getRoutes();
  if (f != null) {
    writer.writeMessage(17, f, proto.com.mu.logistic.api.CalculationRoutes.serializeBinaryToWriter);
  }
  f = message.getIsschedule24x7();
  if (f) {
    writer.writeBool(18, f);
  }
};

/**
 * optional string address = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional bool assigned = 2;
 * @return {boolean}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getAssigned = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setAssigned = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};

/**
 * optional string pointsItemId = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getPointsitemid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setPointsitemid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string cityId = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getCityid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setCityid = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 nearbyCityId = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getNearbycityid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setNearbycityid = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string pointClientId = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getPointclientid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setPointclientid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional double latitude = 7;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};

/**
 * optional double longitude = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};

/**
 * optional string pointsItemName = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getPointsitemname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setPointsitemname = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string nameNearbyCity = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getNamenearbycity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setNamenearbycity = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string parking = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getParking = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setParking = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string phone = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getPhone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setPhone = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string schedule = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getSchedule = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setSchedule = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string scheduleJson = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getSchedulejson = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setSchedulejson = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * repeated Schedule scheduleStructured = 15;
 * @return {!Array<!proto.com.mu.logistic.api.Schedule>}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getSchedulestructuredList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.Schedule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.Schedule, 15)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.Schedule>} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setSchedulestructuredList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 15, value);
};

/**
 * @param {!proto.com.mu.logistic.api.Schedule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.Schedule}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.addSchedulestructured = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.com.mu.logistic.api.Schedule, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.clearSchedulestructuredList = function () {
  this.setSchedulestructuredList([]);
};

/**
 * optional string pointsItemStatus = 16;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getPointsitemstatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setPointsitemstatus = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional CalculationRoutes routes = 17;
 * @return {?proto.com.mu.logistic.api.CalculationRoutes}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getRoutes = function () {
  return /** @type{?proto.com.mu.logistic.api.CalculationRoutes} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CalculationRoutes, 17)
  );
};

/** @param {?proto.com.mu.logistic.api.CalculationRoutes|undefined} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setRoutes = function (value) {
  jspb.Message.setWrapperField(this, 17, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.clearRoutes = function () {
  this.setRoutes(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.hasRoutes = function () {
  return jspb.Message.getField(this, 17) != null;
};

/**
 * optional bool isSchedule24x7 = 18;
 * @return {boolean}
 */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.getIsschedule24x7 = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.CalculationDistanceItem.prototype.setIsschedule24x7 = function (value) {
  jspb.Message.setProto3BooleanField(this, 18, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.Schedule.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.Schedule.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.Schedule.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.Schedule} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.Schedule.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        day: jspb.Message.getFieldWithDefault(msg, 1, 0),
        scheduletimeList: jspb.Message.toObjectList(
          msg.getScheduletimeList(),
          proto.com.mu.logistic.api.ScheduleTime.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.Schedule}
 */
proto.com.mu.logistic.api.Schedule.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.Schedule();
  return proto.com.mu.logistic.api.Schedule.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.Schedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.Schedule}
 */
proto.com.mu.logistic.api.Schedule.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!proto.com.mu.logistic.api.Schedule.DayOfWeek} */ (reader.readEnum());
        msg.setDay(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.ScheduleTime();
        reader.readMessage(value, proto.com.mu.logistic.api.ScheduleTime.deserializeBinaryFromReader);
        msg.addScheduletime(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.Schedule.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.Schedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.Schedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.Schedule.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDay();
  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
  f = message.getScheduletimeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.com.mu.logistic.api.ScheduleTime.serializeBinaryToWriter);
  }
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.Schedule.DayOfWeek = {
  UNKNOWN_DAYOFWEEK_TYPE: 0,
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURSDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7,
  HOLIDAY: 8,
};

/**
 * optional DayOfWeek day = 1;
 * @return {!proto.com.mu.logistic.api.Schedule.DayOfWeek}
 */
proto.com.mu.logistic.api.Schedule.prototype.getDay = function () {
  return /** @type {!proto.com.mu.logistic.api.Schedule.DayOfWeek} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {!proto.com.mu.logistic.api.Schedule.DayOfWeek} value */
proto.com.mu.logistic.api.Schedule.prototype.setDay = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};

/**
 * repeated ScheduleTime scheduleTime = 2;
 * @return {!Array<!proto.com.mu.logistic.api.ScheduleTime>}
 */
proto.com.mu.logistic.api.Schedule.prototype.getScheduletimeList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.ScheduleTime>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.ScheduleTime, 2)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.ScheduleTime>} value */
proto.com.mu.logistic.api.Schedule.prototype.setScheduletimeList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};

/**
 * @param {!proto.com.mu.logistic.api.ScheduleTime=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.ScheduleTime}
 */
proto.com.mu.logistic.api.Schedule.prototype.addScheduletime = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.mu.logistic.api.ScheduleTime, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.Schedule.prototype.clearScheduletimeList = function () {
  this.setScheduletimeList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ScheduleTime.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ScheduleTime.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ScheduleTime} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ScheduleTime.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        starttime: jspb.Message.getFieldWithDefault(msg, 1, 0),
        endtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ScheduleTime}
 */
proto.com.mu.logistic.api.ScheduleTime.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ScheduleTime();
  return proto.com.mu.logistic.api.ScheduleTime.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ScheduleTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ScheduleTime}
 */
proto.com.mu.logistic.api.ScheduleTime.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStarttime(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setEndtime(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ScheduleTime.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ScheduleTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ScheduleTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ScheduleTime.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStarttime();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional int32 startTime = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.ScheduleTime.prototype.getStarttime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ScheduleTime.prototype.setStarttime = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 endTime = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.ScheduleTime.prototype.getEndtime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ScheduleTime.prototype.setEndtime = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ListCalculationDistanceResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ListCalculationDistanceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ListCalculationDistanceResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        pointsList: jspb.Message.toObjectList(
          msg.getPointsList(),
          proto.com.mu.logistic.api.CalculationDistanceItem.toObject,
          includeInstance
        ),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ListCalculationDistanceResponse}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ListCalculationDistanceResponse();
  return proto.com.mu.logistic.api.ListCalculationDistanceResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ListCalculationDistanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ListCalculationDistanceResponse}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.CalculationDistanceItem();
        reader.readMessage(value, proto.com.mu.logistic.api.CalculationDistanceItem.deserializeBinaryFromReader);
        msg.addPoints(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ListCalculationDistanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ListCalculationDistanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.CalculationDistanceItem.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * repeated CalculationDistanceItem points = 1;
 * @return {!Array<!proto.com.mu.logistic.api.CalculationDistanceItem>}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.getPointsList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.CalculationDistanceItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.CalculationDistanceItem, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.CalculationDistanceItem>} value */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.setPointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.CalculationDistanceItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.CalculationDistanceItem}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.addPoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.CalculationDistanceItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.clearPointsList = function () {
  this.setPointsList([]);
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.ListCalculationDistanceResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CalculationCoordinates.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CalculationCoordinates.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CalculationCoordinates} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CalculationCoordinates.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CalculationCoordinates}
 */
proto.com.mu.logistic.api.CalculationCoordinates.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CalculationCoordinates();
  return proto.com.mu.logistic.api.CalculationCoordinates.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CalculationCoordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CalculationCoordinates}
 */
proto.com.mu.logistic.api.CalculationCoordinates.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CalculationCoordinates.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CalculationCoordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CalculationCoordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CalculationCoordinates.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
};

/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationCoordinates.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationCoordinates.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculationCoordinates.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculationCoordinates.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ListCalculationDistanceRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ListCalculationDistanceRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ListCalculationDistanceRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        companyid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        cityid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        userid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        admin: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
        coordinates: (f = msg.getCoordinates()) && proto.com.mu.logistic.api.CalculationCoordinates.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ListCalculationDistanceRequest}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ListCalculationDistanceRequest();
  return proto.com.mu.logistic.api.ListCalculationDistanceRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ListCalculationDistanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ListCalculationDistanceRequest}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setUserid(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setAdmin(value);
        break;
      case 5:
        var value = new proto.com.mu.logistic.api.CalculationCoordinates();
        reader.readMessage(value, proto.com.mu.logistic.api.CalculationCoordinates.deserializeBinaryFromReader);
        msg.setCoordinates(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ListCalculationDistanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ListCalculationDistanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getCityid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getAdmin();
  if (f) {
    writer.writeBool(4, f);
  }
  f = message.getCoordinates();
  if (f != null) {
    writer.writeMessage(5, f, proto.com.mu.logistic.api.CalculationCoordinates.serializeBinaryToWriter);
  }
};

/**
 * optional string companyId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.getCompanyid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.setCompanyid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string cityId = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.getCityid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.setCityid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string userId = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.getUserid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional bool admin = 4;
 * @return {boolean}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.getAdmin = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.setAdmin = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

/**
 * optional CalculationCoordinates coordinates = 5;
 * @return {?proto.com.mu.logistic.api.CalculationCoordinates}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.getCoordinates = function () {
  return /** @type{?proto.com.mu.logistic.api.CalculationCoordinates} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CalculationCoordinates, 5)
  );
};

/** @param {?proto.com.mu.logistic.api.CalculationCoordinates|undefined} value */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.setCoordinates = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.clearCoordinates = function () {
  this.setCoordinates(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.ListCalculationDistanceRequest.prototype.hasCoordinates = function () {
  return jspb.Message.getField(this, 5) != null;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.CalculateData.repeatedFields_ = [21];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CalculateData.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CalculateData.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CalculateData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CalculateData.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        basevalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        distancesurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
        surchargestops: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
        insurancesurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
        roundtripsurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
        totalservice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
        totaldistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
        totalsurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
        stops: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
        adddistancia: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
        surchargekm: jspb.Message.getFieldWithDefault(msg, 12, ''),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
        discountedvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
        totalservicesd: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
        codestatus: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
        othervalues: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
        surchargetime: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
        nightsurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
        parkingsurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
        addressdataList: jspb.Message.toObjectList(
          msg.getAddressdataList(),
          proto.com.mu.logistic.api.AddressData.toObject,
          includeInstance
        ),
        iva: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
        percentageiva: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
        nearbycitysurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
        percentageinsurance: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
        discounttype: jspb.Message.getFieldWithDefault(msg, 26, 0),
        codemessage: jspb.Message.getFieldWithDefault(msg, 27, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CalculateData}
 */
proto.com.mu.logistic.api.CalculateData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CalculateData();
  return proto.com.mu.logistic.api.CalculateData.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CalculateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CalculateData}
 */
proto.com.mu.logistic.api.CalculateData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setBasevalue(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDistancesurcharge(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setSurchargestops(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setInsurancesurcharge(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setRoundtripsurcharge(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalservice(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotaldistance(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalsurcharge(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setStops(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setAdddistancia(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setSurchargekm(value);
        break;
      case 13:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDiscountedvalue(value);
        break;
      case 15:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalservicesd(value);
        break;
      case 16:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setCodestatus(value);
        break;
      case 17:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setOthervalues(value);
        break;
      case 18:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setSurchargetime(value);
        break;
      case 19:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setNightsurcharge(value);
        break;
      case 20:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setParkingsurcharge(value);
        break;
      case 21:
        var value = new proto.com.mu.logistic.api.AddressData();
        reader.readMessage(value, proto.com.mu.logistic.api.AddressData.deserializeBinaryFromReader);
        msg.addAddressdata(value);
        break;
      case 22:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setIva(value);
        break;
      case 23:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setPercentageiva(value);
        break;
      case 24:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setNearbycitysurcharge(value);
        break;
      case 25:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setPercentageinsurance(value);
        break;
      case 26:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDiscounttype(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setCodemessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CalculateData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CalculateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CalculateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CalculateData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBasevalue();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getDistancesurcharge();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
  f = message.getSurchargestops();
  if (f !== 0.0) {
    writer.writeDouble(3, f);
  }
  f = message.getInsurancesurcharge();
  if (f !== 0.0) {
    writer.writeDouble(4, f);
  }
  f = message.getRoundtripsurcharge();
  if (f !== 0.0) {
    writer.writeDouble(5, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(6, f);
  }
  f = message.getTotalservice();
  if (f !== 0.0) {
    writer.writeDouble(7, f);
  }
  f = message.getTotaldistance();
  if (f !== 0.0) {
    writer.writeDouble(8, f);
  }
  f = message.getTotalsurcharge();
  if (f !== 0.0) {
    writer.writeDouble(9, f);
  }
  f = message.getStops();
  if (f !== 0.0) {
    writer.writeDouble(10, f);
  }
  f = message.getAdddistancia();
  if (f !== 0.0) {
    writer.writeDouble(11, f);
  }
  f = message.getSurchargekm();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(13, f);
  }
  f = message.getDiscountedvalue();
  if (f !== 0.0) {
    writer.writeDouble(14, f);
  }
  f = message.getTotalservicesd();
  if (f !== 0.0) {
    writer.writeDouble(15, f);
  }
  f = message.getCodestatus();
  if (f) {
    writer.writeBool(16, f);
  }
  f = message.getOthervalues();
  if (f !== 0.0) {
    writer.writeDouble(17, f);
  }
  f = message.getSurchargetime();
  if (f !== 0.0) {
    writer.writeDouble(18, f);
  }
  f = message.getNightsurcharge();
  if (f !== 0.0) {
    writer.writeDouble(19, f);
  }
  f = message.getParkingsurcharge();
  if (f !== 0.0) {
    writer.writeDouble(20, f);
  }
  f = message.getAddressdataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(21, f, proto.com.mu.logistic.api.AddressData.serializeBinaryToWriter);
  }
  f = message.getIva();
  if (f !== 0.0) {
    writer.writeDouble(22, f);
  }
  f = message.getPercentageiva();
  if (f !== 0.0) {
    writer.writeDouble(23, f);
  }
  f = message.getNearbycitysurcharge();
  if (f !== 0.0) {
    writer.writeDouble(24, f);
  }
  f = message.getPercentageinsurance();
  if (f !== 0.0) {
    writer.writeDouble(25, f);
  }
  f = message.getDiscounttype();
  if (f !== 0) {
    writer.writeInt32(26, f);
  }
  f = message.getCodemessage();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
};

/**
 * optional double baseValue = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getBasevalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setBasevalue = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional double distanceSurcharge = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getDistancesurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setDistancesurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

/**
 * optional double surchargeStops = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getSurchargestops = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setSurchargestops = function (value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};

/**
 * optional double insuranceSurcharge = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getInsurancesurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setInsurancesurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};

/**
 * optional double roundtripSurcharge = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getRoundtripsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setRoundtripsurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};

/**
 * optional double declaredValue = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};

/**
 * optional double totalService = 7;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getTotalservice = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setTotalservice = function (value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};

/**
 * optional double totalDistance = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getTotaldistance = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setTotaldistance = function (value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};

/**
 * optional double totalSurcharge = 9;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getTotalsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setTotalsurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};

/**
 * optional double stops = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getStops = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setStops = function (value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};

/**
 * optional double addDistancia = 11;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getAdddistancia = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setAdddistancia = function (value) {
  jspb.Message.setProto3FloatField(this, 11, value);
};

/**
 * optional string surchargeKM = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getSurchargekm = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculateData.prototype.setSurchargekm = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional bool roundtrip = 13;
 * @return {boolean}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.CalculateData.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};

/**
 * optional double discountedValue = 14;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getDiscountedvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setDiscountedvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 14, value);
};

/**
 * optional double totalServiceSd = 15;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getTotalservicesd = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setTotalservicesd = function (value) {
  jspb.Message.setProto3FloatField(this, 15, value);
};

/**
 * optional bool codeStatus = 16;
 * @return {boolean}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getCodestatus = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.CalculateData.prototype.setCodestatus = function (value) {
  jspb.Message.setProto3BooleanField(this, 16, value);
};

/**
 * optional double otherValues = 17;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getOthervalues = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setOthervalues = function (value) {
  jspb.Message.setProto3FloatField(this, 17, value);
};

/**
 * optional double surchargeTime = 18;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getSurchargetime = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setSurchargetime = function (value) {
  jspb.Message.setProto3FloatField(this, 18, value);
};

/**
 * optional double nightSurcharge = 19;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getNightsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setNightsurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 19, value);
};

/**
 * optional double parkingSurcharge = 20;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getParkingsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setParkingsurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};

/**
 * repeated AddressData addressData = 21;
 * @return {!Array<!proto.com.mu.logistic.api.AddressData>}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getAddressdataList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.AddressData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.AddressData, 21)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.AddressData>} value */
proto.com.mu.logistic.api.CalculateData.prototype.setAddressdataList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 21, value);
};

/**
 * @param {!proto.com.mu.logistic.api.AddressData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.AddressData}
 */
proto.com.mu.logistic.api.CalculateData.prototype.addAddressdata = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.com.mu.logistic.api.AddressData, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.CalculateData.prototype.clearAddressdataList = function () {
  this.setAddressdataList([]);
};

/**
 * optional double iva = 22;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getIva = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setIva = function (value) {
  jspb.Message.setProto3FloatField(this, 22, value);
};

/**
 * optional double percentageIva = 23;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getPercentageiva = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setPercentageiva = function (value) {
  jspb.Message.setProto3FloatField(this, 23, value);
};

/**
 * optional double nearbycitySurcharge = 24;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getNearbycitysurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setNearbycitysurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 24, value);
};

/**
 * optional double percentageInsurance = 25;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getPercentageinsurance = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setPercentageinsurance = function (value) {
  jspb.Message.setProto3FloatField(this, 25, value);
};

/**
 * optional int32 discountType = 26;
 * @return {number}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getDiscounttype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CalculateData.prototype.setDiscounttype = function (value) {
  jspb.Message.setProto3IntField(this, 26, value);
};

/**
 * optional string codeMessage = 27;
 * @return {string}
 */
proto.com.mu.logistic.api.CalculateData.prototype.getCodemessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CalculateData.prototype.setCodemessage = function (value) {
  jspb.Message.setProto3StringField(this, 27, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCalculateResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCalculateResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCalculateResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCalculateResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.CalculateData.toObject(includeInstance, f),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        status: jspb.Message.getFieldWithDefault(msg, 3, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 4, 0),
        version: jspb.Message.getFieldWithDefault(msg, 5, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCalculateResponse}
 */
proto.com.mu.logistic.api.GetCalculateResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCalculateResponse();
  return proto.com.mu.logistic.api.GetCalculateResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCalculateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCalculateResponse}
 */
proto.com.mu.logistic.api.GetCalculateResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.CalculateData();
        reader.readMessage(value, proto.com.mu.logistic.api.CalculateData.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatuscode(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCalculateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCalculateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCalculateResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.CalculateData.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatuscode();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional CalculateData data = 1;
 * @return {?proto.com.mu.logistic.api.CalculateData}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.CalculateData} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CalculateData, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.CalculateData|undefined} value */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string status = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 statusCode = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.getStatuscode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string version = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string apiMessage = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculateResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.AddressData.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.AddressData.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.AddressData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.AddressData.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        country: jspb.Message.getFieldWithDefault(msg, 2, ''),
        address: jspb.Message.getFieldWithDefault(msg, 3, ''),
        city: jspb.Message.getFieldWithDefault(msg, 4, ''),
        postcode: jspb.Message.getFieldWithDefault(msg, 5, ''),
        admin1: jspb.Message.getFieldWithDefault(msg, 6, ''),
        admin2: jspb.Message.getFieldWithDefault(msg, 7, ''),
        admin3: jspb.Message.getFieldWithDefault(msg, 8, ''),
        admin4: jspb.Message.getFieldWithDefault(msg, 9, ''),
        admin5: jspb.Message.getFieldWithDefault(msg, 10, ''),
        attribution: jspb.Message.getFieldWithDefault(msg, 11, ''),
        accuracy: jspb.Message.getFieldWithDefault(msg, 12, ''),
        commonname: jspb.Message.getFieldWithDefault(msg, 13, ''),
        clientaddress: jspb.Message.getFieldWithDefault(msg, 15, ''),
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.AddressData}
 */
proto.com.mu.logistic.api.AddressData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.AddressData();
  return proto.com.mu.logistic.api.AddressData.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.AddressData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.AddressData}
 */
proto.com.mu.logistic.api.AddressData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setPostcode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setAdmin1(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setAdmin2(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setAdmin3(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setAdmin4(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setAdmin5(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setAttribution(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccuracy(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setCommonname(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientaddress(value);
        break;
      case 16:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      case 17:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.AddressData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.AddressData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.AddressData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.AddressData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getPostcode();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getAdmin1();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getAdmin2();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getAdmin3();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getAdmin4();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getAdmin5();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getAttribution();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getAccuracy();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getCommonname();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getClientaddress();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(16, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(17, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.AddressData.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.AddressData.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string country = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getCountry = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setCountry = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string address = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string city = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string postcode = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getPostcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setPostcode = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string admin1 = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAdmin1 = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAdmin1 = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string admin2 = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAdmin2 = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAdmin2 = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string admin3 = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAdmin3 = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAdmin3 = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string admin4 = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAdmin4 = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAdmin4 = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string admin5 = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAdmin5 = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAdmin5 = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string attribution = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAttribution = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAttribution = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string accuracy = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getAccuracy = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setAccuracy = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string commonName = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getCommonname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setCommonname = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string clientAddress = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.AddressData.prototype.getClientaddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.AddressData.prototype.setClientaddress = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional double latitude = 16;
 * @return {number}
 */
proto.com.mu.logistic.api.AddressData.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.AddressData.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 16, value);
};

/**
 * optional double longitude = 17;
 * @return {number}
 */
proto.com.mu.logistic.api.AddressData.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.AddressData.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 17, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.SimplifiedCoordinates.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.SimplifiedCoordinates} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.SimplifiedCoordinates.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        address: jspb.Message.getFieldWithDefault(msg, 1, ''),
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
        city: jspb.Message.getFieldWithDefault(msg, 4, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.SimplifiedCoordinates}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.SimplifiedCoordinates();
  return proto.com.mu.logistic.api.SimplifiedCoordinates.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.SimplifiedCoordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.SimplifiedCoordinates}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.SimplifiedCoordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.SimplifiedCoordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(3, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
};

/**
 * optional string address = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};

/**
 * optional string city = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SimplifiedCoordinates.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetCalculateRequest.repeatedFields_ = [7];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCalculateRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCalculateRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCalculateRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCalculateRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        servicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
        city: jspb.Message.getFieldWithDefault(msg, 4, 0),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        promotionalcode: jspb.Message.getFieldWithDefault(msg, 6, ''),
        coordinatesList: jspb.Message.toObjectList(
          msg.getCoordinatesList(),
          proto.com.mu.logistic.api.SimplifiedCoordinates.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCalculateRequest}
 */
proto.com.mu.logistic.api.GetCalculateRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCalculateRequest();
  return proto.com.mu.logistic.api.GetCalculateRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCalculateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCalculateRequest}
 */
proto.com.mu.logistic.api.GetCalculateRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicetype(value);
        break;
      case 3:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCity(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setPromotionalcode(value);
        break;
      case 7:
        var value = new proto.com.mu.logistic.api.SimplifiedCoordinates();
        reader.readMessage(value, proto.com.mu.logistic.api.SimplifiedCoordinates.deserializeBinaryFromReader);
        msg.addCoordinates(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCalculateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCalculateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCalculateRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getServicetype();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(3, f);
  }
  f = message.getCity();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(5, f);
  }
  f = message.getPromotionalcode();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(7, f, proto.com.mu.logistic.api.SimplifiedCoordinates.serializeBinaryToWriter);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 serviceType = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getServicetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setServicetype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional bool roundTrip = 3;
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};

/**
 * optional int32 city = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getCity = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setCity = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional double declaredValue = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};

/**
 * optional string promotionalCode = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getPromotionalcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setPromotionalcode = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * repeated SimplifiedCoordinates coordinates = 7;
 * @return {!Array<!proto.com.mu.logistic.api.SimplifiedCoordinates>}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.getCoordinatesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.SimplifiedCoordinates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.SimplifiedCoordinates, 7)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.SimplifiedCoordinates>} value */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.setCoordinatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};

/**
 * @param {!proto.com.mu.logistic.api.SimplifiedCoordinates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.SimplifiedCoordinates}
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.addCoordinates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.com.mu.logistic.api.SimplifiedCoordinates, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetCalculateRequest.prototype.clearCoordinatesList = function () {
  this.setCoordinatesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.EditDeliveryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.EditDeliveryResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.EditDeliveryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.EditDeliveryResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: jspb.Message.getFieldWithDefault(msg, 1, ''),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        status: jspb.Message.getFieldWithDefault(msg, 3, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 4, 0),
        version: jspb.Message.getFieldWithDefault(msg, 5, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.EditDeliveryResponse}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.EditDeliveryResponse();
  return proto.com.mu.logistic.api.EditDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.EditDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.EditDeliveryResponse}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatuscode(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.EditDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.EditDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.EditDeliveryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatuscode();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional string data = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.getData = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.setData = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string status = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 statusCode = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.getStatuscode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string version = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string apiMessage = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.TotalAddress.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.TotalAddress.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.TotalAddress} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.TotalAddress.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        address: jspb.Message.getFieldWithDefault(msg, 1, ''),
        description: jspb.Message.getFieldWithDefault(msg, 2, ''),
        purchasevalue: jspb.Message.getFieldWithDefault(msg, 3, 0),
        clientname: jspb.Message.getFieldWithDefault(msg, 4, ''),
        clientphone: jspb.Message.getFieldWithDefault(msg, 5, ''),
        clientdocument: jspb.Message.getFieldWithDefault(msg, 6, ''),
        clientemail: jspb.Message.getFieldWithDefault(msg, 7, ''),
        paymenttype: jspb.Message.getFieldWithDefault(msg, 8, 0),
        productsvalue: jspb.Message.getFieldWithDefault(msg, 9, 0),
        deliveryvalue: jspb.Message.getFieldWithDefault(msg, 10, 0),
        orderid: jspb.Message.getFieldWithDefault(msg, 11, ''),
        latitude: jspb.Message.getFieldWithDefault(msg, 12, ''),
        longitude: jspb.Message.getFieldWithDefault(msg, 13, ''),
        city: jspb.Message.getFieldWithDefault(msg, 14, ''),
        statusid: jspb.Message.getFieldWithDefault(msg, 15, ''),
        typeid: jspb.Message.getFieldWithDefault(msg, 16, ''),
        id: jspb.Message.getFieldWithDefault(msg, 17, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.TotalAddress}
 */
proto.com.mu.logistic.api.TotalAddress.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.TotalAddress();
  return proto.com.mu.logistic.api.TotalAddress.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.TotalAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.TotalAddress}
 */
proto.com.mu.logistic.api.TotalAddress.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPurchasevalue(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientname(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientphone(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientdocument(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientemail(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPaymenttype(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setProductsvalue(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDeliveryvalue(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderid(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setLatitude(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongitude(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatusid(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setTypeid(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.TotalAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.TotalAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.TotalAddress.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getPurchasevalue();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getClientphone();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getClientdocument();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getClientemail();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getPaymenttype();
  if (f !== 0) {
    writer.writeInt32(8, f);
  }
  f = message.getProductsvalue();
  if (f !== 0) {
    writer.writeInt32(9, f);
  }
  f = message.getDeliveryvalue();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getLatitude();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getLongitude();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getStatusid();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getTypeid();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
};

/**
 * optional string address = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string description = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 purchaseValue = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getPurchasevalue = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setPurchasevalue = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string clientName = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getClientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setClientname = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string clientPhone = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getClientphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setClientphone = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string clientDocument = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getClientdocument = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setClientdocument = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string clientEmail = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getClientemail = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setClientemail = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional int32 paymentType = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getPaymenttype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setPaymenttype = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional int32 productsValue = 9;
 * @return {number}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getProductsvalue = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setProductsvalue = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * optional int32 deliveryValue = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getDeliveryvalue = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setDeliveryvalue = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional string orderId = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getOrderid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setOrderid = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string latitude = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getLatitude = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setLatitude = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string longitude = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getLongitude = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setLongitude = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string city = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string statusId = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getStatusid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setStatusid = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string typeId = 16;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getTypeid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setTypeid = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string id = 17;
 * @return {string}
 */
proto.com.mu.logistic.api.TotalAddress.prototype.getId = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TotalAddress.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.EditDeliveryRequest.repeatedFields_ = [17];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.EditDeliveryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.EditDeliveryRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.EditDeliveryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.EditDeliveryRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        taskid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        source: jspb.Message.getFieldWithDefault(msg, 3, 0),
        description: jspb.Message.getFieldWithDefault(msg, 4, ''),
        startdate: jspb.Message.getFieldWithDefault(msg, 5, ''),
        starttime: jspb.Message.getFieldWithDefault(msg, 6, ''),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
        extratime: jspb.Message.getFieldWithDefault(msg, 9, 0),
        applicant: jspb.Message.getFieldWithDefault(msg, 10, 0),
        paymenttype: jspb.Message.getFieldWithDefault(msg, 11, 0),
        segmentationtype: jspb.Message.getFieldWithDefault(msg, 12, 0),
        resourcetype: jspb.Message.getFieldWithDefault(msg, 13, 0),
        promotionalcode: jspb.Message.getFieldWithDefault(msg, 14, ''),
        verificationcode: jspb.Message.getFieldWithDefault(msg, 15, ''),
        parkingsurcharge: jspb.Message.getFieldWithDefault(msg, 16, 0),
        totaladdressList: jspb.Message.toObjectList(
          msg.getTotaladdressList(),
          proto.com.mu.logistic.api.TotalAddress.toObject,
          includeInstance
        ),
        tagsedit: jspb.Message.getFieldWithDefault(msg, 18, ''),
        ordertype: jspb.Message.getFieldWithDefault(msg, 19, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.EditDeliveryRequest}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.EditDeliveryRequest();
  return proto.com.mu.logistic.api.EditDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.EditDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.EditDeliveryRequest}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setSource(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 7:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setExtratime(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setApplicant(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPaymenttype(value);
        break;
      case 12:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setSegmentationtype(value);
        break;
      case 13:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setResourcetype(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setPromotionalcode(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setVerificationcode(value);
        break;
      case 16:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setParkingsurcharge(value);
        break;
      case 17:
        var value = new proto.com.mu.logistic.api.TotalAddress();
        reader.readMessage(value, proto.com.mu.logistic.api.TotalAddress.deserializeBinaryFromReader);
        msg.addTotaladdress(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setTagsedit(value);
        break;
      case 19:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOrdertype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.EditDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.EditDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.EditDeliveryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getSource();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(7, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(8, f);
  }
  f = message.getExtratime();
  if (f !== 0) {
    writer.writeInt32(9, f);
  }
  f = message.getApplicant();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
  f = message.getPaymenttype();
  if (f !== 0) {
    writer.writeInt32(11, f);
  }
  f = message.getSegmentationtype();
  if (f !== 0) {
    writer.writeInt32(12, f);
  }
  f = message.getResourcetype();
  if (f !== 0) {
    writer.writeInt32(13, f);
  }
  f = message.getPromotionalcode();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getVerificationcode();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getParkingsurcharge();
  if (f !== 0) {
    writer.writeInt32(16, f);
  }
  f = message.getTotaladdressList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(17, f, proto.com.mu.logistic.api.TotalAddress.serializeBinaryToWriter);
  }
  f = message.getTagsedit();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getOrdertype();
  if (f !== 0) {
    writer.writeInt32(19, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 taskId = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 source = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getSource = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setSource = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string description = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string startDate = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string startTime = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional bool roundTrip = 7;
 * @return {boolean}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};

/**
 * optional double declaredValue = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};

/**
 * optional int32 extraTime = 9;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getExtratime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setExtratime = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * optional int32 applicant = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getApplicant = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setApplicant = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional int32 paymentType = 11;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getPaymenttype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setPaymenttype = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional int32 segmentationType = 12;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getSegmentationtype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setSegmentationtype = function (value) {
  jspb.Message.setProto3IntField(this, 12, value);
};

/**
 * optional int32 resourceType = 13;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getResourcetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setResourcetype = function (value) {
  jspb.Message.setProto3IntField(this, 13, value);
};

/**
 * optional string promotionalCode = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getPromotionalcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setPromotionalcode = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string verificationCode = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getVerificationcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setVerificationcode = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional int32 parkingSurcharge = 16;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getParkingsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setParkingsurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 16, value);
};

/**
 * repeated TotalAddress totalAddress = 17;
 * @return {!Array<!proto.com.mu.logistic.api.TotalAddress>}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getTotaladdressList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.TotalAddress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.TotalAddress, 17)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.TotalAddress>} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setTotaladdressList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 17, value);
};

/**
 * @param {!proto.com.mu.logistic.api.TotalAddress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.TotalAddress}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.addTotaladdress = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.com.mu.logistic.api.TotalAddress, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.clearTotaladdressList = function () {
  this.setTotaladdressList([]);
};

/**
 * optional string tagsEdit = 18;
 * @return {string}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getTagsedit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setTagsedit = function (value) {
  jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional int32 orderType = 19;
 * @return {number}
 */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.getOrdertype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EditDeliveryRequest.prototype.setOrdertype = function (value) {
  jspb.Message.setProto3IntField(this, 19, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PutCreateServiceResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PutCreateServiceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PutCreateServiceResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.CreateDeliveryItem.toObject(includeInstance, f),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PutCreateServiceResponse}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PutCreateServiceResponse();
  return proto.com.mu.logistic.api.PutCreateServiceResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PutCreateServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PutCreateServiceResponse}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.CreateDeliveryItem();
        reader.readMessage(value, proto.com.mu.logistic.api.CreateDeliveryItem.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PutCreateServiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PutCreateServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.CreateDeliveryItem.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * optional CreateDeliveryItem data = 1;
 * @return {?proto.com.mu.logistic.api.CreateDeliveryItem}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.CreateDeliveryItem} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CreateDeliveryItem, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.CreateDeliveryItem|undefined} value */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.PutCreateServiceResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.repeatedFields_ = [13];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PutCreateServiceRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PutCreateServiceRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PutCreateServiceRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        servicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
        city: jspb.Message.getFieldWithDefault(msg, 5, 0),
        startdate: jspb.Message.getFieldWithDefault(msg, 6, ''),
        starttime: jspb.Message.getFieldWithDefault(msg, 7, ''),
        observation: jspb.Message.getFieldWithDefault(msg, 8, ''),
        userpaymenttype: jspb.Message.getFieldWithDefault(msg, 9, ''),
        typetaskcargoid: jspb.Message.getFieldWithDefault(msg, 10, 0),
        typesegmentation: jspb.Message.getFieldWithDefault(msg, 11, 0),
        os: jspb.Message.getFieldWithDefault(msg, 12, ''),
        coordinatesList: jspb.Message.toObjectList(
          msg.getCoordinatesList(),
          proto.com.mu.logistic.api.DeliveryCoordinates.toObject,
          includeInstance
        ),
        ordertype: jspb.Message.getFieldWithDefault(msg, 14, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PutCreateServiceRequest}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PutCreateServiceRequest();
  return proto.com.mu.logistic.api.PutCreateServiceRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PutCreateServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PutCreateServiceRequest}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicetype(value);
        break;
      case 3:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCity(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setObservation(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setUserpaymenttype(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypetaskcargoid(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypesegmentation(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setOs(value);
        break;
      case 13:
        var value = new proto.com.mu.logistic.api.DeliveryCoordinates();
        reader.readMessage(value, proto.com.mu.logistic.api.DeliveryCoordinates.deserializeBinaryFromReader);
        msg.addCoordinates(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOrdertype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PutCreateServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PutCreateServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getServicetype();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(3, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(4, f);
  }
  f = message.getCity();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getObservation();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getUserpaymenttype();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getTypetaskcargoid();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
  f = message.getTypesegmentation();
  if (f !== 0) {
    writer.writeInt32(11, f);
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(13, f, proto.com.mu.logistic.api.DeliveryCoordinates.serializeBinaryToWriter);
  }
  f = message.getOrdertype();
  if (f !== 0) {
    writer.writeInt32(14, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 serviceType = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getServicetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setServicetype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional bool roundTrip = 3;
 * @return {boolean}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};

/**
 * optional double declaredValue = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};

/**
 * optional int32 city = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getCity = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setCity = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string startDate = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string startTime = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string observation = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getObservation = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setObservation = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string userPaymentType = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getUserpaymenttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setUserpaymenttype = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional int32 typeTaskCargoId = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getTypetaskcargoid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setTypetaskcargoid = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional int32 typeSegmentation = 11;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getTypesegmentation = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setTypesegmentation = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional string os = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getOs = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setOs = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * repeated DeliveryCoordinates coordinates = 13;
 * @return {!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getCoordinatesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.DeliveryCoordinates, 13)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setCoordinatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};

/**
 * @param {!proto.com.mu.logistic.api.DeliveryCoordinates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.DeliveryCoordinates}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.addCoordinates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.com.mu.logistic.api.DeliveryCoordinates, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.clearCoordinatesList = function () {
  this.setCoordinatesList([]);
};

/**
 * optional int32 orderType = 14;
 * @return {number}
 */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.getOrdertype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PutCreateServiceRequest.prototype.setOrdertype = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CreateDeliveryItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CreateDeliveryItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CreateDeliveryItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CreateDeliveryItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        uuid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        status: jspb.Message.getFieldWithDefault(msg, 2, 0),
        total: jspb.Message.getFieldWithDefault(msg, 3, 0),
        date: jspb.Message.getFieldWithDefault(msg, 4, ''),
        distance: jspb.Message.getFieldWithDefault(msg, 5, 0),
        error: jspb.Message.getFieldWithDefault(msg, 6, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CreateDeliveryItem}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CreateDeliveryItem();
  return proto.com.mu.logistic.api.CreateDeliveryItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CreateDeliveryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CreateDeliveryItem}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setUuid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatus(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotal(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setDate(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDistance(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setError(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CreateDeliveryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CreateDeliveryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CreateDeliveryItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getError();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
};

/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.setUuid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int32 status = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.getStatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.setStatus = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.getTotal = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.setTotal = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string date = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.getDate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.setDate = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 distance = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.getDistance = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.setDistance = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional int32 error = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.getError = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryItem.prototype.setError = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CreateDeliveryResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CreateDeliveryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CreateDeliveryResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.CreateDeliveryItem.toObject(includeInstance, f),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        status: jspb.Message.getFieldWithDefault(msg, 3, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 4, 0),
        version: jspb.Message.getFieldWithDefault(msg, 5, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CreateDeliveryResponse}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CreateDeliveryResponse();
  return proto.com.mu.logistic.api.CreateDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CreateDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CreateDeliveryResponse}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.CreateDeliveryItem();
        reader.readMessage(value, proto.com.mu.logistic.api.CreateDeliveryItem.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatuscode(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CreateDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CreateDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.CreateDeliveryItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatuscode();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional CreateDeliveryItem data = 1;
 * @return {?proto.com.mu.logistic.api.CreateDeliveryItem}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.CreateDeliveryItem} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CreateDeliveryItem, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.CreateDeliveryItem|undefined} value */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string status = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 statusCode = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.getStatuscode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string version = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string apiMessage = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CoordinatesProducts.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CoordinatesProducts.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CoordinatesProducts} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CoordinatesProducts.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        storeid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        sku: jspb.Message.getFieldWithDefault(msg, 2, ''),
        productname: jspb.Message.getFieldWithDefault(msg, 3, ''),
        urlimg: jspb.Message.getFieldWithDefault(msg, 4, ''),
        value: jspb.Message.getFieldWithDefault(msg, 5, 0),
        quantity: jspb.Message.getFieldWithDefault(msg, 6, 0),
        idpoint: jspb.Message.getFieldWithDefault(msg, 7, ''),
        barcode: jspb.Message.getFieldWithDefault(msg, 8, ''),
        planogram: jspb.Message.getFieldWithDefault(msg, 9, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CoordinatesProducts}
 */
proto.com.mu.logistic.api.CoordinatesProducts.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CoordinatesProducts();
  return proto.com.mu.logistic.api.CoordinatesProducts.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CoordinatesProducts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CoordinatesProducts}
 */
proto.com.mu.logistic.api.CoordinatesProducts.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setStoreid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setSku(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setProductname(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setUrlimg(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setValue(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setQuantity(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setIdpoint(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setBarcode(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlanogram(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CoordinatesProducts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CoordinatesProducts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CoordinatesProducts.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStoreid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getProductname();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getUrlimg();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getIdpoint();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getBarcode();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getPlanogram();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
};

/**
 * optional string storeId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getStoreid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setStoreid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string sku = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getSku = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setSku = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string productName = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getProductname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setProductname = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string urlImg = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getUrlimg = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setUrlimg = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 value = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getValue = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setValue = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional int32 quantity = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getQuantity = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setQuantity = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional string idPoint = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getIdpoint = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setIdpoint = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string barcode = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getBarcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setBarcode = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string planogram = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.getPlanogram = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesProducts.prototype.setPlanogram = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CoordinatesClientData.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CoordinatesClientData.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CoordinatesClientData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CoordinatesClientData.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        clientname: jspb.Message.getFieldWithDefault(msg, 1, ''),
        clientphone: jspb.Message.getFieldWithDefault(msg, 2, ''),
        clientemail: jspb.Message.getFieldWithDefault(msg, 3, ''),
        productsvalue: jspb.Message.getFieldWithDefault(msg, 4, ''),
        deliveryvalue: jspb.Message.getFieldWithDefault(msg, 5, ''),
        clientdocument: jspb.Message.getFieldWithDefault(msg, 6, ''),
        paymenttype: jspb.Message.getFieldWithDefault(msg, 7, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CoordinatesClientData}
 */
proto.com.mu.logistic.api.CoordinatesClientData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CoordinatesClientData();
  return proto.com.mu.logistic.api.CoordinatesClientData.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CoordinatesClientData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CoordinatesClientData}
 */
proto.com.mu.logistic.api.CoordinatesClientData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientname(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientphone(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientemail(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setProductsvalue(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setDeliveryvalue(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientdocument(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymenttype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CoordinatesClientData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CoordinatesClientData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CoordinatesClientData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getClientphone();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getClientemail();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getProductsvalue();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getDeliveryvalue();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getClientdocument();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getPaymenttype();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
};

/**
 * optional string clientName = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getClientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setClientname = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string clientPhone = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getClientphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setClientphone = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string clientEmail = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getClientemail = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setClientemail = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string productsValue = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getProductsvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setProductsvalue = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string deliveryValue = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getDeliveryvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setDeliveryvalue = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string clientDocument = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getClientdocument = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setClientdocument = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string paymentType = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.getPaymenttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinatesClientData.prototype.setPaymenttype = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.DeliveryCoordinates.repeatedFields_ = [11];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.DeliveryCoordinates.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.DeliveryCoordinates.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.DeliveryCoordinates} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.DeliveryCoordinates.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        type: jspb.Message.getFieldWithDefault(msg, 1, ''),
        pointid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        orderid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        address: jspb.Message.getFieldWithDefault(msg, 4, ''),
        latitude: jspb.Message.getFieldWithDefault(msg, 5, ''),
        longitude: jspb.Message.getFieldWithDefault(msg, 6, ''),
        city: jspb.Message.getFieldWithDefault(msg, 7, ''),
        token: jspb.Message.getFieldWithDefault(msg, 8, ''),
        description: jspb.Message.getFieldWithDefault(msg, 9, ''),
        clientdata: (f = msg.getClientdata()) && proto.com.mu.logistic.api.CoordinatesClientData.toObject(includeInstance, f),
        productsList: jspb.Message.toObjectList(
          msg.getProductsList(),
          proto.com.mu.logistic.api.CoordinatesProducts.toObject,
          includeInstance
        ),
        storeid: jspb.Message.getFieldWithDefault(msg, 12, ''),
        statusid: jspb.Message.getFieldWithDefault(msg, 13, ''),
        typeid: jspb.Message.getFieldWithDefault(msg, 14, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.DeliveryCoordinates}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.DeliveryCoordinates();
  return proto.com.mu.logistic.api.DeliveryCoordinates.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.DeliveryCoordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.DeliveryCoordinates}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setPointid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setLatitude(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongitude(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setToken(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 10:
        var value = new proto.com.mu.logistic.api.CoordinatesClientData();
        reader.readMessage(value, proto.com.mu.logistic.api.CoordinatesClientData.deserializeBinaryFromReader);
        msg.setClientdata(value);
        break;
      case 11:
        var value = new proto.com.mu.logistic.api.CoordinatesProducts();
        reader.readMessage(value, proto.com.mu.logistic.api.CoordinatesProducts.deserializeBinaryFromReader);
        msg.addProducts(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setStoreid(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatusid(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setTypeid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.DeliveryCoordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.DeliveryCoordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.DeliveryCoordinates.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getPointid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getLatitude();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getLongitude();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getClientdata();
  if (f != null) {
    writer.writeMessage(10, f, proto.com.mu.logistic.api.CoordinatesClientData.serializeBinaryToWriter);
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(11, f, proto.com.mu.logistic.api.CoordinatesProducts.serializeBinaryToWriter);
  }
  f = message.getStoreid();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getStatusid();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getTypeid();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
};

/**
 * optional string type = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setType = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string pointId = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getPointid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setPointid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string orderId = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getOrderid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setOrderid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string address = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string latitude = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getLatitude = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setLatitude = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string longitude = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getLongitude = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setLongitude = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string city = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string token = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getToken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setToken = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string description = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional CoordinatesClientData clientData = 10;
 * @return {?proto.com.mu.logistic.api.CoordinatesClientData}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getClientdata = function () {
  return /** @type{?proto.com.mu.logistic.api.CoordinatesClientData} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CoordinatesClientData, 10)
  );
};

/** @param {?proto.com.mu.logistic.api.CoordinatesClientData|undefined} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setClientdata = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.clearClientdata = function () {
  this.setClientdata(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.hasClientdata = function () {
  return jspb.Message.getField(this, 10) != null;
};

/**
 * repeated CoordinatesProducts products = 11;
 * @return {!Array<!proto.com.mu.logistic.api.CoordinatesProducts>}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getProductsList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.CoordinatesProducts>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.CoordinatesProducts, 11)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.CoordinatesProducts>} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setProductsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 11, value);
};

/**
 * @param {!proto.com.mu.logistic.api.CoordinatesProducts=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.CoordinatesProducts}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.addProducts = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.com.mu.logistic.api.CoordinatesProducts, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.clearProductsList = function () {
  this.setProductsList([]);
};

/**
 * optional string storeId = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getStoreid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setStoreid = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string statusId = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getStatusid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setStatusid = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string typeId = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.getTypeid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryCoordinates.prototype.setTypeid = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.repeatedFields_ = [13];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CreateDeliveryRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CreateDeliveryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CreateDeliveryRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        servicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
        declaredvalue: jspb.Message.getFieldWithDefault(msg, 4, 0),
        city: jspb.Message.getFieldWithDefault(msg, 5, 0),
        startdate: jspb.Message.getFieldWithDefault(msg, 6, ''),
        starttime: jspb.Message.getFieldWithDefault(msg, 7, ''),
        observation: jspb.Message.getFieldWithDefault(msg, 8, ''),
        userpaymenttype: jspb.Message.getFieldWithDefault(msg, 9, ''),
        typetaskcargoid: jspb.Message.getFieldWithDefault(msg, 10, 0),
        typesegmentation: jspb.Message.getFieldWithDefault(msg, 11, 0),
        os: jspb.Message.getFieldWithDefault(msg, 12, ''),
        coordinatesList: jspb.Message.toObjectList(
          msg.getCoordinatesList(),
          proto.com.mu.logistic.api.DeliveryCoordinates.toObject,
          includeInstance
        ),
        ordertype: jspb.Message.getFieldWithDefault(msg, 14, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CreateDeliveryRequest}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CreateDeliveryRequest();
  return proto.com.mu.logistic.api.CreateDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CreateDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CreateDeliveryRequest}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicetype(value);
        break;
      case 3:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDeclaredvalue(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCity(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setObservation(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setUserpaymenttype(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypetaskcargoid(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypesegmentation(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setOs(value);
        break;
      case 13:
        var value = new proto.com.mu.logistic.api.DeliveryCoordinates();
        reader.readMessage(value, proto.com.mu.logistic.api.DeliveryCoordinates.deserializeBinaryFromReader);
        msg.addCoordinates(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOrdertype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CreateDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CreateDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getServicetype();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(3, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getCity();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getObservation();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getUserpaymenttype();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getTypetaskcargoid();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
  f = message.getTypesegmentation();
  if (f !== 0) {
    writer.writeInt32(11, f);
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(13, f, proto.com.mu.logistic.api.DeliveryCoordinates.serializeBinaryToWriter);
  }
  f = message.getOrdertype();
  if (f !== 0) {
    writer.writeInt32(14, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 serviceType = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getServicetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setServicetype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional bool roundTrip = 3;
 * @return {boolean}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};

/**
 * optional int32 declaredValue = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional int32 city = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getCity = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setCity = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string startDate = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string startTime = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string observation = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getObservation = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setObservation = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string userPaymentType = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getUserpaymenttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setUserpaymenttype = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional int32 typeTaskCargoId = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getTypetaskcargoid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setTypetaskcargoid = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional int32 typeSegmentation = 11;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getTypesegmentation = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setTypesegmentation = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional string os = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getOs = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setOs = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * repeated DeliveryCoordinates coordinates = 13;
 * @return {!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getCoordinatesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.DeliveryCoordinates, 13)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setCoordinatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};

/**
 * @param {!proto.com.mu.logistic.api.DeliveryCoordinates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.DeliveryCoordinates}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.addCoordinates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.com.mu.logistic.api.DeliveryCoordinates, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.clearCoordinatesList = function () {
  this.setCoordinatesList([]);
};

/**
 * optional int32 orderType = 14;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.getOrdertype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateDeliveryRequest.prototype.setOrdertype = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.DataCalculationDistance.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.DataCalculationDistance.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.DataCalculationDistance} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.DataCalculationDistance.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        basevalue: jspb.Message.getFieldWithDefault(msg, 1, 0),
        distancesurcharge: jspb.Message.getFieldWithDefault(msg, 2, 0),
        surchargestops: jspb.Message.getFieldWithDefault(msg, 3, 0),
        insurancesurcharge: jspb.Message.getFieldWithDefault(msg, 4, 0),
        roundtripsurcharge: jspb.Message.getFieldWithDefault(msg, 5, 0),
        totalservice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
        totaldistance: jspb.Message.getFieldWithDefault(msg, 7, 0),
        totalsurcharge: jspb.Message.getFieldWithDefault(msg, 8, 0),
        stops: jspb.Message.getFieldWithDefault(msg, 9, 0),
        distance: jspb.Message.getFieldWithDefault(msg, 10, 0),
        surchargekm: jspb.Message.getFieldWithDefault(msg, 11, ''),
        roundtrip: jspb.Message.getFieldWithDefault(msg, 12, 0),
        nightsurcharge: jspb.Message.getFieldWithDefault(msg, 13, 0),
        parkingsurcharge: jspb.Message.getFieldWithDefault(msg, 14, 0),
        iva: jspb.Message.getFieldWithDefault(msg, 15, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.DataCalculationDistance}
 */
proto.com.mu.logistic.api.DataCalculationDistance.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.DataCalculationDistance();
  return proto.com.mu.logistic.api.DataCalculationDistance.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.DataCalculationDistance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.DataCalculationDistance}
 */
proto.com.mu.logistic.api.DataCalculationDistance.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setBasevalue(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setDistancesurcharge(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setSurchargestops(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setInsurancesurcharge(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setRoundtripsurcharge(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalservice(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotaldistance(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setTotalsurcharge(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStops(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDistance(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setSurchargekm(value);
        break;
      case 12:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRoundtrip(value);
        break;
      case 13:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setNightsurcharge(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setParkingsurcharge(value);
        break;
      case 15:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setIva(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.DataCalculationDistance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.DataCalculationDistance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.DataCalculationDistance.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBasevalue();
  if (f !== 0) {
    writer.writeInt64(1, f);
  }
  f = message.getDistancesurcharge();
  if (f !== 0) {
    writer.writeInt64(2, f);
  }
  f = message.getSurchargestops();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getInsurancesurcharge();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getRoundtripsurcharge();
  if (f !== 0) {
    writer.writeInt64(5, f);
  }
  f = message.getTotalservice();
  if (f !== 0.0) {
    writer.writeDouble(6, f);
  }
  f = message.getTotaldistance();
  if (f !== 0) {
    writer.writeInt32(7, f);
  }
  f = message.getTotalsurcharge();
  if (f !== 0) {
    writer.writeInt64(8, f);
  }
  f = message.getStops();
  if (f !== 0) {
    writer.writeInt32(9, f);
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
  f = message.getSurchargekm();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getRoundtrip();
  if (f !== 0) {
    writer.writeInt32(12, f);
  }
  f = message.getNightsurcharge();
  if (f !== 0) {
    writer.writeInt32(13, f);
  }
  f = message.getParkingsurcharge();
  if (f !== 0) {
    writer.writeInt32(14, f);
  }
  f = message.getIva();
  if (f !== 0) {
    writer.writeInt32(15, f);
  }
};

/**
 * optional int64 baseValue = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getBasevalue = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setBasevalue = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int64 distanceSurcharge = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getDistancesurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setDistancesurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 surchargeStops = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getSurchargestops = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setSurchargestops = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional int32 insuranceSurcharge = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getInsurancesurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setInsurancesurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional int64 roundtripSurcharge = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getRoundtripsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setRoundtripsurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional double totalService = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getTotalservice = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setTotalservice = function (value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};

/**
 * optional int32 totalDistance = 7;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getTotaldistance = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setTotaldistance = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional int64 totalSurcharge = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getTotalsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setTotalsurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional int32 stops = 9;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getStops = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setStops = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * optional int32 distance = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getDistance = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setDistance = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional string surchargeKm = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getSurchargekm = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setSurchargekm = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional int32 roundtrip = 12;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getRoundtrip = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3IntField(this, 12, value);
};

/**
 * optional int32 nightSurcharge = 13;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getNightsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setNightsurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 13, value);
};

/**
 * optional int32 parkingSurcharge = 14;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getParkingsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setParkingsurcharge = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};

/**
 * optional int32 iva = 15;
 * @return {number}
 */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.getIva = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataCalculationDistance.prototype.setIva = function (value) {
  jspb.Message.setProto3IntField(this, 15, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCalculationDistanceResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCalculationDistanceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCalculationDistanceResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.DataCalculationDistance.toObject(includeInstance, f),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCalculationDistanceResponse}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCalculationDistanceResponse();
  return proto.com.mu.logistic.api.GetCalculationDistanceResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCalculationDistanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCalculationDistanceResponse}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.DataCalculationDistance();
        reader.readMessage(value, proto.com.mu.logistic.api.DataCalculationDistance.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCalculationDistanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCalculationDistanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.DataCalculationDistance.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * optional DataCalculationDistance data = 1;
 * @return {?proto.com.mu.logistic.api.DataCalculationDistance}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.DataCalculationDistance} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.DataCalculationDistance, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.DataCalculationDistance|undefined} value */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCalculationDistanceResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.repeatedFields_ = [9];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCalculationDistanceRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCalculationDistanceRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCalculationDistanceRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        servicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
        city: jspb.Message.getFieldWithDefault(msg, 5, 0),
        startdate: jspb.Message.getFieldWithDefault(msg, 6, ''),
        starttime: jspb.Message.getFieldWithDefault(msg, 7, ''),
        ordertype: jspb.Message.getFieldWithDefault(msg, 8, 0),
        coordinatesList: jspb.Message.toObjectList(
          msg.getCoordinatesList(),
          proto.com.mu.logistic.api.DeliveryCoordinates.toObject,
          includeInstance
        ),
        pointid: jspb.Message.getFieldWithDefault(msg, 10, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCalculationDistanceRequest}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCalculationDistanceRequest();
  return proto.com.mu.logistic.api.GetCalculationDistanceRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCalculationDistanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCalculationDistanceRequest}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicetype(value);
        break;
      case 3:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCity(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOrdertype(value);
        break;
      case 9:
        var value = new proto.com.mu.logistic.api.DeliveryCoordinates();
        reader.readMessage(value, proto.com.mu.logistic.api.DeliveryCoordinates.deserializeBinaryFromReader);
        msg.addCoordinates(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPointid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCalculationDistanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCalculationDistanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getServicetype();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(3, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(4, f);
  }
  f = message.getCity();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getOrdertype();
  if (f !== 0) {
    writer.writeInt32(8, f);
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(9, f, proto.com.mu.logistic.api.DeliveryCoordinates.serializeBinaryToWriter);
  }
  f = message.getPointid();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 serviceType = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getServicetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setServicetype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional bool roundTrip = 3;
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};

/**
 * optional double declaredValue = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};

/**
 * optional int32 city = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getCity = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setCity = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string startDate = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string startTime = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional int32 orderType = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getOrdertype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setOrdertype = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * repeated DeliveryCoordinates coordinates = 9;
 * @return {!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getCoordinatesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.DeliveryCoordinates, 9)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.DeliveryCoordinates>} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setCoordinatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};

/**
 * @param {!proto.com.mu.logistic.api.DeliveryCoordinates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.DeliveryCoordinates}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.addCoordinates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.com.mu.logistic.api.DeliveryCoordinates, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.clearCoordinatesList = function () {
  this.setCoordinatesList([]);
};

/**
 * optional int32 pointId = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.getPointid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCalculationDistanceRequest.prototype.setPointid = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetAddressInGeologicRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetAddressInGeologicRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetAddressInGeologicRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        country: jspb.Message.getFieldWithDefault(msg, 1, ''),
        city: jspb.Message.getFieldWithDefault(msg, 2, ''),
        address: jspb.Message.getFieldWithDefault(msg, 3, ''),
        isprincipal: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetAddressInGeologicRequest}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetAddressInGeologicRequest();
  return proto.com.mu.logistic.api.GetAddressInGeologicRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetAddressInGeologicRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetAddressInGeologicRequest}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsprincipal(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetAddressInGeologicRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetAddressInGeologicRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getIsprincipal();
  if (f) {
    writer.writeBool(4, f);
  }
};

/**
 * optional string country = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.getCountry = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string city = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string address = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional bool isPrincipal = 4;
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.getIsprincipal = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.GetAddressInGeologicRequest.prototype.setIsprincipal = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetAddressGeolocation.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetAddressGeolocation.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetAddressGeolocation} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetAddressGeolocation.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        lng: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetAddressGeolocation}
 */
proto.com.mu.logistic.api.GetAddressGeolocation.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetAddressGeolocation();
  return proto.com.mu.logistic.api.GetAddressGeolocation.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetAddressGeolocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetAddressGeolocation}
 */
proto.com.mu.logistic.api.GetAddressGeolocation.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLat(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLng(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetAddressGeolocation.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetAddressGeolocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetAddressGeolocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetAddressGeolocation.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getLng();
  if (f !== 0.0) {
    writer.writeDouble(2, f);
  }
};

/**
 * optional double lat = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetAddressGeolocation.prototype.getLat = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetAddressGeolocation.prototype.setLat = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional double lng = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.GetAddressGeolocation.prototype.getLng = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetAddressGeolocation.prototype.setLng = function (value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetAddressData.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetAddressData.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetAddressData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetAddressData.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        type: jspb.Message.getFieldWithDefault(msg, 1, ''),
        properties: (f = msg.getProperties()) && proto.com.mu.logistic.api.AddressData.toObject(includeInstance, f),
        coordinates: (f = msg.getCoordinates()) && proto.com.mu.logistic.api.CalculationCoordinates.toObject(includeInstance, f),
        recharge: jspb.Message.getFieldWithDefault(msg, 4, ''),
        nearbycity: jspb.Message.getFieldWithDefault(msg, 5, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetAddressData}
 */
proto.com.mu.logistic.api.GetAddressData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetAddressData();
  return proto.com.mu.logistic.api.GetAddressData.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetAddressData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetAddressData}
 */
proto.com.mu.logistic.api.GetAddressData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.AddressData();
        reader.readMessage(value, proto.com.mu.logistic.api.AddressData.deserializeBinaryFromReader);
        msg.setProperties(value);
        break;
      case 3:
        var value = new proto.com.mu.logistic.api.CalculationCoordinates();
        reader.readMessage(value, proto.com.mu.logistic.api.CalculationCoordinates.deserializeBinaryFromReader);
        msg.setCoordinates(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setRecharge(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setNearbycity(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetAddressData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetAddressData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetAddressData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getProperties();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.AddressData.serializeBinaryToWriter);
  }
  f = message.getCoordinates();
  if (f != null) {
    writer.writeMessage(3, f, proto.com.mu.logistic.api.CalculationCoordinates.serializeBinaryToWriter);
  }
  f = message.getRecharge();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getNearbycity();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
};

/**
 * optional string type = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetAddressData.prototype.setType = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional AddressData properties = 2;
 * @return {?proto.com.mu.logistic.api.AddressData}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.getProperties = function () {
  return /** @type{?proto.com.mu.logistic.api.AddressData} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.AddressData, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.AddressData|undefined} value */
proto.com.mu.logistic.api.GetAddressData.prototype.setProperties = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetAddressData.prototype.clearProperties = function () {
  this.setProperties(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.hasProperties = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional CalculationCoordinates coordinates = 3;
 * @return {?proto.com.mu.logistic.api.CalculationCoordinates}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.getCoordinates = function () {
  return /** @type{?proto.com.mu.logistic.api.CalculationCoordinates} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.CalculationCoordinates, 3)
  );
};

/** @param {?proto.com.mu.logistic.api.CalculationCoordinates|undefined} value */
proto.com.mu.logistic.api.GetAddressData.prototype.setCoordinates = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetAddressData.prototype.clearCoordinates = function () {
  this.setCoordinates(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.hasCoordinates = function () {
  return jspb.Message.getField(this, 3) != null;
};

/**
 * optional string recharge = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.getRecharge = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetAddressData.prototype.setRecharge = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string nearbyCity = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.GetAddressData.prototype.getNearbycity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetAddressData.prototype.setNearbycity = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetAddressInGeologicResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetAddressInGeologicResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetAddressInGeologicResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.GetAddressData.toObject(includeInstance, f),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetAddressInGeologicResponse}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetAddressInGeologicResponse();
  return proto.com.mu.logistic.api.GetAddressInGeologicResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetAddressInGeologicResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetAddressInGeologicResponse}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.GetAddressData();
        reader.readMessage(value, proto.com.mu.logistic.api.GetAddressData.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetAddressInGeologicResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetAddressInGeologicResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.GetAddressData.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * optional GetAddressData data = 1;
 * @return {?proto.com.mu.logistic.api.GetAddressData}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.GetAddressData} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.GetAddressData, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.GetAddressData|undefined} value */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetAddressInGeologicResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.DeliveryItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.DeliveryItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.DeliveryItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.DeliveryItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        addressitem: jspb.Message.getFieldWithDefault(msg, 1, ''),
        clientname: jspb.Message.getFieldWithDefault(msg, 2, ''),
        clientphone: jspb.Message.getFieldWithDefault(msg, 3, ''),
        clientpoint: jspb.Message.getFieldWithDefault(msg, 4, ''),
        itemid: jspb.Message.getFieldWithDefault(msg, 5, 0),
        orderid: jspb.Message.getFieldWithDefault(msg, 6, ''),
        productsvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
        startdate: jspb.Message.getFieldWithDefault(msg, 8, ''),
        starttime: jspb.Message.getFieldWithDefault(msg, 9, ''),
        itemstatus: jspb.Message.getFieldWithDefault(msg, 10, ''),
        itemstatusid: jspb.Message.getFieldWithDefault(msg, 11, ''),
        tasktype: jspb.Message.getFieldWithDefault(msg, 12, ''),
        tasktypeid: jspb.Message.getFieldWithDefault(msg, 13, ''),
        uutermid: jspb.Message.getFieldWithDefault(msg, 14, ''),
        paymentmethodid: jspb.Message.getFieldWithDefault(msg, 15, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.DeliveryItem}
 */
proto.com.mu.logistic.api.DeliveryItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.DeliveryItem();
  return proto.com.mu.logistic.api.DeliveryItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.DeliveryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.DeliveryItem}
 */
proto.com.mu.logistic.api.DeliveryItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddressitem(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientname(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientphone(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientpoint(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setItemid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderid(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setProductsvalue(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setItemstatus(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setItemstatusid(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setTasktype(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setTasktypeid(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setUutermid(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymentmethodid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.DeliveryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.DeliveryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.DeliveryItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddressitem();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getClientphone();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getClientpoint();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getProductsvalue();
  if (f !== 0.0) {
    writer.writeDouble(7, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getItemstatus();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getItemstatusid();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getTasktype();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getTasktypeid();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getUutermid();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getPaymentmethodid();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
};

/**
 * optional string addressItem = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getAddressitem = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setAddressitem = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string clientName = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getClientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setClientname = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string clientPhone = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getClientphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setClientphone = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string clientPoint = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getClientpoint = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setClientpoint = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 itemId = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getItemid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setItemid = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string orderId = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getOrderid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setOrderid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional double productsValue = 7;
 * @return {number}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getProductsvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setProductsvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};

/**
 * optional string startDate = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string startTime = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string itemStatus = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getItemstatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setItemstatus = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string itemStatusId = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getItemstatusid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setItemstatusid = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string taskType = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getTasktype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setTasktype = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string taskTypeId = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getTasktypeid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setTasktypeid = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string uuTermId = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getUutermid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setUutermid = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string paymentMethodId = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.DeliveryItem.prototype.getPaymentmethodid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DeliveryItem.prototype.setPaymentmethodid = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.FiltersToDelivery.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.FiltersToDelivery.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.FiltersToDelivery} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.FiltersToDelivery.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        filtername: jspb.Message.getFieldWithDefault(msg, 1, ''),
        filtervalue: jspb.Message.getFieldWithDefault(msg, 2, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.FiltersToDelivery}
 */
proto.com.mu.logistic.api.FiltersToDelivery.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.FiltersToDelivery();
  return proto.com.mu.logistic.api.FiltersToDelivery.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.FiltersToDelivery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.FiltersToDelivery}
 */
proto.com.mu.logistic.api.FiltersToDelivery.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setFiltername(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setFiltervalue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.FiltersToDelivery.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.FiltersToDelivery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.FiltersToDelivery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.FiltersToDelivery.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFiltername();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getFiltervalue();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional string filterName = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.FiltersToDelivery.prototype.getFiltername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.FiltersToDelivery.prototype.setFiltername = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string filterValue = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.FiltersToDelivery.prototype.getFiltervalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.FiltersToDelivery.prototype.setFiltervalue = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.PropertiesToFilter.repeatedFields_ = [2, 4];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PropertiesToFilter.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PropertiesToFilter.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PropertiesToFilter} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PropertiesToFilter.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        currentpage: jspb.Message.getFieldWithDefault(msg, 1, 0),
        filtersList: jspb.Message.toObjectList(msg.getFiltersList(), proto.com.mu.logistic.api.FiltersToDelivery.toObject, includeInstance),
        limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
        orderList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
        totalrows: jspb.Message.getFieldWithDefault(msg, 5, 0),
        totalpages: jspb.Message.getFieldWithDefault(msg, 6, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PropertiesToFilter}
 */
proto.com.mu.logistic.api.PropertiesToFilter.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PropertiesToFilter();
  return proto.com.mu.logistic.api.PropertiesToFilter.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PropertiesToFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PropertiesToFilter}
 */
proto.com.mu.logistic.api.PropertiesToFilter.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCurrentpage(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.FiltersToDelivery();
        reader.readMessage(value, proto.com.mu.logistic.api.FiltersToDelivery.deserializeBinaryFromReader);
        msg.addFilters(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setLimit(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.addOrder(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalrows(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalpages(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PropertiesToFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PropertiesToFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PropertiesToFilter.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCurrentpage();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.com.mu.logistic.api.FiltersToDelivery.serializeBinaryToWriter);
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getOrderList();
  if (f.length > 0) {
    writer.writeRepeatedString(4, f);
  }
  f = message.getTotalrows();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getTotalpages();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
};

/**
 * optional int32 currentPage = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.getCurrentpage = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.setCurrentpage = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * repeated FiltersToDelivery filters = 2;
 * @return {!Array<!proto.com.mu.logistic.api.FiltersToDelivery>}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.getFiltersList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.FiltersToDelivery>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.FiltersToDelivery, 2)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.FiltersToDelivery>} value */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.setFiltersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};

/**
 * @param {!proto.com.mu.logistic.api.FiltersToDelivery=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.FiltersToDelivery}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.addFilters = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.mu.logistic.api.FiltersToDelivery, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.clearFiltersList = function () {
  this.setFiltersList([]);
};

/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.getLimit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * repeated string order = 4;
 * @return {!Array<string>}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.getOrderList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};

/** @param {!Array<string>} value */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.setOrderList = function (value) {
  jspb.Message.setField(this, 4, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.addOrder = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.clearOrderList = function () {
  this.setOrderList([]);
};

/**
 * optional int32 totalRows = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.getTotalrows = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.setTotalrows = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional int32 totalPages = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.getTotalpages = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PropertiesToFilter.prototype.setTotalpages = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.UserTaskByIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.UserTaskByIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.UserTaskByIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        page: jspb.Message.getFieldWithDefault(msg, 2, 0),
        limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
        filtername: jspb.Message.getFieldWithDefault(msg, 4, ''),
        filter: jspb.Message.getFieldWithDefault(msg, 5, ''),
        points: jspb.Message.getFieldWithDefault(msg, 6, ''),
        status: jspb.Message.getFieldWithDefault(msg, 7, ''),
        paymentmethod: jspb.Message.getFieldWithDefault(msg, 8, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.UserTaskByIdRequest}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.UserTaskByIdRequest();
  return proto.com.mu.logistic.api.UserTaskByIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.UserTaskByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.UserTaskByIdRequest}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPage(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setLimit(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setFiltername(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setFilter(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setPoints(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymentmethod(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.UserTaskByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.UserTaskByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getFiltername();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getPoints();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getPaymentmethod();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getPage = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setPage = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getLimit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string filterName = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getFiltername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setFiltername = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string filter = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getFilter = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setFilter = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string points = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getPoints = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setPoints = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string status = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string paymentMethod = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.getPaymentmethod = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdRequest.prototype.setPaymentmethod = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.UserTaskByIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.UserTaskByIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.UserTaskByIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        dataList: jspb.Message.toObjectList(msg.getDataList(), proto.com.mu.logistic.api.DeliveryItem.toObject, includeInstance),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        properties: (f = msg.getProperties()) && proto.com.mu.logistic.api.PropertiesToFilter.toObject(includeInstance, f),
        status: jspb.Message.getFieldWithDefault(msg, 5, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 6, 0),
        version: jspb.Message.getFieldWithDefault(msg, 7, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.UserTaskByIdResponse}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.UserTaskByIdResponse();
  return proto.com.mu.logistic.api.UserTaskByIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.UserTaskByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.UserTaskByIdResponse}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.DeliveryItem();
        reader.readMessage(value, proto.com.mu.logistic.api.DeliveryItem.deserializeBinaryFromReader);
        msg.addData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = new proto.com.mu.logistic.api.PropertiesToFilter();
        reader.readMessage(value, proto.com.mu.logistic.api.PropertiesToFilter.deserializeBinaryFromReader);
        msg.setProperties(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatuscode(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.UserTaskByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.UserTaskByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.DeliveryItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getProperties();
  if (f != null) {
    writer.writeMessage(4, f, proto.com.mu.logistic.api.PropertiesToFilter.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getStatuscode();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
};

/**
 * repeated DeliveryItem data = 1;
 * @return {!Array<!proto.com.mu.logistic.api.DeliveryItem>}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getDataList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.DeliveryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.DeliveryItem, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.DeliveryItem>} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setDataList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.DeliveryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.DeliveryItem}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.addData = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.DeliveryItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.clearDataList = function () {
  this.setDataList([]);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional PropertiesToFilter properties = 4;
 * @return {?proto.com.mu.logistic.api.PropertiesToFilter}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getProperties = function () {
  return /** @type{?proto.com.mu.logistic.api.PropertiesToFilter} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.PropertiesToFilter, 4)
  );
};

/** @param {?proto.com.mu.logistic.api.PropertiesToFilter|undefined} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setProperties = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.clearProperties = function () {
  this.setProperties(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.hasProperties = function () {
  return jspb.Message.getField(this, 4) != null;
};

/**
 * optional string status = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional int32 statusCode = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getStatuscode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional string version = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.UserTaskByIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.OauthTokenRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.OauthTokenRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.OauthTokenRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.OauthTokenRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        clientid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        clientsecret: jspb.Message.getFieldWithDefault(msg, 2, ''),
        granttype: jspb.Message.getFieldWithDefault(msg, 3, ''),
        password: jspb.Message.getFieldWithDefault(msg, 4, ''),
        username: jspb.Message.getFieldWithDefault(msg, 5, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.OauthTokenRequest}
 */
proto.com.mu.logistic.api.OauthTokenRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.OauthTokenRequest();
  return proto.com.mu.logistic.api.OauthTokenRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.OauthTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.OauthTokenRequest}
 */
proto.com.mu.logistic.api.OauthTokenRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientsecret(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setGranttype(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setPassword(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsername(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.OauthTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.OauthTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.OauthTokenRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getClientsecret();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getGranttype();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
};

/**
 * optional string clientId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.getClientid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.setClientid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string clientSecret = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.getClientsecret = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.setClientsecret = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string grantType = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.getGranttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.setGranttype = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string password = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.getPassword = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.setPassword = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string userName = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.getUsername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenRequest.prototype.setUsername = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.OauthTokenResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.OauthTokenResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.OauthTokenResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.OauthTokenResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        accesstoken: jspb.Message.getFieldWithDefault(msg, 1, ''),
        expirationtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
        refreshtoken: jspb.Message.getFieldWithDefault(msg, 3, ''),
        scope: jspb.Message.getFieldWithDefault(msg, 4, ''),
        tokentype: jspb.Message.getFieldWithDefault(msg, 5, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.OauthTokenResponse}
 */
proto.com.mu.logistic.api.OauthTokenResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.OauthTokenResponse();
  return proto.com.mu.logistic.api.OauthTokenResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.OauthTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.OauthTokenResponse}
 */
proto.com.mu.logistic.api.OauthTokenResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccesstoken(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setExpirationtime(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setRefreshtoken(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setScope(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setTokentype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.OauthTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.OauthTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.OauthTokenResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAccesstoken();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getExpirationtime();
  if (f !== 0) {
    writer.writeInt64(2, f);
  }
  f = message.getRefreshtoken();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getTokentype();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
};

/**
 * optional string accessToken = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.getAccesstoken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.setAccesstoken = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int64 expirationTime = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.getExpirationtime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.setExpirationtime = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string refreshToken = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.getRefreshtoken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.setRefreshtoken = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string scope = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.getScope = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.setScope = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string tokenType = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.getTokentype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OauthTokenResponse.prototype.setTokentype = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.EvidenceItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.EvidenceItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.EvidenceItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.EvidenceItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        urlphoto: jspb.Message.getFieldWithDefault(msg, 2, ''),
        date: jspb.Message.getFieldWithDefault(msg, 3, ''),
        address: jspb.Message.getFieldWithDefault(msg, 4, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.EvidenceItem}
 */
proto.com.mu.logistic.api.EvidenceItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.EvidenceItem();
  return proto.com.mu.logistic.api.EvidenceItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.EvidenceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.EvidenceItem}
 */
proto.com.mu.logistic.api.EvidenceItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setUrlphoto(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDate(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.EvidenceItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.EvidenceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.EvidenceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.EvidenceItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getUrlphoto();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.EvidenceItem.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EvidenceItem.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string urlPhoto = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.EvidenceItem.prototype.getUrlphoto = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EvidenceItem.prototype.setUrlphoto = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string date = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.EvidenceItem.prototype.getDate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EvidenceItem.prototype.setDate = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string address = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.EvidenceItem.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EvidenceItem.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        filter: (f = msg.getFilter()) && proto.com.mu.logistic.api.EvidenceFilter.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest();
  return proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTaskid(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.EvidenceFilter();
        reader.readMessage(value, proto.com.mu.logistic.api.EvidenceFilter.deserializeBinaryFromReader);
        msg.setFilter(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.EvidenceFilter.serializeBinaryToWriter);
  }
};

/**
 * optional string taskId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.getTaskid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.setTaskid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional EvidenceFilter filter = 2;
 * @return {?proto.com.mu.logistic.api.EvidenceFilter}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.getFilter = function () {
  return /** @type{?proto.com.mu.logistic.api.EvidenceFilter} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.EvidenceFilter, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.EvidenceFilter|undefined} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.setFilter = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.clearFilter = function () {
  this.setFilter(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdRequest.prototype.hasFilter = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.EvidenceFilter.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.EvidenceFilter.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.EvidenceFilter} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.EvidenceFilter.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskplaceid: jspb.Message.getFieldWithDefault(msg, 1, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.EvidenceFilter}
 */
proto.com.mu.logistic.api.EvidenceFilter.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.EvidenceFilter();
  return proto.com.mu.logistic.api.EvidenceFilter.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.EvidenceFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.EvidenceFilter}
 */
proto.com.mu.logistic.api.EvidenceFilter.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskplaceid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.EvidenceFilter.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.EvidenceFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.EvidenceFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.EvidenceFilter.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskplaceid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};

/**
 * optional int32 taskPlaceId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.EvidenceFilter.prototype.getTaskplaceid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.EvidenceFilter.prototype.setTaskplaceid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        dataList: jspb.Message.toObjectList(msg.getDataList(), proto.com.mu.logistic.api.EvidenceItem.toObject, includeInstance),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, ''),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse();
  return proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.EvidenceItem();
        reader.readMessage(value, proto.com.mu.logistic.api.EvidenceItem.deserializeBinaryFromReader);
        msg.addData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.EvidenceItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * repeated EvidenceItem data = 1;
 * @return {!Array<!proto.com.mu.logistic.api.EvidenceItem>}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.getDataList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.EvidenceItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.EvidenceItem, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.EvidenceItem>} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.setDataList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.EvidenceItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.EvidenceItem}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.addData = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.EvidenceItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.clearDataList = function () {
  this.setDataList([]);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string statusCode = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.getStatuscode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetEvidencesByTaskIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
        zipfile: msg.getZipfile_asB64(),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse();
  return proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      case 2:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setZipfile(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
  f = message.getZipfile_asU8();
  if (f.length > 0) {
    writer.writeBytes(2, f);
  }
};

/**
 * optional StatusInfoResponse status = 1;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional bytes zipFile = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.getZipfile = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * optional bytes zipFile = 2;
 * This is a type-conversion wrapper around `getZipfile()`
 * @return {string}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.getZipfile_asB64 = function () {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getZipfile()));
};

/**
 * optional bytes zipFile = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getZipfile()`
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.getZipfile_asU8 = function () {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getZipfile()));
};

/** @param {!(string|Uint8Array)} value */
proto.com.mu.logistic.api.GetEvidencesZipByTaskIdResponse.prototype.setZipfile = function (value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetRatebyTaskIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetRatebyTaskIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetRatebyTaskIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        question: jspb.Message.getFieldWithDefault(msg, 2, 0),
        device: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetRatebyTaskIdRequest}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetRatebyTaskIdRequest();
  return proto.com.mu.logistic.api.GetRatebyTaskIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetRatebyTaskIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetRatebyTaskIdRequest}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setQuestion(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDevice(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetRatebyTaskIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetRatebyTaskIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getQuestion();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getDevice();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 question = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.getQuestion = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.setQuestion = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 device = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.getDevice = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetRatebyTaskIdRequest.prototype.setDevice = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetRatebyTaskIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetRatebyTaskIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetRatebyTaskIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        calificacion: jspb.Message.getFieldWithDefault(msg, 2, 0),
        descripcion: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, ''),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetRatebyTaskIdResponse}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetRatebyTaskIdResponse();
  return proto.com.mu.logistic.api.GetRatebyTaskIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetRatebyTaskIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetRatebyTaskIdResponse}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCalificacion(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescripcion(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetRatebyTaskIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetRatebyTaskIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCalificacion();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getDescripcion();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 calificacion = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.getCalificacion = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.setCalificacion = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string descripcion = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.getDescripcion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.setDescripcion = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string statusCode = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.getStatuscode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetRatebyTaskIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.RateTaskbyIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.RateTaskbyIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.RateTaskbyIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        question: jspb.Message.getFieldWithDefault(msg, 2, 0),
        rate: jspb.Message.getFieldWithDefault(msg, 3, 0),
        device: jspb.Message.getFieldWithDefault(msg, 4, 0),
        version: jspb.Message.getFieldWithDefault(msg, 5, ''),
        description: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.RateTaskbyIdRequest}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.RateTaskbyIdRequest();
  return proto.com.mu.logistic.api.RateTaskbyIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.RateTaskbyIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.RateTaskbyIdRequest}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setQuestion(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRate(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setDevice(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.RateTaskbyIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.RateTaskbyIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getQuestion();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getRate();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getDevice();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 question = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.getQuestion = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.setQuestion = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 rate = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.getRate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.setRate = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional int32 device = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.getDevice = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.setDevice = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string version = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string description = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdRequest.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.RateTaskbyIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.RateTaskbyIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.RateTaskbyIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: jspb.Message.getFieldWithDefault(msg, 1, ''),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, ''),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.RateTaskbyIdResponse}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.RateTaskbyIdResponse();
  return proto.com.mu.logistic.api.RateTaskbyIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.RateTaskbyIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.RateTaskbyIdResponse}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.RateTaskbyIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.RateTaskbyIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional string data = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.getData = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.setData = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string statusCode = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.getStatuscode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.RateTaskbyIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CancelTaskByIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CancelTaskByIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CancelTaskByIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        cancellationtype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        description: jspb.Message.getFieldWithDefault(msg, 3, ''),
        finec: jspb.Message.getFieldWithDefault(msg, 4, 0),
        payc: jspb.Message.getFieldWithDefault(msg, 5, 0),
        finer: jspb.Message.getFieldWithDefault(msg, 6, 0),
        payr: jspb.Message.getFieldWithDefault(msg, 7, 0),
        userid: jspb.Message.getFieldWithDefault(msg, 8, 0),
        verificationcode: jspb.Message.getFieldWithDefault(msg, 9, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CancelTaskByIdRequest}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CancelTaskByIdRequest();
  return proto.com.mu.logistic.api.CancelTaskByIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CancelTaskByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CancelTaskByIdRequest}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCancellationtype(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setFinec(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPayc(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setFiner(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPayr(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setVerificationcode(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CancelTaskByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CancelTaskByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCancellationtype();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getFinec();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getPayc();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getFiner();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getPayr();
  if (f !== 0) {
    writer.writeInt32(7, f);
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(8, f);
  }
  f = message.getVerificationcode();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 cancellationType = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getCancellationtype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setCancellationtype = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string description = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 fineC = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getFinec = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setFinec = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional int32 payC = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getPayc = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setPayc = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional int32 fineR = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getFiner = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setFiner = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional int32 payR = 7;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getPayr = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setPayr = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};

/**
 * optional int32 userId = 8;
 * @return {number}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};

/**
 * optional string verificationCode = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.getVerificationcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdRequest.prototype.setVerificationcode = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CancelTaskByIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CancelTaskByIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CancelTaskByIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: jspb.Message.getFieldWithDefault(msg, 1, ''),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, ''),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CancelTaskByIdResponse}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CancelTaskByIdResponse();
  return proto.com.mu.logistic.api.CancelTaskByIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CancelTaskByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CancelTaskByIdResponse}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CancelTaskByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CancelTaskByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional string data = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.getData = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.setData = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string statusCode = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.getStatuscode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancelTaskByIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.SourceDeliveryIn.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.SourceDeliveryIn.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.SourceDeliveryIn} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.SourceDeliveryIn.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        cityid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        cityname: jspb.Message.getFieldWithDefault(msg, 2, ''),
        clientid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        clientname: jspb.Message.getFieldWithDefault(msg, 4, ''),
        clienttype: jspb.Message.getFieldWithDefault(msg, 5, ''),
        companyid: jspb.Message.getFieldWithDefault(msg, 6, ''),
        companyname: jspb.Message.getFieldWithDefault(msg, 7, ''),
        finalclientdocument: jspb.Message.getFieldWithDefault(msg, 8, ''),
        finalclientname: jspb.Message.getFieldWithDefault(msg, 9, ''),
        finalclientphone: jspb.Message.getFieldWithDefault(msg, 10, ''),
        sourcedeliveryid: jspb.Message.getFieldWithDefault(msg, 11, ''),
        orderid: jspb.Message.getFieldWithDefault(msg, 12, ''),
        originaddress: jspb.Message.getFieldWithDefault(msg, 13, ''),
        startdate: jspb.Message.getFieldWithDefault(msg, 14, ''),
        startdateunix: jspb.Message.getFieldWithDefault(msg, 15, ''),
        taskstatusid: jspb.Message.getFieldWithDefault(msg, 16, ''),
        taskstatusname: jspb.Message.getFieldWithDefault(msg, 17, ''),
        tasktypeid: jspb.Message.getFieldWithDefault(msg, 18, ''),
        tasktypename: jspb.Message.getFieldWithDefault(msg, 19, ''),
        uuid: jspb.Message.getFieldWithDefault(msg, 20, ''),
        taskid: jspb.Message.getFieldWithDefault(msg, 21, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.SourceDeliveryIn}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.SourceDeliveryIn();
  return proto.com.mu.logistic.api.SourceDeliveryIn.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.SourceDeliveryIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.SourceDeliveryIn}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityname(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientname(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setClienttype(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyid(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyname(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinalclientdocument(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinalclientname(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinalclientphone(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setSourcedeliveryid(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderid(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginaddress(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdateunix(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setTaskstatusid(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setTaskstatusname(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setTasktypeid(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setTasktypename(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setUuid(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setTaskid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.SourceDeliveryIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.SourceDeliveryIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.SourceDeliveryIn.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCityid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getClienttype();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getCompanyid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getFinalclientdocument();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getFinalclientname();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getFinalclientphone();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getSourcedeliveryid();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getOriginaddress();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getStartdateunix();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getTaskstatusid();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getTaskstatusname();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getTasktypeid();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getTasktypename();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getTaskid();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
};

/**
 * optional string cityId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getCityid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setCityid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string cityName = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getCityname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setCityname = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string clientId = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getClientid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setClientid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string clientName = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getClientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setClientname = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string clientType = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getClienttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setClienttype = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string companyId = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getCompanyid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setCompanyid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string companyName = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getCompanyname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setCompanyname = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string finalClientDocument = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getFinalclientdocument = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setFinalclientdocument = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string finalClientName = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getFinalclientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setFinalclientname = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string finalClientPhone = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getFinalclientphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setFinalclientphone = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string SourceDeliveryId = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getSourcedeliveryid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setSourcedeliveryid = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string orderId = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getOrderid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setOrderid = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string originAddress = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getOriginaddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setOriginaddress = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string startDate = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string startDateUnix = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getStartdateunix = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setStartdateunix = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string taskStatusId = 16;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getTaskstatusid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setTaskstatusid = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string taskStatusName = 17;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getTaskstatusname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setTaskstatusname = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string taskTypeId = 18;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getTasktypeid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setTasktypeid = function (value) {
  jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string taskTypeName = 19;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getTasktypename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setTasktypename = function (value) {
  jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string uuid = 20;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setUuid = function (value) {
  jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string taskId = 21;
 * @return {string}
 */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.getTaskid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SourceDeliveryIn.prototype.setTaskid = function (value) {
  jspb.Message.setProto3StringField(this, 21, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.Hits.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.Hits.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.Hits} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.Hits.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        hitsid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        hitsindex: jspb.Message.getFieldWithDefault(msg, 2, ''),
        score: jspb.Message.getFieldWithDefault(msg, 3, ''),
        source: (f = msg.getSource()) && proto.com.mu.logistic.api.SourceDeliveryIn.toObject(includeInstance, f),
        type: jspb.Message.getFieldWithDefault(msg, 5, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.Hits}
 */
proto.com.mu.logistic.api.Hits.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.Hits();
  return proto.com.mu.logistic.api.Hits.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.Hits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.Hits}
 */
proto.com.mu.logistic.api.Hits.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setHitsid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setHitsindex(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setScore(value);
        break;
      case 4:
        var value = new proto.com.mu.logistic.api.SourceDeliveryIn();
        reader.readMessage(value, proto.com.mu.logistic.api.SourceDeliveryIn.deserializeBinaryFromReader);
        msg.setSource(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.Hits.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.Hits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.Hits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.Hits.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHitsid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getHitsindex();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getScore();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(4, f, proto.com.mu.logistic.api.SourceDeliveryIn.serializeBinaryToWriter);
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
};

/**
 * optional string hitsId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.Hits.prototype.getHitsid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Hits.prototype.setHitsid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string hitsIndex = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.Hits.prototype.getHitsindex = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Hits.prototype.setHitsindex = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string score = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.Hits.prototype.getScore = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Hits.prototype.setScore = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional SourceDeliveryIn source = 4;
 * @return {?proto.com.mu.logistic.api.SourceDeliveryIn}
 */
proto.com.mu.logistic.api.Hits.prototype.getSource = function () {
  return /** @type{?proto.com.mu.logistic.api.SourceDeliveryIn} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.SourceDeliveryIn, 4)
  );
};

/** @param {?proto.com.mu.logistic.api.SourceDeliveryIn|undefined} value */
proto.com.mu.logistic.api.Hits.prototype.setSource = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.Hits.prototype.clearSource = function () {
  this.setSource(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.Hits.prototype.hasSource = function () {
  return jspb.Message.getField(this, 4) != null;
};

/**
 * optional string type = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.Hits.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Hits.prototype.setType = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.ItemHits.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ItemHits.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ItemHits.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ItemHits} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ItemHits.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        hitsList: jspb.Message.toObjectList(msg.getHitsList(), proto.com.mu.logistic.api.Hits.toObject, includeInstance),
        maxscore: jspb.Message.getFieldWithDefault(msg, 2, 0),
        total: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ItemHits}
 */
proto.com.mu.logistic.api.ItemHits.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ItemHits();
  return proto.com.mu.logistic.api.ItemHits.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ItemHits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ItemHits}
 */
proto.com.mu.logistic.api.ItemHits.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.Hits();
        reader.readMessage(value, proto.com.mu.logistic.api.Hits.deserializeBinaryFromReader);
        msg.addHits(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setMaxscore(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotal(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ItemHits.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ItemHits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ItemHits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ItemHits.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.Hits.serializeBinaryToWriter);
  }
  f = message.getMaxscore();
  if (f !== 0) {
    writer.writeInt64(2, f);
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * repeated Hits hits = 1;
 * @return {!Array<!proto.com.mu.logistic.api.Hits>}
 */
proto.com.mu.logistic.api.ItemHits.prototype.getHitsList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.Hits>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.Hits, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.Hits>} value */
proto.com.mu.logistic.api.ItemHits.prototype.setHitsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.Hits=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.Hits}
 */
proto.com.mu.logistic.api.ItemHits.prototype.addHits = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.Hits, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.ItemHits.prototype.clearHitsList = function () {
  this.setHitsList([]);
};

/**
 * optional int64 maxScore = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.ItemHits.prototype.getMaxscore = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ItemHits.prototype.setMaxscore = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.ItemHits.prototype.getTotal = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ItemHits.prototype.setTotal = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ShardsItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ShardsItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ShardsItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ShardsItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        failed: jspb.Message.getFieldWithDefault(msg, 1, 0),
        successful: jspb.Message.getFieldWithDefault(msg, 2, 0),
        total: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ShardsItem}
 */
proto.com.mu.logistic.api.ShardsItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ShardsItem();
  return proto.com.mu.logistic.api.ShardsItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ShardsItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ShardsItem}
 */
proto.com.mu.logistic.api.ShardsItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setFailed(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setSuccessful(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotal(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ShardsItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ShardsItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ShardsItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ShardsItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFailed();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getSuccessful();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * optional int32 failed = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.ShardsItem.prototype.getFailed = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ShardsItem.prototype.setFailed = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 successful = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.ShardsItem.prototype.getSuccessful = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ShardsItem.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.ShardsItem.prototype.getTotal = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ShardsItem.prototype.setTotal = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.SearchItemsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.SearchItemsRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.SearchItemsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.SearchItemsRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        valuesearch: jspb.Message.getFieldWithDefault(msg, 1, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.SearchItemsRequest}
 */
proto.com.mu.logistic.api.SearchItemsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.SearchItemsRequest();
  return proto.com.mu.logistic.api.SearchItemsRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.SearchItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.SearchItemsRequest}
 */
proto.com.mu.logistic.api.SearchItemsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setValuesearch(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.SearchItemsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.SearchItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.SearchItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.SearchItemsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getValuesearch();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string valueSearch = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.SearchItemsRequest.prototype.getValuesearch = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SearchItemsRequest.prototype.setValuesearch = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.SearchItemsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.SearchItemsResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.SearchItemsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.SearchItemsResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        hits: (f = msg.getHits()) && proto.com.mu.logistic.api.ItemHits.toObject(includeInstance, f),
        timedout: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
        took: jspb.Message.getFieldWithDefault(msg, 3, 0),
        shards: (f = msg.getShards()) && proto.com.mu.logistic.api.ShardsItem.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.SearchItemsResponse}
 */
proto.com.mu.logistic.api.SearchItemsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.SearchItemsResponse();
  return proto.com.mu.logistic.api.SearchItemsResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.SearchItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.SearchItemsResponse}
 */
proto.com.mu.logistic.api.SearchItemsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.ItemHits();
        reader.readMessage(value, proto.com.mu.logistic.api.ItemHits.deserializeBinaryFromReader);
        msg.setHits(value);
        break;
      case 2:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setTimedout(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTook(value);
        break;
      case 4:
        var value = new proto.com.mu.logistic.api.ShardsItem();
        reader.readMessage(value, proto.com.mu.logistic.api.ShardsItem.deserializeBinaryFromReader);
        msg.setShards(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.SearchItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.SearchItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.SearchItemsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHits();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.ItemHits.serializeBinaryToWriter);
  }
  f = message.getTimedout();
  if (f) {
    writer.writeBool(2, f);
  }
  f = message.getTook();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getShards();
  if (f != null) {
    writer.writeMessage(4, f, proto.com.mu.logistic.api.ShardsItem.serializeBinaryToWriter);
  }
};

/**
 * optional ItemHits hits = 1;
 * @return {?proto.com.mu.logistic.api.ItemHits}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.getHits = function () {
  return /** @type{?proto.com.mu.logistic.api.ItemHits} */ (jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.ItemHits, 1));
};

/** @param {?proto.com.mu.logistic.api.ItemHits|undefined} value */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.setHits = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.clearHits = function () {
  this.setHits(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.hasHits = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional bool timedOut = 2;
 * @return {boolean}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.getTimedout = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.setTimedout = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};

/**
 * optional int32 took = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.getTook = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.setTook = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional ShardsItem shards = 4;
 * @return {?proto.com.mu.logistic.api.ShardsItem}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.getShards = function () {
  return /** @type{?proto.com.mu.logistic.api.ShardsItem} */ (jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.ShardsItem, 4));
};

/** @param {?proto.com.mu.logistic.api.ShardsItem|undefined} value */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.setShards = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.clearShards = function () {
  this.setShards(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.SearchItemsResponse.prototype.hasShards = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetResourcesByUserRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetResourcesByUserRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetResourcesByUserRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetResourcesByUserRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        accesstoken: jspb.Message.getFieldWithDefault(msg, 1, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetResourcesByUserRequest}
 */
proto.com.mu.logistic.api.GetResourcesByUserRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetResourcesByUserRequest();
  return proto.com.mu.logistic.api.GetResourcesByUserRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetResourcesByUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetResourcesByUserRequest}
 */
proto.com.mu.logistic.api.GetResourcesByUserRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccesstoken(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetResourcesByUserRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetResourcesByUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetResourcesByUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetResourcesByUserRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAccesstoken();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string accessToken = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetResourcesByUserRequest.prototype.getAccesstoken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetResourcesByUserRequest.prototype.setAccesstoken = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.ResourceItem.repeatedFields_ = [16, 17, 27];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ResourceItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ResourceItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ResourceItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ResourceItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        administrator: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
        cityid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        cityphone: jspb.Message.getFieldWithDefault(msg, 3, ''),
        companyresources: jspb.Message.getFieldWithDefault(msg, 4, ''),
        companyid: jspb.Message.getFieldWithDefault(msg, 5, ''),
        countryresources: jspb.Message.getFieldWithDefault(msg, 6, 0),
        createat: jspb.Message.getFieldWithDefault(msg, 7, ''),
        resourcesemail: jspb.Message.getFieldWithDefault(msg, 8, ''),
        resourcesid: jspb.Message.getFieldWithDefault(msg, 9, ''),
        numberid: jspb.Message.getFieldWithDefault(msg, 10, 0),
        lastvisitat: jspb.Message.getFieldWithDefault(msg, 11, ''),
        companyname: jspb.Message.getFieldWithDefault(msg, 12, ''),
        cityname: jspb.Message.getFieldWithDefault(msg, 13, ''),
        servicesnumber: jspb.Message.getFieldWithDefault(msg, 14, 0),
        usersnumber: jspb.Message.getFieldWithDefault(msg, 15, 0),
        rolesnamesList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
        rolesidsList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
        resourcestatus: jspb.Message.getFieldWithDefault(msg, 18, 0),
        userstatus: jspb.Message.getFieldWithDefault(msg, 19, 0),
        resourceterms: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
        timeend: jspb.Message.getFieldWithDefault(msg, 21, 0),
        usertype: jspb.Message.getFieldWithDefault(msg, 22, ''),
        username: jspb.Message.getFieldWithDefault(msg, 23, ''),
        viewservices: jspb.Message.getFieldWithDefault(msg, 24, ''),
        typetaskpayid: jspb.Message.getFieldWithDefault(msg, 25, 0),
        identification: jspb.Message.getFieldWithDefault(msg, 26, ''),
        enterprisegroupList: jspb.Message.toObjectList(
          msg.getEnterprisegroupList(),
          proto.com.mu.logistic.api.EnterpriseGroup.toObject,
          includeInstance
        ),
        usernickname: jspb.Message.getFieldWithDefault(msg, 28, ''),
        companytypetaskpayid: jspb.Message.getFieldWithDefault(msg, 29, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ResourceItem}
 */
proto.com.mu.logistic.api.ResourceItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ResourceItem();
  return proto.com.mu.logistic.api.ResourceItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ResourceItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ResourceItem}
 */
proto.com.mu.logistic.api.ResourceItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setAdministrator(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityphone(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyresources(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyid(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCountryresources(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setCreateat(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setResourcesemail(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setResourcesid(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setNumberid(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setLastvisitat(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyname(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityname(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicesnumber(value);
        break;
      case 15:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUsersnumber(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.addRolesnames(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.addRolesids(value);
        break;
      case 18:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setResourcestatus(value);
        break;
      case 19:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserstatus(value);
        break;
      case 20:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setResourceterms(value);
        break;
      case 21:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTimeend(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsertype(value);
        break;
      case 23:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsername(value);
        break;
      case 24:
        var value = /** @type {string} */ (reader.readString());
        msg.setViewservices(value);
        break;
      case 25:
        var value = /** @type {!proto.com.mu.logistic.api.PaymentType} */ (reader.readEnum());
        msg.setTypetaskpayid(value);
        break;
      case 26:
        var value = /** @type {string} */ (reader.readString());
        msg.setIdentification(value);
        break;
      case 27:
        var value = new proto.com.mu.logistic.api.EnterpriseGroup();
        reader.readMessage(value, proto.com.mu.logistic.api.EnterpriseGroup.deserializeBinaryFromReader);
        msg.addEnterprisegroup(value);
        break;
      case 28:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsernickname(value);
        break;
      case 29:
        var value = /** @type {!proto.com.mu.logistic.api.PaymentType} */ (reader.readEnum());
        msg.setCompanytypetaskpayid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ResourceItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ResourceItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ResourceItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAdministrator();
  if (f) {
    writer.writeBool(1, f);
  }
  f = message.getCityid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getCityphone();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getCompanyresources();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getCompanyid();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getCountryresources();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getCreateat();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getResourcesemail();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getResourcesid();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getNumberid();
  if (f !== 0) {
    writer.writeInt32(10, f);
  }
  f = message.getLastvisitat();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getServicesnumber();
  if (f !== 0) {
    writer.writeInt32(14, f);
  }
  f = message.getUsersnumber();
  if (f !== 0) {
    writer.writeInt32(15, f);
  }
  f = message.getRolesnamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(16, f);
  }
  f = message.getRolesidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(17, f);
  }
  f = message.getResourcestatus();
  if (f !== 0) {
    writer.writeInt32(18, f);
  }
  f = message.getUserstatus();
  if (f !== 0) {
    writer.writeInt32(19, f);
  }
  f = message.getResourceterms();
  if (f) {
    writer.writeBool(20, f);
  }
  f = message.getTimeend();
  if (f !== 0) {
    writer.writeInt32(21, f);
  }
  f = message.getUsertype();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getViewservices();
  if (f.length > 0) {
    writer.writeString(24, f);
  }
  f = message.getTypetaskpayid();
  if (f !== 0.0) {
    writer.writeEnum(25, f);
  }
  f = message.getIdentification();
  if (f.length > 0) {
    writer.writeString(26, f);
  }
  f = message.getEnterprisegroupList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(27, f, proto.com.mu.logistic.api.EnterpriseGroup.serializeBinaryToWriter);
  }
  f = message.getUsernickname();
  if (f.length > 0) {
    writer.writeString(28, f);
  }
  f = message.getCompanytypetaskpayid();
  if (f !== 0.0) {
    writer.writeEnum(29, f);
  }
};

/**
 * optional bool administrator = 1;
 * @return {boolean}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getAdministrator = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setAdministrator = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

/**
 * optional string cityId = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCityid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCityid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string cityPhone = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCityphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCityphone = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string companyResources = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCompanyresources = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCompanyresources = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string companyId = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCompanyid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCompanyid = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional int32 countryResources = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCountryresources = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCountryresources = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional string createAt = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCreateat = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCreateat = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string resourcesEmail = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getResourcesemail = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setResourcesemail = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string resourcesId = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getResourcesid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setResourcesid = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional int32 numberId = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getNumberid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setNumberid = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional string lastvisitAt = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getLastvisitat = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setLastvisitat = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string companyName = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCompanyname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCompanyname = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string cityName = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCityname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCityname = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional int32 servicesNumber = 14;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getServicesnumber = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setServicesnumber = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};

/**
 * optional int32 usersNumber = 15;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getUsersnumber = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setUsersnumber = function (value) {
  jspb.Message.setProto3IntField(this, 15, value);
};

/**
 * repeated string rolesNames = 16;
 * @return {!Array<string>}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getRolesnamesList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};

/** @param {!Array<string>} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setRolesnamesList = function (value) {
  jspb.Message.setField(this, 16, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.com.mu.logistic.api.ResourceItem.prototype.addRolesnames = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.ResourceItem.prototype.clearRolesnamesList = function () {
  this.setRolesnamesList([]);
};

/**
 * repeated string rolesIds = 17;
 * @return {!Array<string>}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getRolesidsList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};

/** @param {!Array<string>} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setRolesidsList = function (value) {
  jspb.Message.setField(this, 17, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.com.mu.logistic.api.ResourceItem.prototype.addRolesids = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.ResourceItem.prototype.clearRolesidsList = function () {
  this.setRolesidsList([]);
};

/**
 * optional int32 resourceStatus = 18;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getResourcestatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setResourcestatus = function (value) {
  jspb.Message.setProto3IntField(this, 18, value);
};

/**
 * optional int32 userStatus = 19;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getUserstatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setUserstatus = function (value) {
  jspb.Message.setProto3IntField(this, 19, value);
};

/**
 * optional bool resourceTerms = 20;
 * @return {boolean}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getResourceterms = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setResourceterms = function (value) {
  jspb.Message.setProto3BooleanField(this, 20, value);
};

/**
 * optional int32 timeEnd = 21;
 * @return {number}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getTimeend = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setTimeend = function (value) {
  jspb.Message.setProto3IntField(this, 21, value);
};

/**
 * optional string userType = 22;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getUsertype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setUsertype = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string userName = 23;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getUsername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setUsername = function (value) {
  jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional string viewServices = 24;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getViewservices = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setViewservices = function (value) {
  jspb.Message.setProto3StringField(this, 24, value);
};

/**
 * optional PaymentType typeTaskPayId = 25;
 * @return {!proto.com.mu.logistic.api.PaymentType}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getTypetaskpayid = function () {
  return /** @type {!proto.com.mu.logistic.api.PaymentType} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};

/** @param {!proto.com.mu.logistic.api.PaymentType} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setTypetaskpayid = function (value) {
  jspb.Message.setProto3EnumField(this, 25, value);
};

/**
 * optional string identification = 26;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getIdentification = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setIdentification = function (value) {
  jspb.Message.setProto3StringField(this, 26, value);
};

/**
 * repeated EnterpriseGroup enterpriseGroup = 27;
 * @return {!Array<!proto.com.mu.logistic.api.EnterpriseGroup>}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getEnterprisegroupList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.EnterpriseGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.EnterpriseGroup, 27)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.EnterpriseGroup>} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setEnterprisegroupList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 27, value);
};

/**
 * @param {!proto.com.mu.logistic.api.EnterpriseGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.EnterpriseGroup}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.addEnterprisegroup = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.com.mu.logistic.api.EnterpriseGroup, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.ResourceItem.prototype.clearEnterprisegroupList = function () {
  this.setEnterprisegroupList([]);
};

/**
 * optional string userNickName = 28;
 * @return {string}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getUsernickname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setUsernickname = function (value) {
  jspb.Message.setProto3StringField(this, 28, value);
};

/**
 * optional PaymentType companyTypeTaskPayId = 29;
 * @return {!proto.com.mu.logistic.api.PaymentType}
 */
proto.com.mu.logistic.api.ResourceItem.prototype.getCompanytypetaskpayid = function () {
  return /** @type {!proto.com.mu.logistic.api.PaymentType} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};

/** @param {!proto.com.mu.logistic.api.PaymentType} value */
proto.com.mu.logistic.api.ResourceItem.prototype.setCompanytypetaskpayid = function (value) {
  jspb.Message.setProto3EnumField(this, 29, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.EnterpriseGroup.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.EnterpriseGroup.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.EnterpriseGroup} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.EnterpriseGroup.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        idcompany: jspb.Message.getFieldWithDefault(msg, 1, ''),
        didcompany: jspb.Message.getFieldWithDefault(msg, 2, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.EnterpriseGroup}
 */
proto.com.mu.logistic.api.EnterpriseGroup.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.EnterpriseGroup();
  return proto.com.mu.logistic.api.EnterpriseGroup.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.EnterpriseGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.EnterpriseGroup}
 */
proto.com.mu.logistic.api.EnterpriseGroup.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setIdcompany(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setDidcompany(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.EnterpriseGroup.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.EnterpriseGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.EnterpriseGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.EnterpriseGroup.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIdcompany();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getDidcompany();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional string idCompany = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.EnterpriseGroup.prototype.getIdcompany = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EnterpriseGroup.prototype.setIdcompany = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string didCompany = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.EnterpriseGroup.prototype.getDidcompany = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.EnterpriseGroup.prototype.setDidcompany = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetResourcesByUserResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetResourcesByUserResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetResourcesByUserResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.ResourceItem.toObject(includeInstance, f),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, 0),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetResourcesByUserResponse}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetResourcesByUserResponse();
  return proto.com.mu.logistic.api.GetResourcesByUserResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetResourcesByUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetResourcesByUserResponse}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.ResourceItem();
        reader.readMessage(value, proto.com.mu.logistic.api.ResourceItem.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetResourcesByUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetResourcesByUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.ResourceItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional ResourceItem data = 1;
 * @return {?proto.com.mu.logistic.api.ResourceItem}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.ResourceItem} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.ResourceItem, 1)
  );
};

/** @param {?proto.com.mu.logistic.api.ResourceItem|undefined} value */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 statusCode = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.getStatuscode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetResourcesByUserResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.NearbyCity.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.NearbyCity.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.NearbyCity} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.NearbyCity.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        name: jspb.Message.getFieldWithDefault(msg, 1, ''),
        namegeoapps: jspb.Message.getFieldWithDefault(msg, 2, ''),
        type: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.NearbyCity}
 */
proto.com.mu.logistic.api.NearbyCity.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.NearbyCity();
  return proto.com.mu.logistic.api.NearbyCity.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.NearbyCity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.NearbyCity}
 */
proto.com.mu.logistic.api.NearbyCity.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setNamegeoapps(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.NearbyCity.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.NearbyCity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.NearbyCity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.NearbyCity.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getNamegeoapps();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.NearbyCity.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.NearbyCity.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string nameGeoapps = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.NearbyCity.prototype.getNamegeoapps = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.NearbyCity.prototype.setNamegeoapps = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string type = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.NearbyCity.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.NearbyCity.prototype.setType = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.CityItem.repeatedFields_ = [8];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CityItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CityItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CityItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CityItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        cityid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        citybaseid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        cityiso: jspb.Message.getFieldWithDefault(msg, 3, ''),
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        cityname: jspb.Message.getFieldWithDefault(msg, 6, ''),
        geoappsname: jspb.Message.getFieldWithDefault(msg, 7, ''),
        nearbycityList: jspb.Message.toObjectList(msg.getNearbycityList(), proto.com.mu.logistic.api.NearbyCity.toObject, includeInstance),
        phone: jspb.Message.getFieldWithDefault(msg, 9, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CityItem}
 */
proto.com.mu.logistic.api.CityItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CityItem();
  return proto.com.mu.logistic.api.CityItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CityItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CityItem}
 */
proto.com.mu.logistic.api.CityItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCityid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCitybaseid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityiso(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityname(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setGeoappsname(value);
        break;
      case 8:
        var value = new proto.com.mu.logistic.api.NearbyCity();
        reader.readMessage(value, proto.com.mu.logistic.api.NearbyCity.deserializeBinaryFromReader);
        msg.addNearbycity(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setPhone(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CityItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CityItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CityItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CityItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCitybaseid();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getCityiso();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(4, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(5, f);
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getGeoappsname();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getNearbycityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(8, f, proto.com.mu.logistic.api.NearbyCity.serializeBinaryToWriter);
  }
  f = message.getPhone();
  if (f !== 0) {
    writer.writeInt64(9, f);
  }
};

/**
 * optional int32 cityId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CityItem.prototype.getCityid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CityItem.prototype.setCityid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 cityBaseId = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CityItem.prototype.getCitybaseid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CityItem.prototype.setCitybaseid = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string cityIso = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CityItem.prototype.getCityiso = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CityItem.prototype.setCityiso = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional double latitude = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.CityItem.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CityItem.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};

/**
 * optional double longitude = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CityItem.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CityItem.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};

/**
 * optional string cityName = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.CityItem.prototype.getCityname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CityItem.prototype.setCityname = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string geoAppsName = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.CityItem.prototype.getGeoappsname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CityItem.prototype.setGeoappsname = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * repeated NearbyCity nearbyCity = 8;
 * @return {!Array<!proto.com.mu.logistic.api.NearbyCity>}
 */
proto.com.mu.logistic.api.CityItem.prototype.getNearbycityList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.NearbyCity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.NearbyCity, 8)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.NearbyCity>} value */
proto.com.mu.logistic.api.CityItem.prototype.setNearbycityList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};

/**
 * @param {!proto.com.mu.logistic.api.NearbyCity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.NearbyCity}
 */
proto.com.mu.logistic.api.CityItem.prototype.addNearbycity = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.com.mu.logistic.api.NearbyCity, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.CityItem.prototype.clearNearbycityList = function () {
  this.setNearbycityList([]);
};

/**
 * optional int64 phone = 9;
 * @return {number}
 */
proto.com.mu.logistic.api.CityItem.prototype.getPhone = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CityItem.prototype.setPhone = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCitiesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCitiesRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCitiesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCitiesRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        status: jspb.Message.getFieldWithDefault(msg, 1, ''),
        countryid: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCitiesRequest}
 */
proto.com.mu.logistic.api.GetCitiesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCitiesRequest();
  return proto.com.mu.logistic.api.GetCitiesRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCitiesRequest}
 */
proto.com.mu.logistic.api.GetCitiesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCountryid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCitiesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCitiesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getCountryid();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCitiesRequest.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCitiesRequest.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int32 countryId = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCitiesRequest.prototype.getCountryid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCitiesRequest.prototype.setCountryid = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetCitiesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCitiesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCitiesResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCitiesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCitiesResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        dataList: jspb.Message.toObjectList(msg.getDataList(), proto.com.mu.logistic.api.CityItem.toObject, includeInstance),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, 0),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCitiesResponse}
 */
proto.com.mu.logistic.api.GetCitiesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCitiesResponse();
  return proto.com.mu.logistic.api.GetCitiesResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCitiesResponse}
 */
proto.com.mu.logistic.api.GetCitiesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.CityItem();
        reader.readMessage(value, proto.com.mu.logistic.api.CityItem.deserializeBinaryFromReader);
        msg.addData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCitiesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.CityItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * repeated CityItem data = 1;
 * @return {!Array<!proto.com.mu.logistic.api.CityItem>}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.getDataList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.CityItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.CityItem, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.CityItem>} value */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.setDataList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.CityItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.CityItem}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.addData = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.CityItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.clearDataList = function () {
  this.setDataList([]);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 statusCode = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.getStatuscode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetCitiesResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PermissionItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PermissionItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PermissionItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PermissionItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        aplication: jspb.Message.getFieldWithDefault(msg, 1, ''),
        description: jspb.Message.getFieldWithDefault(msg, 2, ''),
        module: jspb.Message.getFieldWithDefault(msg, 3, ''),
        name: jspb.Message.getFieldWithDefault(msg, 4, ''),
        permission: jspb.Message.getFieldWithDefault(msg, 5, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PermissionItem}
 */
proto.com.mu.logistic.api.PermissionItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PermissionItem();
  return proto.com.mu.logistic.api.PermissionItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PermissionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PermissionItem}
 */
proto.com.mu.logistic.api.PermissionItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAplication(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setModule(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setPermission(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PermissionItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PermissionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PermissionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PermissionItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAplication();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getModule();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getPermission();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
};

/**
 * optional string aplication = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.PermissionItem.prototype.getAplication = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PermissionItem.prototype.setAplication = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string description = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.PermissionItem.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PermissionItem.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string module = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.PermissionItem.prototype.getModule = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PermissionItem.prototype.setModule = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string name = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.PermissionItem.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PermissionItem.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string permission = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.PermissionItem.prototype.getPermission = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PermissionItem.prototype.setPermission = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.repeatedFields_ = [1, 2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PropertiesToFilterbyUser.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PropertiesToFilterbyUser} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PropertiesToFilterbyUser.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        filtersList: jspb.Message.toObjectList(msg.getFiltersList(), proto.com.mu.logistic.api.FiltersToDelivery.toObject, includeInstance),
        orderList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PropertiesToFilterbyUser}
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PropertiesToFilterbyUser();
  return proto.com.mu.logistic.api.PropertiesToFilterbyUser.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PropertiesToFilterbyUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PropertiesToFilterbyUser}
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.FiltersToDelivery();
        reader.readMessage(value, proto.com.mu.logistic.api.FiltersToDelivery.deserializeBinaryFromReader);
        msg.addFilters(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addOrder(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PropertiesToFilterbyUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PropertiesToFilterbyUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.FiltersToDelivery.serializeBinaryToWriter);
  }
  f = message.getOrderList();
  if (f.length > 0) {
    writer.writeRepeatedString(2, f);
  }
};

/**
 * repeated FiltersToDelivery filters = 1;
 * @return {!Array<!proto.com.mu.logistic.api.FiltersToDelivery>}
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.getFiltersList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.FiltersToDelivery>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.FiltersToDelivery, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.FiltersToDelivery>} value */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.setFiltersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.FiltersToDelivery=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.FiltersToDelivery}
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.addFilters = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.FiltersToDelivery, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.clearFiltersList = function () {
  this.setFiltersList([]);
};

/**
 * repeated string order = 2;
 * @return {!Array<string>}
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.getOrderList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};

/** @param {!Array<string>} value */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.setOrderList = function (value) {
  jspb.Message.setField(this, 2, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.addOrder = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.PropertiesToFilterbyUser.prototype.clearOrderList = function () {
  this.setOrderList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetPermissionsByUserIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        filtername: jspb.Message.getFieldWithDefault(msg, 2, ''),
        filtervalue: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetPermissionsByUserIdRequest}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetPermissionsByUserIdRequest();
  return proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetPermissionsByUserIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetPermissionsByUserIdRequest}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setFiltername(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setFiltervalue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetPermissionsByUserIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getFiltername();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getFiltervalue();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string filterName = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.getFiltername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.setFiltername = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string filterValue = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.getFiltervalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdRequest.prototype.setFiltervalue = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetPermissionsByUserIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        dataList: jspb.Message.toObjectList(msg.getDataList(), proto.com.mu.logistic.api.PermissionItem.toObject, includeInstance),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        properties: (f = msg.getProperties()) && proto.com.mu.logistic.api.PropertiesToFilterbyUser.toObject(includeInstance, f),
        statuscode: jspb.Message.getFieldWithDefault(msg, 6, ''),
        version: jspb.Message.getFieldWithDefault(msg, 7, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetPermissionsByUserIdResponse}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetPermissionsByUserIdResponse();
  return proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetPermissionsByUserIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetPermissionsByUserIdResponse}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.PermissionItem();
        reader.readMessage(value, proto.com.mu.logistic.api.PermissionItem.deserializeBinaryFromReader);
        msg.addData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = new proto.com.mu.logistic.api.PropertiesToFilterbyUser();
        reader.readMessage(value, proto.com.mu.logistic.api.PropertiesToFilterbyUser.deserializeBinaryFromReader);
        msg.setProperties(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatuscode(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetPermissionsByUserIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.PermissionItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getProperties();
  if (f != null) {
    writer.writeMessage(5, f, proto.com.mu.logistic.api.PropertiesToFilterbyUser.serializeBinaryToWriter);
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
};

/**
 * repeated PermissionItem data = 1;
 * @return {!Array<!proto.com.mu.logistic.api.PermissionItem>}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getDataList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.PermissionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.PermissionItem, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.PermissionItem>} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setDataList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.PermissionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.PermissionItem}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.addData = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.PermissionItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.clearDataList = function () {
  this.setDataList([]);
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional PropertiesToFilterbyUser properties = 5;
 * @return {?proto.com.mu.logistic.api.PropertiesToFilterbyUser}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getProperties = function () {
  return /** @type{?proto.com.mu.logistic.api.PropertiesToFilterbyUser} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.PropertiesToFilterbyUser, 5)
  );
};

/** @param {?proto.com.mu.logistic.api.PropertiesToFilterbyUser|undefined} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setProperties = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.clearProperties = function () {
  this.setProperties(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.hasProperties = function () {
  return jspb.Message.getField(this, 5) != null;
};

/**
 * optional string statusCode = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getStatuscode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string version = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetPermissionsByUserIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.Products.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.Products.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.Products} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.Products.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, ''),
        name: jspb.Message.getFieldWithDefault(msg, 2, ''),
        photourl: jspb.Message.getFieldWithDefault(msg, 3, ''),
        price: jspb.Message.getFieldWithDefault(msg, 4, ''),
        quantity: jspb.Message.getFieldWithDefault(msg, 5, ''),
        barcode: jspb.Message.getFieldWithDefault(msg, 6, ''),
        planogram: jspb.Message.getFieldWithDefault(msg, 7, ''),
        sku: jspb.Message.getFieldWithDefault(msg, 8, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.Products}
 */
proto.com.mu.logistic.api.Products.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.Products();
  return proto.com.mu.logistic.api.Products.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.Products} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.Products}
 */
proto.com.mu.logistic.api.Products.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setPhotourl(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setPrice(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setQuantity(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setBarcode(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlanogram(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setSku(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.Products.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.Products.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.Products} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.Products.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getPhotourl();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getQuantity();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getBarcode();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getPlanogram();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getId = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string photoUrl = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getPhotourl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setPhotourl = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string price = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setPrice = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string quantity = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getQuantity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setQuantity = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string barcode = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getBarcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setBarcode = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string planogram = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getPlanogram = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setPlanogram = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string sku = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.Products.prototype.getSku = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Products.prototype.setSku = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.repeatedFields_ = [26];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.TaskPlaceDelivery.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.TaskPlaceDelivery} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.TaskPlaceDelivery.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskplaceid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        address: jspb.Message.getFieldWithDefault(msg, 2, ''),
        addressstring: jspb.Message.getFieldWithDefault(msg, 3, ''),
        description: jspb.Message.getFieldWithDefault(msg, 4, ''),
        latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
        status: jspb.Message.getFieldWithDefault(msg, 7, ''),
        cityname: jspb.Message.getFieldWithDefault(msg, 8, ''),
        citynamelupap: jspb.Message.getFieldWithDefault(msg, 9, ''),
        clientname: jspb.Message.getFieldWithDefault(msg, 10, ''),
        clientphone: jspb.Message.getFieldWithDefault(msg, 11, ''),
        clientdocument: jspb.Message.getFieldWithDefault(msg, 12, ''),
        paymenttype: jspb.Message.getFieldWithDefault(msg, 13, ''),
        paymenttypename: jspb.Message.getFieldWithDefault(msg, 14, ''),
        productsvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
        orderid: jspb.Message.getFieldWithDefault(msg, 16, ''),
        token: jspb.Message.getFieldWithDefault(msg, 17, ''),
        tokentaskplace: jspb.Message.getFieldWithDefault(msg, 18, ''),
        finishedtype: jspb.Message.getFieldWithDefault(msg, 19, ''),
        finishedtypename: jspb.Message.getFieldWithDefault(msg, 20, ''),
        finishedstatus: jspb.Message.getFieldWithDefault(msg, 21, ''),
        finishedmessagge: jspb.Message.getFieldWithDefault(msg, 22, ''),
        evidence: jspb.Message.getFieldWithDefault(msg, 23, ''),
        waittime: jspb.Message.getFieldWithDefault(msg, 24, 0),
        productsList: jspb.Message.toObjectList(msg.getProductsList(), proto.com.mu.logistic.api.Products.toObject, includeInstance),
        statusid: jspb.Message.getFieldWithDefault(msg, 27, ''),
        lastupdated: jspb.Message.getFieldWithDefault(msg, 28, ''),
        typeid: jspb.Message.getFieldWithDefault(msg, 29, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.TaskPlaceDelivery}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.TaskPlaceDelivery();
  return proto.com.mu.logistic.api.TaskPlaceDelivery.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.TaskPlaceDelivery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.TaskPlaceDelivery}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskplaceid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddressstring(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLatitude(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLongitude(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityname(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setCitynamelupap(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientname(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientphone(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientdocument(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymenttype(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymenttypename(value);
        break;
      case 15:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setProductsvalue(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderid(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setToken(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setTokentaskplace(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinishedtype(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinishedtypename(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinishedstatus(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinishedmessagge(value);
        break;
      case 23:
        var value = /** @type {string} */ (reader.readString());
        msg.setEvidence(value);
        break;
      case 24:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setWaittime(value);
        break;
      case 26:
        var value = new proto.com.mu.logistic.api.Products();
        reader.readMessage(value, proto.com.mu.logistic.api.Products.deserializeBinaryFromReader);
        msg.addProducts(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatusid(value);
        break;
      case 28:
        var value = /** @type {string} */ (reader.readString());
        msg.setLastupdated(value);
        break;
      case 29:
        var value = /** @type {string} */ (reader.readString());
        msg.setTypeid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.TaskPlaceDelivery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.TaskPlaceDelivery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskplaceid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getAddressstring();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(5, f);
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(6, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getCitynamelupap();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getClientphone();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getClientdocument();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getPaymenttype();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getPaymenttypename();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getProductsvalue();
  if (f !== 0.0) {
    writer.writeDouble(15, f);
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getTokentaskplace();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getFinishedtype();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getFinishedtypename();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getFinishedstatus();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getFinishedmessagge();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getEvidence();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getWaittime();
  if (f !== 0) {
    writer.writeInt32(24, f);
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(26, f, proto.com.mu.logistic.api.Products.serializeBinaryToWriter);
  }
  f = message.getStatusid();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
  f = message.getLastupdated();
  if (f.length > 0) {
    writer.writeString(28, f);
  }
  f = message.getTypeid();
  if (f.length > 0) {
    writer.writeString(29, f);
  }
};

/**
 * optional int32 taskPlaceId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getTaskplaceid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setTaskplaceid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string address = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string addressString = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getAddressstring = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setAddressstring = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string description = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional double latitude = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getLatitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setLatitude = function (value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};

/**
 * optional double longitude = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getLongitude = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setLongitude = function (value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};

/**
 * optional string status = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string cityName = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getCityname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setCityname = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string cityNameLupap = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getCitynamelupap = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setCitynamelupap = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string clientName = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getClientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setClientname = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string clientPhone = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getClientphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setClientphone = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string clientDocument = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getClientdocument = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setClientdocument = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string paymentType = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getPaymenttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setPaymenttype = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string paymentTypeName = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getPaymenttypename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setPaymenttypename = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional double productsValue = 15;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getProductsvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setProductsvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 15, value);
};

/**
 * optional string orderId = 16;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getOrderid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setOrderid = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string token = 17;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getToken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setToken = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string tokenTaskplace = 18;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getTokentaskplace = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setTokentaskplace = function (value) {
  jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string finishedType = 19;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getFinishedtype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setFinishedtype = function (value) {
  jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string finishedTypeName = 20;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getFinishedtypename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setFinishedtypename = function (value) {
  jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string finishedStatus = 21;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getFinishedstatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setFinishedstatus = function (value) {
  jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string finishedMessagge = 22;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getFinishedmessagge = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setFinishedmessagge = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string evidence = 23;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getEvidence = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setEvidence = function (value) {
  jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional int32 waitTime = 24;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getWaittime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setWaittime = function (value) {
  jspb.Message.setProto3IntField(this, 24, value);
};

/**
 * repeated Products products = 26;
 * @return {!Array<!proto.com.mu.logistic.api.Products>}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getProductsList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.Products>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.Products, 26)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.Products>} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setProductsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 26, value);
};

/**
 * @param {!proto.com.mu.logistic.api.Products=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.Products}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.addProducts = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.com.mu.logistic.api.Products, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.clearProductsList = function () {
  this.setProductsList([]);
};

/**
 * optional string statusId = 27;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getStatusid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setStatusid = function (value) {
  jspb.Message.setProto3StringField(this, 27, value);
};

/**
 * optional string lastUpdated = 28;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getLastupdated = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setLastupdated = function (value) {
  jspb.Message.setProto3StringField(this, 28, value);
};

/**
 * optional string typeId = 29;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.getTypeid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskPlaceDelivery.prototype.setTypeid = function (value) {
  jspb.Message.setProto3StringField(this, 29, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.Resources.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.Resources.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.Resources} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.Resources.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        resourceid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        resourcesname: jspb.Message.getFieldWithDefault(msg, 3, ''),
        firstname: jspb.Message.getFieldWithDefault(msg, 4, ''),
        lastname: jspb.Message.getFieldWithDefault(msg, 5, ''),
        numberid: jspb.Message.getFieldWithDefault(msg, 6, ''),
        phone: jspb.Message.getFieldWithDefault(msg, 7, ''),
        phone2: jspb.Message.getFieldWithDefault(msg, 8, ''),
        platenumber: jspb.Message.getFieldWithDefault(msg, 9, ''),
        photo: jspb.Message.getFieldWithDefault(msg, 10, ''),
        typeresourcename: jspb.Message.getFieldWithDefault(msg, 11, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.Resources}
 */
proto.com.mu.logistic.api.Resources.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.Resources();
  return proto.com.mu.logistic.api.Resources.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.Resources} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.Resources}
 */
proto.com.mu.logistic.api.Resources.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setResourceid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setResourcesname(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setFirstname(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setLastname(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setNumberid(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setPhone(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setPhone2(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlatenumber(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setPhoto(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setTyperesourcename(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.Resources.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.Resources.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.Resources} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.Resources.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getResourceid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getResourcesname();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getFirstname();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getLastname();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getNumberid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getPhone2();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getPlatenumber();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getPhoto();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getTyperesourcename();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.Resources.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.Resources.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string resourceId = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getResourceid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setResourceid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string resourcesName = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getResourcesname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setResourcesname = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string firstName = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getFirstname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setFirstname = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string lastName = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getLastname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setLastname = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string numberId = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getNumberid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setNumberid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string phone = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getPhone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setPhone = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string phone2 = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getPhone2 = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setPhone2 = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string plateNumber = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getPlatenumber = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setPlatenumber = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string photo = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getPhoto = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setPhoto = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string typeResourceName = 11;
 * @return {string}
 */
proto.com.mu.logistic.api.Resources.prototype.getTyperesourcename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.Resources.prototype.setTyperesourcename = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.DataUserPlatform.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.DataUserPlatform.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.DataUserPlatform} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.DataUserPlatform.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        username: jspb.Message.getFieldWithDefault(msg, 2, ''),
        userphone: jspb.Message.getFieldWithDefault(msg, 3, ''),
        useremail: jspb.Message.getFieldWithDefault(msg, 4, ''),
        companyid: jspb.Message.getFieldWithDefault(msg, 5, 0),
        companyname: jspb.Message.getFieldWithDefault(msg, 6, ''),
        companyphone: jspb.Message.getFieldWithDefault(msg, 7, ''),
        companynit: jspb.Message.getFieldWithDefault(msg, 8, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.DataUserPlatform}
 */
proto.com.mu.logistic.api.DataUserPlatform.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.DataUserPlatform();
  return proto.com.mu.logistic.api.DataUserPlatform.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.DataUserPlatform} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.DataUserPlatform}
 */
proto.com.mu.logistic.api.DataUserPlatform.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsername(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setUserphone(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setUseremail(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCompanyid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyname(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyphone(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanynit(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.DataUserPlatform.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.DataUserPlatform} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.DataUserPlatform.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getUserphone();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getUseremail();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getCompanyphone();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getCompanynit();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string userName = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getUsername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setUsername = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string userPhone = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getUserphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setUserphone = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string userEmail = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getUseremail = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setUseremail = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 companyId = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getCompanyid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setCompanyid = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string companyName = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getCompanyname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setCompanyname = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string companyPhone = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getCompanyphone = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setCompanyphone = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string companyNit = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.DataUserPlatform.prototype.getCompanynit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.DataUserPlatform.prototype.setCompanynit = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ObservationItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ObservationItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ObservationItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ObservationItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        taskid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        creationdate: jspb.Message.getFieldWithDefault(msg, 3, ''),
        jsoncontent: jspb.Message.getFieldWithDefault(msg, 4, ''),
        historytype: jspb.Message.getFieldWithDefault(msg, 5, 0),
        creationuserid: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ObservationItem}
 */
proto.com.mu.logistic.api.ObservationItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ObservationItem();
  return proto.com.mu.logistic.api.ObservationItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ObservationItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ObservationItem}
 */
proto.com.mu.logistic.api.ObservationItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCreationdate(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setJsoncontent(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setHistorytype(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setCreationuserid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ObservationItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ObservationItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ObservationItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getCreationdate();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getJsoncontent();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getHistorytype();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getCreationuserid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ObservationItem.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 taskId = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ObservationItem.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string creationDate = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.getCreationdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ObservationItem.prototype.setCreationdate = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string jsonContent = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.getJsoncontent = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ObservationItem.prototype.setJsoncontent = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 historyType = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.getHistorytype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ObservationItem.prototype.setHistorytype = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string creationUserId = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.ObservationItem.prototype.getCreationuserid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ObservationItem.prototype.setCreationuserid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.TaskItem.repeatedFields_ = [41, 48];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.TaskItem.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.TaskItem.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.TaskItem} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.TaskItem.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        uuid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        ratingclient: jspb.Message.getFieldWithDefault(msg, 2, 0),
        cityid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        cityname: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statusid: jspb.Message.getFieldWithDefault(msg, 5, 0),
        statusname: jspb.Message.getFieldWithDefault(msg, 6, ''),
        description: jspb.Message.getFieldWithDefault(msg, 7, ''),
        startdate: jspb.Message.getFieldWithDefault(msg, 8, ''),
        starttime: jspb.Message.getFieldWithDefault(msg, 9, ''),
        distance: jspb.Message.getFieldWithDefault(msg, 10, 0),
        basevalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
        discountvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
        rating: jspb.Message.getFieldWithDefault(msg, 13, 0),
        ratingdistance: jspb.Message.getFieldWithDefault(msg, 14, 0),
        creationdate: jspb.Message.getFieldWithDefault(msg, 15, ''),
        servicetype: jspb.Message.getFieldWithDefault(msg, 16, 0),
        servicetypename: jspb.Message.getFieldWithDefault(msg, 17, ''),
        waytopay: jspb.Message.getFieldWithDefault(msg, 18, 0),
        waytopayname: jspb.Message.getFieldWithDefault(msg, 19, ''),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
        segmentationid: jspb.Message.getFieldWithDefault(msg, 21, 0),
        segmentationname: jspb.Message.getFieldWithDefault(msg, 22, ''),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
        ssresource: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
        typevipresource: jspb.Message.getFieldWithDefault(msg, 25, 0),
        resource: (f = msg.getResource()) && proto.com.mu.logistic.api.Resources.toObject(includeInstance, f),
        surchargestops: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
        surchargedistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
        safesurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
        extraminutessurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
        extratime: jspb.Message.getFieldWithDefault(msg, 31, 0),
        roundtripsurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
        parkingsurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0),
        nightfestivesurcharge: jspb.Message.getFloatingPointFieldWithDefault(msg, 34, 0.0),
        valuediscounts: jspb.Message.getFloatingPointFieldWithDefault(msg, 35, 0.0),
        totalservice: jspb.Message.getFloatingPointFieldWithDefault(msg, 36, 0.0),
        datauser: (f = msg.getDatauser()) && proto.com.mu.logistic.api.DataUserPlatform.toObject(includeInstance, f),
        usercreatorid: jspb.Message.getFieldWithDefault(msg, 38, ''),
        usercreatorname: jspb.Message.getFieldWithDefault(msg, 39, ''),
        os: jspb.Message.getFieldWithDefault(msg, 40, ''),
        taskplacesList: jspb.Message.toObjectList(
          msg.getTaskplacesList(),
          proto.com.mu.logistic.api.TaskPlaceDelivery.toObject,
          includeInstance
        ),
        numberrelaunches: jspb.Message.getFieldWithDefault(msg, 42, 0),
        bonusvaluerelaunches: jspb.Message.getFieldWithDefault(msg, 43, 0),
        promotionalcode: jspb.Message.getFieldWithDefault(msg, 44, ''),
        userexperience: jspb.Message.getFieldWithDefault(msg, 45, 0),
        actioncancel: jspb.Message.getBooleanFieldWithDefault(msg, 46, false),
        totalwaittime: jspb.Message.getFieldWithDefault(msg, 47, 0),
        observationList: jspb.Message.toObjectList(
          msg.getObservationList(),
          proto.com.mu.logistic.api.ObservationItem.toObject,
          includeInstance
        ),
        updateddatetime: jspb.Message.getFieldWithDefault(msg, 49, ''),
        ordertype: jspb.Message.getFieldWithDefault(msg, 50, 0),
        taskid: jspb.Message.getFieldWithDefault(msg, 51, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.TaskItem}
 */
proto.com.mu.logistic.api.TaskItem.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.TaskItem();
  return proto.com.mu.logistic.api.TaskItem.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.TaskItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.TaskItem}
 */
proto.com.mu.logistic.api.TaskItem.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setUuid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRatingclient(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCityname(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatusid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatusname(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setDistance(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setBasevalue(value);
        break;
      case 12:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDiscountvalue(value);
        break;
      case 13:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRating(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRatingdistance(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setCreationdate(value);
        break;
      case 16:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicetype(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setServicetypename(value);
        break;
      case 18:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setWaytopay(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setWaytopayname(value);
        break;
      case 20:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 21:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setSegmentationid(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setSegmentationname(value);
        break;
      case 23:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 24:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setSsresource(value);
        break;
      case 25:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypevipresource(value);
        break;
      case 26:
        var value = new proto.com.mu.logistic.api.Resources();
        reader.readMessage(value, proto.com.mu.logistic.api.Resources.deserializeBinaryFromReader);
        msg.setResource(value);
        break;
      case 27:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setSurchargestops(value);
        break;
      case 28:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setSurchargedistance(value);
        break;
      case 29:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setSafesurcharge(value);
        break;
      case 30:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setExtraminutessurcharge(value);
        break;
      case 31:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setExtratime(value);
        break;
      case 32:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setRoundtripsurcharge(value);
        break;
      case 33:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setParkingsurcharge(value);
        break;
      case 34:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setNightfestivesurcharge(value);
        break;
      case 35:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setValuediscounts(value);
        break;
      case 36:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalservice(value);
        break;
      case 37:
        var value = new proto.com.mu.logistic.api.DataUserPlatform();
        reader.readMessage(value, proto.com.mu.logistic.api.DataUserPlatform.deserializeBinaryFromReader);
        msg.setDatauser(value);
        break;
      case 38:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsercreatorid(value);
        break;
      case 39:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsercreatorname(value);
        break;
      case 40:
        var value = /** @type {string} */ (reader.readString());
        msg.setOs(value);
        break;
      case 41:
        var value = new proto.com.mu.logistic.api.TaskPlaceDelivery();
        reader.readMessage(value, proto.com.mu.logistic.api.TaskPlaceDelivery.deserializeBinaryFromReader);
        msg.addTaskplaces(value);
        break;
      case 42:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setNumberrelaunches(value);
        break;
      case 43:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setBonusvaluerelaunches(value);
        break;
      case 44:
        var value = /** @type {string} */ (reader.readString());
        msg.setPromotionalcode(value);
        break;
      case 45:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserexperience(value);
        break;
      case 46:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setActioncancel(value);
        break;
      case 47:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalwaittime(value);
        break;
      case 48:
        var value = new proto.com.mu.logistic.api.ObservationItem();
        reader.readMessage(value, proto.com.mu.logistic.api.ObservationItem.deserializeBinaryFromReader);
        msg.addObservation(value);
        break;
      case 49:
        var value = /** @type {string} */ (reader.readString());
        msg.setUpdateddatetime(value);
        break;
      case 50:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOrdertype(value);
        break;
      case 51:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.TaskItem.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.TaskItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.TaskItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.TaskItem.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getRatingclient();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getCityid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatusid();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getStatusname();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt64(10, f);
  }
  f = message.getBasevalue();
  if (f !== 0.0) {
    writer.writeDouble(11, f);
  }
  f = message.getDiscountvalue();
  if (f !== 0.0) {
    writer.writeDouble(12, f);
  }
  f = message.getRating();
  if (f !== 0) {
    writer.writeInt32(13, f);
  }
  f = message.getRatingdistance();
  if (f !== 0) {
    writer.writeInt32(14, f);
  }
  f = message.getCreationdate();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getServicetype();
  if (f !== 0) {
    writer.writeInt32(16, f);
  }
  f = message.getServicetypename();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getWaytopay();
  if (f !== 0) {
    writer.writeInt32(18, f);
  }
  f = message.getWaytopayname();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(20, f);
  }
  f = message.getSegmentationid();
  if (f !== 0) {
    writer.writeInt32(21, f);
  }
  f = message.getSegmentationname();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(23, f);
  }
  f = message.getSsresource();
  if (f) {
    writer.writeBool(24, f);
  }
  f = message.getTypevipresource();
  if (f !== 0) {
    writer.writeInt32(25, f);
  }
  f = message.getResource();
  if (f != null) {
    writer.writeMessage(26, f, proto.com.mu.logistic.api.Resources.serializeBinaryToWriter);
  }
  f = message.getSurchargestops();
  if (f !== 0.0) {
    writer.writeDouble(27, f);
  }
  f = message.getSurchargedistance();
  if (f !== 0.0) {
    writer.writeDouble(28, f);
  }
  f = message.getSafesurcharge();
  if (f !== 0.0) {
    writer.writeDouble(29, f);
  }
  f = message.getExtraminutessurcharge();
  if (f !== 0.0) {
    writer.writeDouble(30, f);
  }
  f = message.getExtratime();
  if (f !== 0) {
    writer.writeInt32(31, f);
  }
  f = message.getRoundtripsurcharge();
  if (f !== 0.0) {
    writer.writeDouble(32, f);
  }
  f = message.getParkingsurcharge();
  if (f !== 0.0) {
    writer.writeDouble(33, f);
  }
  f = message.getNightfestivesurcharge();
  if (f !== 0.0) {
    writer.writeDouble(34, f);
  }
  f = message.getValuediscounts();
  if (f !== 0.0) {
    writer.writeDouble(35, f);
  }
  f = message.getTotalservice();
  if (f !== 0.0) {
    writer.writeDouble(36, f);
  }
  f = message.getDatauser();
  if (f != null) {
    writer.writeMessage(37, f, proto.com.mu.logistic.api.DataUserPlatform.serializeBinaryToWriter);
  }
  f = message.getUsercreatorid();
  if (f.length > 0) {
    writer.writeString(38, f);
  }
  f = message.getUsercreatorname();
  if (f.length > 0) {
    writer.writeString(39, f);
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(40, f);
  }
  f = message.getTaskplacesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(41, f, proto.com.mu.logistic.api.TaskPlaceDelivery.serializeBinaryToWriter);
  }
  f = message.getNumberrelaunches();
  if (f !== 0) {
    writer.writeInt32(42, f);
  }
  f = message.getBonusvaluerelaunches();
  if (f !== 0) {
    writer.writeInt32(43, f);
  }
  f = message.getPromotionalcode();
  if (f.length > 0) {
    writer.writeString(44, f);
  }
  f = message.getUserexperience();
  if (f !== 0) {
    writer.writeInt32(45, f);
  }
  f = message.getActioncancel();
  if (f) {
    writer.writeBool(46, f);
  }
  f = message.getTotalwaittime();
  if (f !== 0) {
    writer.writeInt32(47, f);
  }
  f = message.getObservationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(48, f, proto.com.mu.logistic.api.ObservationItem.serializeBinaryToWriter);
  }
  f = message.getUpdateddatetime();
  if (f.length > 0) {
    writer.writeString(49, f);
  }
  f = message.getOrdertype();
  if (f !== 0) {
    writer.writeInt32(50, f);
  }
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(51, f);
  }
};

/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setUuid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int32 ratingClient = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getRatingclient = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setRatingclient = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string cityId = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getCityid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setCityid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string cityName = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getCityname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setCityname = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 statusId = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getStatusid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setStatusid = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string statusName = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getStatusname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setStatusname = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string description = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string startDate = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string startTime = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional int64 distance = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getDistance = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setDistance = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};

/**
 * optional double baseValue = 11;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getBasevalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setBasevalue = function (value) {
  jspb.Message.setProto3FloatField(this, 11, value);
};

/**
 * optional double discountValue = 12;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getDiscountvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setDiscountvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};

/**
 * optional int32 rating = 13;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getRating = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setRating = function (value) {
  jspb.Message.setProto3IntField(this, 13, value);
};

/**
 * optional int32 ratingDistance = 14;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getRatingdistance = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setRatingdistance = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};

/**
 * optional string creationDate = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getCreationdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setCreationdate = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional int32 serviceType = 16;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getServicetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setServicetype = function (value) {
  jspb.Message.setProto3IntField(this, 16, value);
};

/**
 * optional string serviceTypeName = 17;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getServicetypename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setServicetypename = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional int32 wayToPay = 18;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getWaytopay = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setWaytopay = function (value) {
  jspb.Message.setProto3IntField(this, 18, value);
};

/**
 * optional string wayToPayName = 19;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getWaytopayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setWaytopayname = function (value) {
  jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional double declaredValue = 20;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 20, value);
};

/**
 * optional int32 segmentationId = 21;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getSegmentationid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setSegmentationid = function (value) {
  jspb.Message.setProto3IntField(this, 21, value);
};

/**
 * optional string segmentationName = 22;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getSegmentationname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setSegmentationname = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional bool roundTrip = 23;
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.TaskItem.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 23, value);
};

/**
 * optional bool ssResource = 24;
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getSsresource = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.TaskItem.prototype.setSsresource = function (value) {
  jspb.Message.setProto3BooleanField(this, 24, value);
};

/**
 * optional int32 typeVipResource = 25;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getTypevipresource = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setTypevipresource = function (value) {
  jspb.Message.setProto3IntField(this, 25, value);
};

/**
 * optional Resources resource = 26;
 * @return {?proto.com.mu.logistic.api.Resources}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getResource = function () {
  return /** @type{?proto.com.mu.logistic.api.Resources} */ (jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.Resources, 26));
};

/** @param {?proto.com.mu.logistic.api.Resources|undefined} value */
proto.com.mu.logistic.api.TaskItem.prototype.setResource = function (value) {
  jspb.Message.setWrapperField(this, 26, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.TaskItem.prototype.clearResource = function () {
  this.setResource(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskItem.prototype.hasResource = function () {
  return jspb.Message.getField(this, 26) != null;
};

/**
 * optional double surchargeStops = 27;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getSurchargestops = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setSurchargestops = function (value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};

/**
 * optional double surchargeDistance = 28;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getSurchargedistance = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setSurchargedistance = function (value) {
  jspb.Message.setProto3FloatField(this, 28, value);
};

/**
 * optional double safeSurcharge = 29;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getSafesurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setSafesurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 29, value);
};

/**
 * optional double extraMinutesSurcharge = 30;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getExtraminutessurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setExtraminutessurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 30, value);
};

/**
 * optional int32 extraTime = 31;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getExtratime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setExtratime = function (value) {
  jspb.Message.setProto3IntField(this, 31, value);
};

/**
 * optional double roundTripSurcharge = 32;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getRoundtripsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setRoundtripsurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 32, value);
};

/**
 * optional double parkingSurcharge = 33;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getParkingsurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setParkingsurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 33, value);
};

/**
 * optional double nightFestiveSurcharge = 34;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getNightfestivesurcharge = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setNightfestivesurcharge = function (value) {
  jspb.Message.setProto3FloatField(this, 34, value);
};

/**
 * optional double valueDiscounts = 35;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getValuediscounts = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 35, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setValuediscounts = function (value) {
  jspb.Message.setProto3FloatField(this, 35, value);
};

/**
 * optional double totalService = 36;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getTotalservice = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 36, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setTotalservice = function (value) {
  jspb.Message.setProto3FloatField(this, 36, value);
};

/**
 * optional DataUserPlatform dataUser = 37;
 * @return {?proto.com.mu.logistic.api.DataUserPlatform}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getDatauser = function () {
  return /** @type{?proto.com.mu.logistic.api.DataUserPlatform} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.DataUserPlatform, 37)
  );
};

/** @param {?proto.com.mu.logistic.api.DataUserPlatform|undefined} value */
proto.com.mu.logistic.api.TaskItem.prototype.setDatauser = function (value) {
  jspb.Message.setWrapperField(this, 37, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.TaskItem.prototype.clearDatauser = function () {
  this.setDatauser(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskItem.prototype.hasDatauser = function () {
  return jspb.Message.getField(this, 37) != null;
};

/**
 * optional string userCreatorId = 38;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getUsercreatorid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setUsercreatorid = function (value) {
  jspb.Message.setProto3StringField(this, 38, value);
};

/**
 * optional string userCreatorName = 39;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getUsercreatorname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setUsercreatorname = function (value) {
  jspb.Message.setProto3StringField(this, 39, value);
};

/**
 * optional string os = 40;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getOs = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setOs = function (value) {
  jspb.Message.setProto3StringField(this, 40, value);
};

/**
 * repeated TaskPlaceDelivery taskPlaces = 41;
 * @return {!Array<!proto.com.mu.logistic.api.TaskPlaceDelivery>}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getTaskplacesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.TaskPlaceDelivery>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.TaskPlaceDelivery, 41)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.TaskPlaceDelivery>} value */
proto.com.mu.logistic.api.TaskItem.prototype.setTaskplacesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 41, value);
};

/**
 * @param {!proto.com.mu.logistic.api.TaskPlaceDelivery=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.TaskPlaceDelivery}
 */
proto.com.mu.logistic.api.TaskItem.prototype.addTaskplaces = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 41, opt_value, proto.com.mu.logistic.api.TaskPlaceDelivery, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.TaskItem.prototype.clearTaskplacesList = function () {
  this.setTaskplacesList([]);
};

/**
 * optional int32 numberRelaunches = 42;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getNumberrelaunches = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setNumberrelaunches = function (value) {
  jspb.Message.setProto3IntField(this, 42, value);
};

/**
 * optional int32 bonusValueRelaunches = 43;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getBonusvaluerelaunches = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setBonusvaluerelaunches = function (value) {
  jspb.Message.setProto3IntField(this, 43, value);
};

/**
 * optional string promotionalCode = 44;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getPromotionalcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setPromotionalcode = function (value) {
  jspb.Message.setProto3StringField(this, 44, value);
};

/**
 * optional int32 userExperience = 45;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getUserexperience = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setUserexperience = function (value) {
  jspb.Message.setProto3IntField(this, 45, value);
};

/**
 * optional bool actionCancel = 46;
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getActioncancel = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 46, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.TaskItem.prototype.setActioncancel = function (value) {
  jspb.Message.setProto3BooleanField(this, 46, value);
};

/**
 * optional int32 totalWaitTime = 47;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getTotalwaittime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setTotalwaittime = function (value) {
  jspb.Message.setProto3IntField(this, 47, value);
};

/**
 * repeated ObservationItem observation = 48;
 * @return {!Array<!proto.com.mu.logistic.api.ObservationItem>}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getObservationList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.ObservationItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.ObservationItem, 48)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.ObservationItem>} value */
proto.com.mu.logistic.api.TaskItem.prototype.setObservationList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 48, value);
};

/**
 * @param {!proto.com.mu.logistic.api.ObservationItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.ObservationItem}
 */
proto.com.mu.logistic.api.TaskItem.prototype.addObservation = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 48, opt_value, proto.com.mu.logistic.api.ObservationItem, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.TaskItem.prototype.clearObservationList = function () {
  this.setObservationList([]);
};

/**
 * optional string updatedDateTime = 49;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getUpdateddatetime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskItem.prototype.setUpdateddatetime = function (value) {
  jspb.Message.setProto3StringField(this, 49, value);
};

/**
 * optional int32 orderType = 50;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getOrdertype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setOrdertype = function (value) {
  jspb.Message.setProto3IntField(this, 50, value);
};

/**
 * optional int32 taskId = 51;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskItem.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskItem.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 51, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest();
  return proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.prototype.getId = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdRequest.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        data: (f = msg.getData()) && proto.com.mu.logistic.api.TaskItem.toObject(includeInstance, f),
        requesterurl: jspb.Message.getFieldWithDefault(msg, 2, ''),
        apimessage: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statuscode: jspb.Message.getFieldWithDefault(msg, 5, ''),
        version: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse();
  return proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.TaskItem();
        reader.readMessage(value, proto.com.mu.logistic.api.TaskItem.deserializeBinaryFromReader);
        msg.setData(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRequesterurl(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setApimessage(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatuscode(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setVersion(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(1, f, proto.com.mu.logistic.api.TaskItem.serializeBinaryToWriter);
  }
  f = message.getRequesterurl();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getApimessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional TaskItem data = 1;
 * @return {?proto.com.mu.logistic.api.TaskItem}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.getData = function () {
  return /** @type{?proto.com.mu.logistic.api.TaskItem} */ (jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.TaskItem, 1));
};

/** @param {?proto.com.mu.logistic.api.TaskItem|undefined} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.setData = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.clearData = function () {
  this.setData(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.hasData = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional string requesterUrl = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.getRequesterurl = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.setRequesterurl = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string apiMessage = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.getApimessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.setApimessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string status = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string statusCode = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.getStatuscode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.setStatuscode = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string version = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.getVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByIdResponse.prototype.setVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.CreateExpressRequest.repeatedFields_ = [11, 13];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CreateExpressRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CreateExpressRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CreateExpressRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CreateExpressRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        usercreate: jspb.Message.getFieldWithDefault(msg, 2, 0),
        typeservice: jspb.Message.getFieldWithDefault(msg, 3, 0),
        roundtrip: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
        declaredvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
        cityid: jspb.Message.getFieldWithDefault(msg, 6, 0),
        starttime: jspb.Message.getFieldWithDefault(msg, 7, ''),
        startdate: jspb.Message.getFieldWithDefault(msg, 8, ''),
        description: jspb.Message.getFieldWithDefault(msg, 9, ''),
        promotionalcode: jspb.Message.getFieldWithDefault(msg, 10, ''),
        coordinatesList: jspb.Message.toObjectList(
          msg.getCoordinatesList(),
          proto.com.mu.logistic.api.CoordinateExpress.toObject,
          includeInstance
        ),
        segmentation: jspb.Message.getFieldWithDefault(msg, 12, 0),
        utmsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
        pay: (f = msg.getPay()) && proto.com.mu.logistic.api.PaymentInfo.toObject(includeInstance, f),
        cc: jspb.Message.getFieldWithDefault(msg, 15, ''),
        application: jspb.Message.getFieldWithDefault(msg, 16, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CreateExpressRequest}
 */
proto.com.mu.logistic.api.CreateExpressRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CreateExpressRequest();
  return proto.com.mu.logistic.api.CreateExpressRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CreateExpressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CreateExpressRequest}
 */
proto.com.mu.logistic.api.CreateExpressRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUsercreate(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypeservice(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setRoundtrip(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setDeclaredvalue(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCityid(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setStarttime(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setStartdate(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setPromotionalcode(value);
        break;
      case 11:
        var value = new proto.com.mu.logistic.api.CoordinateExpress();
        reader.readMessage(value, proto.com.mu.logistic.api.CoordinateExpress.deserializeBinaryFromReader);
        msg.addCoordinates(value);
        break;
      case 12:
        var value = /** @type {!proto.com.mu.logistic.api.SegmentationType} */ (reader.readEnum());
        msg.setSegmentation(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.addUtms(value);
        break;
      case 14:
        var value = new proto.com.mu.logistic.api.PaymentInfo();
        reader.readMessage(value, proto.com.mu.logistic.api.PaymentInfo.deserializeBinaryFromReader);
        msg.setPay(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setCc(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setApplication(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CreateExpressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CreateExpressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CreateExpressRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getUsercreate();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getTypeservice();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getRoundtrip();
  if (f) {
    writer.writeBool(4, f);
  }
  f = message.getDeclaredvalue();
  if (f !== 0.0) {
    writer.writeDouble(5, f);
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getPromotionalcode();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(11, f, proto.com.mu.logistic.api.CoordinateExpress.serializeBinaryToWriter);
  }
  f = message.getSegmentation();
  if (f !== 0.0) {
    writer.writeEnum(12, f);
  }
  f = message.getUtmsList();
  if (f.length > 0) {
    writer.writeRepeatedString(13, f);
  }
  f = message.getPay();
  if (f != null) {
    writer.writeMessage(14, f, proto.com.mu.logistic.api.PaymentInfo.serializeBinaryToWriter);
  }
  f = message.getCc();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 userCreate = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getUsercreate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setUsercreate = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 typeService = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getTypeservice = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setTypeservice = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional bool roundTrip = 4;
 * @return {boolean}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getRoundtrip = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setRoundtrip = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

/**
 * optional double declaredValue = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getDeclaredvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setDeclaredvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 5, value);
};

/**
 * optional int32 cityId = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getCityid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setCityid = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional string startTime = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getStarttime = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setStarttime = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string startDate = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getStartdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setStartdate = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string description = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string promotionalCode = 10;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getPromotionalcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setPromotionalcode = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * repeated CoordinateExpress coordinates = 11;
 * @return {!Array<!proto.com.mu.logistic.api.CoordinateExpress>}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getCoordinatesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.CoordinateExpress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.CoordinateExpress, 11)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.CoordinateExpress>} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setCoordinatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 11, value);
};

/**
 * @param {!proto.com.mu.logistic.api.CoordinateExpress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.CoordinateExpress}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.addCoordinates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.com.mu.logistic.api.CoordinateExpress, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.clearCoordinatesList = function () {
  this.setCoordinatesList([]);
};

/**
 * optional SegmentationType segmentation = 12;
 * @return {!proto.com.mu.logistic.api.SegmentationType}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getSegmentation = function () {
  return /** @type {!proto.com.mu.logistic.api.SegmentationType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};

/** @param {!proto.com.mu.logistic.api.SegmentationType} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setSegmentation = function (value) {
  jspb.Message.setProto3EnumField(this, 12, value);
};

/**
 * repeated string utms = 13;
 * @return {!Array<string>}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getUtmsList = function () {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};

/** @param {!Array<string>} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setUtmsList = function (value) {
  jspb.Message.setField(this, 13, value || []);
};

/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.addUtms = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.clearUtmsList = function () {
  this.setUtmsList([]);
};

/**
 * optional PaymentInfo pay = 14;
 * @return {?proto.com.mu.logistic.api.PaymentInfo}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getPay = function () {
  return /** @type{?proto.com.mu.logistic.api.PaymentInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.PaymentInfo, 14)
  );
};

/** @param {?proto.com.mu.logistic.api.PaymentInfo|undefined} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setPay = function (value) {
  jspb.Message.setWrapperField(this, 14, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.clearPay = function () {
  this.setPay(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.hasPay = function () {
  return jspb.Message.getField(this, 14) != null;
};

/**
 * optional string cc = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getCc = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setCc = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string application = 16;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.getApplication = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressRequest.prototype.setApplication = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CreateExpressResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CreateExpressResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CreateExpressResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CreateExpressResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        uuid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        totalservice: jspb.Message.getFieldWithDefault(msg, 3, 0),
        servicesstatus: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statusinfo: (f = msg.getStatusinfo()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CreateExpressResponse}
 */
proto.com.mu.logistic.api.CreateExpressResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CreateExpressResponse();
  return proto.com.mu.logistic.api.CreateExpressResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CreateExpressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CreateExpressResponse}
 */
proto.com.mu.logistic.api.CreateExpressResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setUuid(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setTotalservice(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setServicesstatus(value);
        break;
      case 5:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatusinfo(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CreateExpressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CreateExpressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CreateExpressResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getTotalservice();
  if (f !== 0) {
    writer.writeInt64(3, f);
  }
  f = message.getServicesstatus();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatusinfo();
  if (f != null) {
    writer.writeMessage(5, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.setUuid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int64 totalService = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.getTotalservice = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.setTotalservice = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string servicesStatus = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.getServicesstatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.setServicesstatus = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional StatusInfoResponse statusInfo = 5;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.getStatusinfo = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 5)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.setStatusinfo = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.clearStatusinfo = function () {
  this.setStatusinfo(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.CreateExpressResponse.prototype.hasStatusinfo = function () {
  return jspb.Message.getField(this, 5) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CoordinateExpress.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CoordinateExpress.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CoordinateExpress} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CoordinateExpress.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        address: jspb.Message.getFieldWithDefault(msg, 1, ''),
        longitude: jspb.Message.getFieldWithDefault(msg, 2, ''),
        latitude: jspb.Message.getFieldWithDefault(msg, 3, ''),
        description: jspb.Message.getFieldWithDefault(msg, 4, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CoordinateExpress}
 */
proto.com.mu.logistic.api.CoordinateExpress.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CoordinateExpress();
  return proto.com.mu.logistic.api.CoordinateExpress.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CoordinateExpress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CoordinateExpress}
 */
proto.com.mu.logistic.api.CoordinateExpress.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAddress(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongitude(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setLatitude(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CoordinateExpress.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CoordinateExpress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CoordinateExpress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CoordinateExpress.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getLongitude();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getLatitude();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
};

/**
 * optional string address = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinateExpress.prototype.getAddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinateExpress.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string longitude = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinateExpress.prototype.getLongitude = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinateExpress.prototype.setLongitude = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string latitude = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinateExpress.prototype.getLatitude = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinateExpress.prototype.setLatitude = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string description = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.CoordinateExpress.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CoordinateExpress.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PaymentInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PaymentInfo.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PaymentInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PaymentInfo.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        paymenttype: jspb.Message.getFieldWithDefault(msg, 1, 0),
        cartid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        tokensecure: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PaymentInfo}
 */
proto.com.mu.logistic.api.PaymentInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PaymentInfo();
  return proto.com.mu.logistic.api.PaymentInfo.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PaymentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PaymentInfo}
 */
proto.com.mu.logistic.api.PaymentInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!proto.com.mu.logistic.api.PaymentType} */ (reader.readEnum());
        msg.setPaymenttype(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCartid(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setTokensecure(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PaymentInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PaymentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PaymentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PaymentInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPaymenttype();
  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
  f = message.getCartid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getTokensecure();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional PaymentType paymentType = 1;
 * @return {!proto.com.mu.logistic.api.PaymentType}
 */
proto.com.mu.logistic.api.PaymentInfo.prototype.getPaymenttype = function () {
  return /** @type {!proto.com.mu.logistic.api.PaymentType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {!proto.com.mu.logistic.api.PaymentType} value */
proto.com.mu.logistic.api.PaymentInfo.prototype.setPaymenttype = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};

/**
 * optional string cartId = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.PaymentInfo.prototype.getCartid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PaymentInfo.prototype.setCartid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string tokenSecure = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.PaymentInfo.prototype.getTokensecure = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.PaymentInfo.prototype.setTokensecure = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetOrderTypesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetOrderTypesRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetOrderTypesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetOrderTypesRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetOrderTypesRequest}
 */
proto.com.mu.logistic.api.GetOrderTypesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetOrderTypesRequest();
  return proto.com.mu.logistic.api.GetOrderTypesRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetOrderTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetOrderTypesRequest}
 */
proto.com.mu.logistic.api.GetOrderTypesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetOrderTypesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetOrderTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetOrderTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetOrderTypesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetOrderTypesResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetOrderTypesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetOrderTypesResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        ordertypesList: jspb.Message.toObjectList(msg.getOrdertypesList(), proto.com.mu.logistic.api.OrderType.toObject, includeInstance),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetOrderTypesResponse}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetOrderTypesResponse();
  return proto.com.mu.logistic.api.GetOrderTypesResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetOrderTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetOrderTypesResponse}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.OrderType();
        reader.readMessage(value, proto.com.mu.logistic.api.OrderType.deserializeBinaryFromReader);
        msg.addOrdertypes(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetOrderTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetOrderTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrdertypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.OrderType.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * repeated OrderType orderTypes = 1;
 * @return {!Array<!proto.com.mu.logistic.api.OrderType>}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.getOrdertypesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.OrderType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.OrderType, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.OrderType>} value */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.setOrdertypesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.OrderType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.OrderType}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.addOrdertypes = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.OrderType, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.clearOrdertypesList = function () {
  this.setOrdertypesList([]);
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetOrderTypesResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.OrderType.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.OrderType.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.OrderType} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.OrderType.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        name: jspb.Message.getFieldWithDefault(msg, 2, ''),
        description: jspb.Message.getFieldWithDefault(msg, 3, ''),
        status: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
        createDate: jspb.Message.getFieldWithDefault(msg, 5, ''),
        updateDate: jspb.Message.getFieldWithDefault(msg, 6, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.OrderType}
 */
proto.com.mu.logistic.api.OrderType.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.OrderType();
  return proto.com.mu.logistic.api.OrderType.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.OrderType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.OrderType}
 */
proto.com.mu.logistic.api.OrderType.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setStatus(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setCreateDate(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setUpdateDate(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.OrderType.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.OrderType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.OrderType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.OrderType.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(4, f);
  }
  f = message.getCreateDate();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getUpdateDate();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.OrderType.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.OrderType.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.OrderType.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OrderType.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string description = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.OrderType.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OrderType.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional bool status = 4;
 * @return {boolean}
 */
proto.com.mu.logistic.api.OrderType.prototype.getStatus = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.OrderType.prototype.setStatus = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

/**
 * optional string create_date = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.OrderType.prototype.getCreateDate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OrderType.prototype.setCreateDate = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string update_date = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.OrderType.prototype.getUpdateDate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.OrderType.prototype.setUpdateDate = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetExpressTaskHistoryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetExpressTaskHistoryRequest}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetExpressTaskHistoryRequest();
  return proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetExpressTaskHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetExpressTaskHistoryRequest}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetExpressTaskHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetExpressTaskHistoryRequest.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetExpressTaskHistoryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        historyList: jspb.Message.toObjectList(msg.getHistoryList(), proto.com.mu.logistic.api.TaskHistory.toObject, includeInstance),
        statusinfo: (f = msg.getStatusinfo()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetExpressTaskHistoryResponse}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetExpressTaskHistoryResponse();
  return proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetExpressTaskHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetExpressTaskHistoryResponse}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.TaskHistory();
        reader.readMessage(value, proto.com.mu.logistic.api.TaskHistory.deserializeBinaryFromReader);
        msg.addHistory(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatusinfo(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetExpressTaskHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.TaskHistory.serializeBinaryToWriter);
  }
  f = message.getStatusinfo();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * repeated TaskHistory history = 1;
 * @return {!Array<!proto.com.mu.logistic.api.TaskHistory>}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.getHistoryList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.TaskHistory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.TaskHistory, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.TaskHistory>} value */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.setHistoryList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.TaskHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.TaskHistory}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.addHistory = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.TaskHistory, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.clearHistoryList = function () {
  this.setHistoryList([]);
};

/**
 * optional StatusInfoResponse statusInfo = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.getStatusinfo = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.setStatusinfo = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.clearStatusinfo = function () {
  this.setStatusinfo(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetExpressTaskHistoryResponse.prototype.hasStatusinfo = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.TaskHistory.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.TaskHistory.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.TaskHistory} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.TaskHistory.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        usercreate: jspb.Message.getFieldWithDefault(msg, 2, 0),
        usercreatename: jspb.Message.getFieldWithDefault(msg, 3, ''),
        usercreatetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
        utcdate: jspb.Message.getFieldWithDefault(msg, 5, ''),
        typeid: jspb.Message.getFieldWithDefault(msg, 6, 0),
        typename: jspb.Message.getFieldWithDefault(msg, 7, ''),
        typedescription: jspb.Message.getFieldWithDefault(msg, 8, ''),
        generaltype: jspb.Message.getFieldWithDefault(msg, 9, 0),
        content: (f = msg.getContent()) && proto.com.mu.logistic.api.TaskContent.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.TaskHistory}
 */
proto.com.mu.logistic.api.TaskHistory.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.TaskHistory();
  return proto.com.mu.logistic.api.TaskHistory.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.TaskHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.TaskHistory}
 */
proto.com.mu.logistic.api.TaskHistory.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUsercreate(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsercreatename(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUsercreatetype(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setUtcdate(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypeid(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setTypename(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setTypedescription(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setGeneraltype(value);
        break;
      case 10:
        var value = new proto.com.mu.logistic.api.TaskContent();
        reader.readMessage(value, proto.com.mu.logistic.api.TaskContent.deserializeBinaryFromReader);
        msg.setContent(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.TaskHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.TaskHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.TaskHistory.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getUsercreate();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getUsercreatename();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getUsercreatetype();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getUtcdate();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getTypeid();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getTypename();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getTypedescription();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getGeneraltype();
  if (f !== 0) {
    writer.writeInt32(9, f);
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(10, f, proto.com.mu.logistic.api.TaskContent.serializeBinaryToWriter);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 userCreate = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getUsercreate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setUsercreate = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string userCreateName = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getUsercreatename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setUsercreatename = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 userCreateType = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getUsercreatetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setUsercreatetype = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string utcDate = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getUtcdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setUtcdate = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional int32 typeId = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getTypeid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setTypeid = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional string typeName = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getTypename = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setTypename = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string typeDescription = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getTypedescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setTypedescription = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional int32 generalType = 9;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getGeneraltype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setGeneraltype = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};

/**
 * optional TaskContent content = 10;
 * @return {?proto.com.mu.logistic.api.TaskContent}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.getContent = function () {
  return /** @type{?proto.com.mu.logistic.api.TaskContent} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.TaskContent, 10)
  );
};

/** @param {?proto.com.mu.logistic.api.TaskContent|undefined} value */
proto.com.mu.logistic.api.TaskHistory.prototype.setContent = function (value) {
  jspb.Message.setWrapperField(this, 10, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.TaskHistory.prototype.clearContent = function () {
  this.setContent(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskHistory.prototype.hasContent = function () {
  return jspb.Message.getField(this, 10) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.TaskContent.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.TaskContent.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.TaskContent} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.TaskContent.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        messenger: jspb.Message.getFieldWithDefault(msg, 1, ''),
        idresource: jspb.Message.getFieldWithDefault(msg, 2, 0),
        title: jspb.Message.getFieldWithDefault(msg, 3, ''),
        description: jspb.Message.getFieldWithDefault(msg, 4, ''),
        penalty: jspb.Message.getFieldWithDefault(msg, 5, ''),
        finishreasonid: jspb.Message.getFieldWithDefault(msg, 6, 0),
        finishreasonname: jspb.Message.getFieldWithDefault(msg, 7, ''),
        finishstatus: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.TaskContent}
 */
proto.com.mu.logistic.api.TaskContent.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.TaskContent();
  return proto.com.mu.logistic.api.TaskContent.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.TaskContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.TaskContent}
 */
proto.com.mu.logistic.api.TaskContent.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setMessenger(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setIdresource(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setTitle(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setPenalty(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setFinishreasonid(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setFinishreasonname(value);
        break;
      case 8:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setFinishstatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.TaskContent.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.TaskContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.TaskContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.TaskContent.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMessenger();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getIdresource();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getPenalty();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getFinishreasonid();
  if (f !== 0) {
    writer.writeInt32(6, f);
  }
  f = message.getFinishreasonname();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getFinishstatus();
  if (f) {
    writer.writeBool(8, f);
  }
};

/**
 * optional string messenger = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getMessenger = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskContent.prototype.setMessenger = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int32 idResource = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getIdresource = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskContent.prototype.setIdresource = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string title = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getTitle = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskContent.prototype.setTitle = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string description = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskContent.prototype.setDescription = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string penalty = 5;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getPenalty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskContent.prototype.setPenalty = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional int32 finishReasonId = 6;
 * @return {number}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getFinishreasonid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.TaskContent.prototype.setFinishreasonid = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};

/**
 * optional string finishReasonName = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getFinishreasonname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.TaskContent.prototype.setFinishreasonname = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional bool finishStatus = 8;
 * @return {boolean}
 */
proto.com.mu.logistic.api.TaskContent.prototype.getFinishstatus = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.TaskContent.prototype.setFinishstatus = function (value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.FilterExpressList.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.FilterExpressList.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.FilterExpressList.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.FilterExpressList} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.FilterExpressList.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        statusList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.FilterExpressList}
 */
proto.com.mu.logistic.api.FilterExpressList.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.FilterExpressList();
  return proto.com.mu.logistic.api.FilterExpressList.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.FilterExpressList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.FilterExpressList}
 */
proto.com.mu.logistic.api.FilterExpressList.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
        msg.setStatusList(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.FilterExpressList.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.FilterExpressList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.FilterExpressList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.FilterExpressList.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writePackedInt32(1, f);
  }
};

/**
 * repeated int32 status = 1;
 * @return {!Array<number>}
 */
proto.com.mu.logistic.api.FilterExpressList.prototype.getStatusList = function () {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};

/** @param {!Array<number>} value */
proto.com.mu.logistic.api.FilterExpressList.prototype.setStatusList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};

/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.com.mu.logistic.api.FilterExpressList.prototype.addStatus = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.FilterExpressList.prototype.clearStatusList = function () {
  this.setStatusList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.ExpressService.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.ExpressService.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.ExpressService} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.ExpressService.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        uuid: jspb.Message.getFieldWithDefault(msg, 2, ''),
        typetaskid: jspb.Message.getFieldWithDefault(msg, 3, 0),
        creationdate: jspb.Message.getFieldWithDefault(msg, 4, ''),
        statusid: jspb.Message.getFieldWithDefault(msg, 5, 0),
        statusname: jspb.Message.getFieldWithDefault(msg, 6, ''),
        sourceaddress: jspb.Message.getFieldWithDefault(msg, 7, ''),
        destinationaddress: jspb.Message.getFieldWithDefault(msg, 8, ''),
        clientname: jspb.Message.getFieldWithDefault(msg, 9, ''),
        totalvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
        paymentmethod: jspb.Message.getFieldWithDefault(msg, 11, 0),
        paymentmethodname: jspb.Message.getFieldWithDefault(msg, 12, ''),
        city: jspb.Message.getFieldWithDefault(msg, 13, ''),
        franchise: jspb.Message.getFieldWithDefault(msg, 14, ''),
        lastdigitscard: jspb.Message.getFieldWithDefault(msg, 15, ''),
        destinationcity: jspb.Message.getFieldWithDefault(msg, 16, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.ExpressService}
 */
proto.com.mu.logistic.api.ExpressService.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.ExpressService();
  return proto.com.mu.logistic.api.ExpressService.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.ExpressService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.ExpressService}
 */
proto.com.mu.logistic.api.ExpressService.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setUuid(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTypetaskid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCreationdate(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setStatusid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatusname(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setSourceaddress(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setDestinationaddress(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientname(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalvalue(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPaymentmethod(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymentmethodname(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setFranchise(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setLastdigitscard(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setDestinationcity(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.ExpressService.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.ExpressService.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.ExpressService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.ExpressService.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getTypetaskid();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getCreationdate();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getStatusid();
  if (f !== 0) {
    writer.writeInt32(5, f);
  }
  f = message.getStatusname();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getSourceaddress();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getDestinationaddress();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getTotalvalue();
  if (f !== 0.0) {
    writer.writeDouble(10, f);
  }
  f = message.getPaymentmethod();
  if (f !== 0) {
    writer.writeInt32(11, f);
  }
  f = message.getPaymentmethodname();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getFranchise();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getLastdigitscard();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getDestinationcity();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ExpressService.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setUuid = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 typeTaskId = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getTypetaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ExpressService.prototype.setTypetaskid = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string creationDate = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getCreationdate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setCreationdate = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional int32 statusId = 5;
 * @return {number}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getStatusid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ExpressService.prototype.setStatusid = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string statusName = 6;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getStatusname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setStatusname = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string sourceAddress = 7;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getSourceaddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setSourceaddress = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string destinationAddress = 8;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getDestinationaddress = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setDestinationaddress = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string clientName = 9;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getClientname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setClientname = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional double totalValue = 10;
 * @return {number}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getTotalvalue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ExpressService.prototype.setTotalvalue = function (value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};

/**
 * optional int32 paymentMethod = 11;
 * @return {number}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getPaymentmethod = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.ExpressService.prototype.setPaymentmethod = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional string paymentMethodName = 12;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getPaymentmethodname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setPaymentmethodname = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string city = 13;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getCity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setCity = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string franchise = 14;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getFranchise = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setFranchise = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string lastDigitsCard = 15;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getLastdigitscard = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setLastdigitscard = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string destinationCity = 16;
 * @return {string}
 */
proto.com.mu.logistic.api.ExpressService.prototype.getDestinationcity = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.ExpressService.prototype.setDestinationcity = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PaginationDeliveryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PaginationDeliveryRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PaginationDeliveryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PaginationDeliveryRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        page: jspb.Message.getFieldWithDefault(msg, 1, 0),
        limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PaginationDeliveryRequest}
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PaginationDeliveryRequest();
  return proto.com.mu.logistic.api.PaginationDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PaginationDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PaginationDeliveryRequest}
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPage(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setLimit(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PaginationDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PaginationDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest.prototype.getPage = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PaginationDeliveryRequest.prototype.setPage = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.PaginationDeliveryRequest.prototype.getLimit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PaginationDeliveryRequest.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.PaginationDeliveryResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.PaginationDeliveryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.PaginationDeliveryResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        page: jspb.Message.getFieldWithDefault(msg, 1, 0),
        limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
        totalpages: jspb.Message.getFieldWithDefault(msg, 3, 0),
        totalrows: jspb.Message.getFieldWithDefault(msg, 4, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.PaginationDeliveryResponse}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.PaginationDeliveryResponse();
  return proto.com.mu.logistic.api.PaginationDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.PaginationDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.PaginationDeliveryResponse}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPage(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setLimit(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalpages(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalrows(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.PaginationDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.PaginationDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getTotalpages();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getTotalrows();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
};

/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.getPage = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.setPage = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.getLimit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional int32 totalPages = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.getTotalpages = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.setTotalpages = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional int32 totalRows = 4;
 * @return {number}
 */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.getTotalrows = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.PaginationDeliveryResponse.prototype.setTotalrows = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetExpressServicesRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetExpressServicesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetExpressServicesRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        filter: (f = msg.getFilter()) && proto.com.mu.logistic.api.FilterExpressList.toObject(includeInstance, f),
        pagination: (f = msg.getPagination()) && proto.com.mu.logistic.api.PaginationDeliveryRequest.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetExpressServicesRequest}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetExpressServicesRequest();
  return proto.com.mu.logistic.api.GetExpressServicesRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetExpressServicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetExpressServicesRequest}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.FilterExpressList();
        reader.readMessage(value, proto.com.mu.logistic.api.FilterExpressList.deserializeBinaryFromReader);
        msg.setFilter(value);
        break;
      case 3:
        var value = new proto.com.mu.logistic.api.PaginationDeliveryRequest();
        reader.readMessage(value, proto.com.mu.logistic.api.PaginationDeliveryRequest.deserializeBinaryFromReader);
        msg.setPagination(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetExpressServicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetExpressServicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.FilterExpressList.serializeBinaryToWriter);
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(3, f, proto.com.mu.logistic.api.PaginationDeliveryRequest.serializeBinaryToWriter);
  }
};

/**
 * optional int32 userId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional FilterExpressList filter = 2;
 * @return {?proto.com.mu.logistic.api.FilterExpressList}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.getFilter = function () {
  return /** @type{?proto.com.mu.logistic.api.FilterExpressList} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.FilterExpressList, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.FilterExpressList|undefined} value */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.setFilter = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.clearFilter = function () {
  this.setFilter(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.hasFilter = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional PaginationDeliveryRequest pagination = 3;
 * @return {?proto.com.mu.logistic.api.PaginationDeliveryRequest}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.getPagination = function () {
  return /** @type{?proto.com.mu.logistic.api.PaginationDeliveryRequest} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.PaginationDeliveryRequest, 3)
  );
};

/** @param {?proto.com.mu.logistic.api.PaginationDeliveryRequest|undefined} value */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.setPagination = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.clearPagination = function () {
  this.setPagination(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetExpressServicesRequest.prototype.hasPagination = function () {
  return jspb.Message.getField(this, 3) != null;
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetExpressServicesResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetExpressServicesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetExpressServicesResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        servicesList: jspb.Message.toObjectList(msg.getServicesList(), proto.com.mu.logistic.api.ExpressService.toObject, includeInstance),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
        pagination: (f = msg.getPagination()) && proto.com.mu.logistic.api.PaginationDeliveryResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetExpressServicesResponse}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetExpressServicesResponse();
  return proto.com.mu.logistic.api.GetExpressServicesResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetExpressServicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetExpressServicesResponse}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.ExpressService();
        reader.readMessage(value, proto.com.mu.logistic.api.ExpressService.deserializeBinaryFromReader);
        msg.addServices(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      case 3:
        var value = new proto.com.mu.logistic.api.PaginationDeliveryResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.PaginationDeliveryResponse.deserializeBinaryFromReader);
        msg.setPagination(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetExpressServicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetExpressServicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.ExpressService.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(3, f, proto.com.mu.logistic.api.PaginationDeliveryResponse.serializeBinaryToWriter);
  }
};

/**
 * repeated ExpressService services = 1;
 * @return {!Array<!proto.com.mu.logistic.api.ExpressService>}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.getServicesList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.ExpressService>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.ExpressService, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.ExpressService>} value */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.setServicesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.ExpressService=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.ExpressService}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.addServices = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.ExpressService, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.clearServicesList = function () {
  this.setServicesList([]);
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional PaginationDeliveryResponse pagination = 3;
 * @return {?proto.com.mu.logistic.api.PaginationDeliveryResponse}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.getPagination = function () {
  return /** @type{?proto.com.mu.logistic.api.PaginationDeliveryResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.PaginationDeliveryResponse, 3)
  );
};

/** @param {?proto.com.mu.logistic.api.PaginationDeliveryResponse|undefined} value */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.setPagination = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.clearPagination = function () {
  this.setPagination(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetExpressServicesResponse.prototype.hasPagination = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
        servicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
        ordertype: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest();
  return proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCompanyid(value);
        break;
      case 2:
        var value = /** @type {!proto.com.mu.logistic.api.ServiceTypeEnum} */ (reader.readEnum());
        msg.setServicetype(value);
        break;
      case 3:
        var value = /** @type {!proto.com.mu.logistic.api.OrderTypeEnum} */ (reader.readEnum());
        msg.setOrdertype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getServicetype();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getOrdertype();
  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }
};

/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.getCompanyid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.setCompanyid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional ServiceTypeEnum serviceType = 2;
 * @return {!proto.com.mu.logistic.api.ServiceTypeEnum}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.getServicetype = function () {
  return /** @type {!proto.com.mu.logistic.api.ServiceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {!proto.com.mu.logistic.api.ServiceTypeEnum} value */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.setServicetype = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * optional OrderTypeEnum orderType = 3;
 * @return {!proto.com.mu.logistic.api.OrderTypeEnum}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.getOrdertype = function () {
  return /** @type {!proto.com.mu.logistic.api.OrderTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {!proto.com.mu.logistic.api.OrderTypeEnum} value */
proto.com.mu.logistic.api.GetDefaultDeclaredValueRequest.prototype.setOrdertype = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse();
  return proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setValue(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * optional double value = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.getValue = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.setValue = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetDefaultDeclaredValueResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.StatusInfoResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.StatusInfoResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.StatusInfoResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.StatusInfoResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        status: jspb.Message.getFieldWithDefault(msg, 1, 0),
        errorcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
        message: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.StatusInfoResponse();
  return proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.StatusInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!proto.com.mu.logistic.api.StatusInfoResponse.StatusType} */ (reader.readEnum());
        msg.setStatus(value);
        break;
      case 2:
        var value = /** @type {!proto.com.mu.logistic.api.StatusInfoResponse.ErrorCode} */ (reader.readEnum());
        msg.setErrorcode(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setMessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.StatusInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }
  f = message.getErrorcode();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.StatusInfoResponse.StatusType = {
  UNKNOWN_STATUS_TYPE: 0,
  SUCCESS: 1,
  ERROR: 2,
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.StatusInfoResponse.ErrorCode = {
  UNKNOWN_ERROR_CODE_TYPE: 0,
  OK: 1,
  GENERAL_ERROR: 2,
  NOT_FOUND: 3,
  INVALID_DACLARED_VALUE: 4,
  INVALID_ADRESS: 5,
  SERVICE_EXCEED_LIMITED_DISTANCE: 6,
  IS_NOT_PRINCIPAL_CITY: 7,
  SERVICE_BYCASH_NEGATIVE_BALANCE: 8,
  CREDIT_CARD_TRANSACTION_ERROR: 9,
  ADDRESS_NOT_INSIDE_POLYGON: 10,
};

/**
 * optional StatusType status = 1;
 * @return {!proto.com.mu.logistic.api.StatusInfoResponse.StatusType}
 */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.getStatus = function () {
  return /** @type {!proto.com.mu.logistic.api.StatusInfoResponse.StatusType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {!proto.com.mu.logistic.api.StatusInfoResponse.StatusType} value */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};

/**
 * optional ErrorCode errorCode = 2;
 * @return {!proto.com.mu.logistic.api.StatusInfoResponse.ErrorCode}
 */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.getErrorcode = function () {
  return /** @type {!proto.com.mu.logistic.api.StatusInfoResponse.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/** @param {!proto.com.mu.logistic.api.StatusInfoResponse.ErrorCode} value */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.setErrorcode = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * optional string message = 3;
 * @return {string}
 */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.getMessage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.StatusInfoResponse.prototype.setMessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCancellationTypesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCancellationTypesRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCancellationTypesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCancellationTypesRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        servicetype: jspb.Message.getFieldWithDefault(msg, 1, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCancellationTypesRequest}
 */
proto.com.mu.logistic.api.GetCancellationTypesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCancellationTypesRequest();
  return proto.com.mu.logistic.api.GetCancellationTypesRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCancellationTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCancellationTypesRequest}
 */
proto.com.mu.logistic.api.GetCancellationTypesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setServicetype(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCancellationTypesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCancellationTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCancellationTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCancellationTypesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getServicetype();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};

/**
 * optional int32 serviceType = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCancellationTypesRequest.prototype.getServicetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCancellationTypesRequest.prototype.setServicetype = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.CancellationReason.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.CancellationReason.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.CancellationReason} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.CancellationReason.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        name: jspb.Message.getFieldWithDefault(msg, 2, ''),
        idrelations: jspb.Message.getFieldWithDefault(msg, 3, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.CancellationReason}
 */
proto.com.mu.logistic.api.CancellationReason.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.CancellationReason();
  return proto.com.mu.logistic.api.CancellationReason.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.CancellationReason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.CancellationReason}
 */
proto.com.mu.logistic.api.CancellationReason.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setIdrelations(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.CancellationReason.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.CancellationReason.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.CancellationReason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.CancellationReason.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getIdrelations();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.CancellationReason.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancellationReason.prototype.setId = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.CancellationReason.prototype.getName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.CancellationReason.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 idRelations = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.CancellationReason.prototype.getIdrelations = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.CancellationReason.prototype.setIdrelations = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCancellationTypesResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCancellationTypesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCancellationTypesResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        cancellationreasonsList: jspb.Message.toObjectList(
          msg.getCancellationreasonsList(),
          proto.com.mu.logistic.api.CancellationReason.toObject,
          includeInstance
        ),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCancellationTypesResponse}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCancellationTypesResponse();
  return proto.com.mu.logistic.api.GetCancellationTypesResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCancellationTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCancellationTypesResponse}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.com.mu.logistic.api.CancellationReason();
        reader.readMessage(value, proto.com.mu.logistic.api.CancellationReason.deserializeBinaryFromReader);
        msg.addCancellationreasons(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCancellationTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCancellationTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCancellationreasonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.com.mu.logistic.api.CancellationReason.serializeBinaryToWriter);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * repeated CancellationReason cancellationReasons = 1;
 * @return {!Array<!proto.com.mu.logistic.api.CancellationReason>}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.getCancellationreasonsList = function () {
  return /** @type{!Array<!proto.com.mu.logistic.api.CancellationReason>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.logistic.api.CancellationReason, 1)
  );
};

/** @param {!Array<!proto.com.mu.logistic.api.CancellationReason>} value */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.setCancellationreasonsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.com.mu.logistic.api.CancellationReason=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.logistic.api.CancellationReason}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.addCancellationreasons = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.logistic.api.CancellationReason, opt_index);
};

/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.clearCancellationreasonsList = function () {
  this.setCancellationreasonsList([]);
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCancellationTypesResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCancellationRateRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCancellationRateRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCancellationRateRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCancellationRateRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        taskid: jspb.Message.getFieldWithDefault(msg, 1, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCancellationRateRequest}
 */
proto.com.mu.logistic.api.GetCancellationRateRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCancellationRateRequest();
  return proto.com.mu.logistic.api.GetCancellationRateRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCancellationRateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCancellationRateRequest}
 */
proto.com.mu.logistic.api.GetCancellationRateRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTaskid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCancellationRateRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCancellationRateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCancellationRateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCancellationRateRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};

/**
 * optional int32 taskId = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCancellationRateRequest.prototype.getTaskid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCancellationRateRequest.prototype.setTaskid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetCancellationRateResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetCancellationRateResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetCancellationRateResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        cancellationrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
        status: (f = msg.getStatus()) && proto.com.mu.logistic.api.StatusInfoResponse.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetCancellationRateResponse}
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetCancellationRateResponse();
  return proto.com.mu.logistic.api.GetCancellationRateResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetCancellationRateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetCancellationRateResponse}
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setCancellationrate(value);
        break;
      case 2:
        var value = new proto.com.mu.logistic.api.StatusInfoResponse();
        reader.readMessage(value, proto.com.mu.logistic.api.StatusInfoResponse.deserializeBinaryFromReader);
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetCancellationRateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetCancellationRateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCancellationrate();
  if (f !== 0.0) {
    writer.writeDouble(1, f);
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(2, f, proto.com.mu.logistic.api.StatusInfoResponse.serializeBinaryToWriter);
  }
};

/**
 * optional double cancellationRate = 1;
 * @return {number}
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.getCancellationrate = function () {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};

/** @param {number} value */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.setCancellationrate = function (value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};

/**
 * optional StatusInfoResponse status = 2;
 * @return {?proto.com.mu.logistic.api.StatusInfoResponse}
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.getStatus = function () {
  return /** @type{?proto.com.mu.logistic.api.StatusInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.logistic.api.StatusInfoResponse, 2)
  );
};

/** @param {?proto.com.mu.logistic.api.StatusInfoResponse|undefined} value */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.setStatus = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.clearStatus = function () {
  this.setStatus(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.logistic.api.GetCancellationRateResponse.prototype.hasStatus = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        uuid: jspb.Message.getFieldWithDefault(msg, 1, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest();
  return proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setUuid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.prototype.getUuid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.GetDeliveryDetailByUUIDRequest.prototype.setUuid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        businessentityid: jspb.Message.getFieldWithDefault(msg, 1, ''),
        logdetail: jspb.Message.getFieldWithDefault(msg, 2, ''),
        userid: jspb.Message.getFieldWithDefault(msg, 3, 0),
        username: jspb.Message.getFieldWithDefault(msg, 4, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest();
  return proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setBusinessentityid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setLogdetail(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUserid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setUsername(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBusinessentityid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getLogdetail();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
};

/**
 * optional string businessEntityId = 1;
 * @return {string}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.getBusinessentityid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.setBusinessentityid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string logDetail = 2;
 * @return {string}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.getLogdetail = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.setLogdetail = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 userId = 3;
 * @return {number}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/** @param {number} value */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.setUserid = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string userName = 4;
 * @return {string}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.getUsername = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/** @param {string} value */
proto.com.mu.logistic.api.SetDeliveryLogArmireneRequest.prototype.setUsername = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        saved: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse();
  return proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setSaved(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSaved();
  if (f) {
    writer.writeBool(1, f);
  }
};

/**
 * optional bool saved = 1;
 * @return {boolean}
 */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.prototype.getSaved = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};

/** @param {boolean} value */
proto.com.mu.logistic.api.SetDeliveryLogArmireneResponse.prototype.setSaved = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.GetAddressResultType = {
  ADDRESS_NOT_FOUND: 0,
  ADDRESS_FOUND: 1,
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.SegmentationType = {
  UNKNOWN_SEGMENTATION_TYPE: 0,
  EMPTY: 1,
  GRILL: 2,
  TRUNK: 3,
  BAG: 4,
  DRAWER: 5,
  LUNCH_BOX: 13,
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.PaymentType = {
  UNKNOWN_PAYMENTMETHOD_TYPE: 0,
  CASH: 1,
  CREDIT_CARD: 8,
  PREPAID: 2,
  POSTPAID: 3,
  CXC: 4,
  ONLINE: 5,
  ACCOUNT: 6,
  ADMINISTRATIVE: 7,
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.ServiceTypeEnum = {
  UNKNOWN_SERVICE_TYPE: 0,
  SERVICE_EXPRESS: 1,
  SERVICE_ESTANDAR: 2,
  SERVICE_DILIGENCIA: 3,
  SERVICE_DOMICILIOS: 4,
  SERVICE_ECOMMERCE: 5,
  SERVICE_ECOMMERCE_RUTA: 6,
  SERVICE_RECAUDO: 7,
  SERVICE_MASIVO: 8,
};

/**
 * @enum {number}
 */
proto.com.mu.logistic.api.OrderTypeEnum = {
  UNKNOWN_ORDER_TYPE: 0,
  ORDER_VENTA_DOMICILIO: 1,
  ORDER_VENTA_FARMACIA: 2,
  ORDER_VENTA_CALLCENTER: 3,
  ORDER_RECETA_MEDICA: 4,
  ORDER_VENTA_ECOMMERCE: 5,
  ORDER_TRASLADO_VENTA_DOMICILIO: 6,
  ORDER_TRASLADO_VENTA_FARMACIA: 7,
  ORDER_TRASLADO_DISPENSACION: 8,
  ORDER_CONVENIO: 9,
  ORDER_CAMBIO_PRODUCTO: 10,
  ORDER_ENVIO_DISPENSACION: 11,
};

goog.object.extend(exports, proto.com.mu.logistic.api);
